/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

type UtilRequiredKeys<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

/** WorkOrderStatus */
export enum WorkOrderStatus {
  Closed = 'closed',
  Pending = 'pending',
  InProgress = 'inProgress',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

/** WebsiteTheme */
export enum WebsiteTheme {
  Default = 'default',
  Blue = 'blue',
  Orange = 'orange',
  Green = 'green',
  Purple = 'purple',
  Black = 'black',
}

/** WalletType */
export enum WalletType {
  CashApp = 'cashApp',
  GooglePay = 'googlePay',
  ApplePay = 'applePay',
  SamsungPay = 'samsungPay',
}

/** VersionStatus */
export enum VersionStatus {
  Ok = 'ok',
  Maintenance = 'maintenance',
  Upgrade = 'upgrade',
}

/** VendorType */
export enum VendorType {
  Hoa = 'hoa',
  PropertyManager = 'propertyManager',
  Other = 'other',
}

/** VendorBillStatus */
export enum VendorBillStatus {
  Draft = 'draft',
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  Withdrawn = 'withdrawn',
}

/** VendorBillSourceType */
export enum VendorBillSourceType {
  WorkOrder = 'workOrder',
}

/** Urgency */
export enum Urgency {
  Urgent = 'urgent',
  High = 'high',
  Medium = 'medium',
  Low = 'low',
  None = 'none',
}

/** UnitListingStatus */
export enum UnitListingStatus {
  Pending = 'pending',
  Available = 'available',
  Reserved = 'reserved',
  Leased = 'leased',
  Occupied = 'occupied',
  UnderMaintenance = 'underMaintenance',
  Sold = 'sold',
  Other = 'other',
}

/** TwoFactorState */
export enum TwoFactorState {
  SelectMethod = 'selectMethod',
  CodeSent = 'codeSent',
}

/** TwoFactorMethodType */
export enum TwoFactorMethodType {
  Email = 'email',
  Phone = 'phone',
}

/** TransactionType */
export enum TransactionType {
  Payment = 'payment',
  Return = 'return',
  Refund = 'refund',
  Dispute = 'dispute',
  Credit = 'credit',
  Transfer = 'transfer',
}

/** TransactionStatus */
export enum TransactionStatus {
  Pending = 'pending',
  Failed = 'failed',
  Success = 'success',
  Cancelled = 'cancelled',
  Returned = 'returned',
  Refunded = 'refunded',
  Disputing = 'disputing',
  Disputed = 'disputed',
}

/** TransactionPaymentMethod */
export enum TransactionPaymentMethod {
  Ach = 'ach',
  DebitCard = 'debitCard',
  Wallet = 'wallet',
  CreditCard = 'creditCard',
  Check = 'check',
  CashiersCheck = 'cashiersCheck',
  MoneyOrder = 'moneyOrder',
  Cash = 'cash',
  Zelle = 'zelle',
  Other = 'other',
  Credit = 'credit',
  Transfer = 'transfer',
}

/** TransactionIdentity */
export enum TransactionIdentity {
  LeaseCharge = 'leaseCharge',
  LeaseDeposit = 'leaseDeposit',
  LeaseProcessingFee = 'leaseProcessingFee',
  RentalApplicationFee = 'rentalApplicationFee',
  PropertyCharge = 'propertyCharge',
  OwnerContribution = 'ownerContribution',
  OwnerDistribution = 'ownerDistribution',
  ManagementFee = 'managementFee',
  ServiceBill = 'serviceBill',
  VendorBill = 'vendorBill',
  CompanyDisbursement = 'companyDisbursement',
  MagicDoorBill = 'magicDoorBill',
  BankLedgerTransfer = 'bankLedgerTransfer',
}

/** TransactionFailure */
export enum TransactionFailure {
  NoSufficientFunds = 'noSufficientFunds',
  Unknown = 'unknown',
  TransferLimitReached = 'transferLimitReached',
  PaymentProcessorDeclined = 'paymentProcessorDeclined',
  CardLost = 'cardLost',
  StolenCard = 'stolenCard',
  ExpiredCard = 'expiredCard',
  PaymentAccountSetupError = 'paymentAccountSetupError',
  CompanyAccountSetupError = 'companyAccountSetupError',
}

/** TransactionDirection */
export enum TransactionDirection {
  In = 'in',
  Out = 'out',
}

/** TimePeriod */
export enum TimePeriod {
  Days = 'days',
  Months = 'months',
  Years = 'years',
}

/** TextStatus */
export enum TextStatus {
  NotSent = 'notSent',
  Disabled = 'disabled',
  NoRecipients = 'noRecipients',
  Sent = 'sent',
  Delivered = 'delivered',
  Failed = 'failed',
}

/** TenantAutoPayType */
export enum TenantAutoPayType {
  FixedAmount = 'fixedAmount',
  PostedBalance = 'postedBalance',
  CurrentBalance = 'currentBalance',
}

/** TemplateRefKind */
export enum TemplateRefKind {
  Pdf = 'pdf',
  Docx = 'docx',
  File = 'file',
}

/** TaxType */
export enum TaxType {
  Misc = 'misc',
  Nec = 'nec',
}

/** TaxDocumentAnnotationType */
export enum TaxDocumentAnnotationType {
  Text = 'text',
  Currency = 'currency',
}

/** TaxDocumentAccountType */
export enum TaxDocumentAccountType {
  Vendor = 'vendor',
  Owner = 'owner',
}

/** TargetType */
export enum TargetType {
  Lease = 'lease',
  Tenant = 'tenant',
  Owner = 'owner',
  Vendor = 'vendor',
}

/** SyndicationStatus */
export enum SyndicationStatus {
  NotStarted = 'notStarted',
  NotPostedAndBlocked = 'notPostedAndBlocked',
  NotPostedAndInvalidData = 'notPostedAndInvalidData',
  NotPostedAndUnpaidNotAllowed = 'notPostedAndUnpaidNotAllowed',
  NotPostedAndRestrictedArea = 'notPostedAndRestrictedArea',
  NotPostedAndDuplicate = 'notPostedAndDuplicate',
  Posted = 'posted',
  Unknown = 'unknown',
}

/** SubsidyType */
export enum SubsidyType {
  Section8 = 'section8',
  Vash = 'vash',
  Ehv = 'ehv',
  Fup = 'fup',
  ProjectBased = 'projectBased',
  Other = 'other',
}

/** SubsidizerType */
export enum SubsidizerType {
  Government = 'government',
  NonProfit = 'nonProfit',
  Private = 'private',
  Other = 'other',
}

/** SubsidizerPaymentMethod */
export enum SubsidizerPaymentMethod {
  Ach = 'ach',
  DebitCard = 'debitCard',
  Wallet = 'wallet',
  CreditCard = 'creditCard',
  Check = 'check',
  CashiersCheck = 'cashiersCheck',
  MoneyOrder = 'moneyOrder',
  Cash = 'cash',
  Other = 'other',
}

/** StripeType */
export enum StripeType {
  Unknown = 'unknown',
  Card = 'card',
  BankAccount = 'bankAccount',
  Wallet = 'wallet',
}

/** StatusType */
export enum StatusType {
  Draft = 'draft',
  Sent = 'sent',
  Viewed = 'viewed',
  Signed = 'signed',
}

/** StartOutgoingAchFailure */
export enum StartOutgoingAchFailure {
  CompanyAccountSetupError = 'companyAccountSetupError',
  CompanyDisabledPayout = 'companyDisabledPayout',
  PaymentAccountNotMapped = 'paymentAccountNotMapped',
  PaymentAccountNotActive = 'paymentAccountNotActive',
  TransferLimitReached = 'transferLimitReached',
  StartPaymentFailed = 'startPaymentFailed',
  PaymentNotAuthorized = 'paymentNotAuthorized',
  Unknown = 'unknown',
}

/** StandardizedImportDataPropertyType */
export enum StandardizedImportDataPropertyType {
  SingleFamily = 'singleFamily',
  MultiFamily = 'multiFamily',
  Commercial = 'commercial',
  Condo = 'condo',
  TownHome = 'townHome',
  Other = 'other',
}

/** StandardizedImportDataGender */
export enum StandardizedImportDataGender {
  Male = 'male',
  Female = 'female',
  Other = 'other',
  PreferNotToSay = 'preferNotToSay',
}

/** RentStatus */
export enum RentStatus {
  Rented = 'rented',
  UnRented = 'unRented',
}

/** PropertyType */
export enum PropertyType {
  SingleFamily = 'singleFamily',
  MultiFamily = 'multiFamily',
  Commercial = 'commercial',
  Condo = 'condo',
  TownHome = 'townHome',
  Other = 'other',
}

/** ProcessStatus */
export enum ProcessStatus {
  NotStarted = 'notStarted',
  InProgress = 'inProgress',
  Completed = 'completed',
  Failed = 'failed',
  NotFound = 'notFound',
}

/** PortalStatus */
export enum PortalStatus {
  NotInvited = 'notInvited',
  Invited = 'invited',
  Active = 'active',
}

/** PolicyHandbookLevel */
export enum PolicyHandbookLevel {
  Global = 'global',
  Portfolio = 'portfolio',
  Property = 'property',
  Unit = 'unit',
  Lease = 'lease',
}

/** Platform */
export enum Platform {
  Android = 'android',
  IOS = 'iOS',
  Web = 'web',
}

/** PlaidSweepType */
export enum PlaidSweepType {
  Deposit = 'deposit',
  Withdraw = 'withdraw',
}

/** PlaidSweepStatus */
export enum PlaidSweepStatus {
  Pending = 'pending',
  Posted = 'posted',
  Settled = 'settled',
  FundsAvailable = 'fundsAvailable',
  Returned = 'returned',
  Failed = 'failed',
}

/** PetSize */
export enum PetSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

/** PayoutStatus */
export enum PayoutStatus {
  Succeeded = 'succeeded',
  Failed = 'failed',
}

/** PayoutMethod */
export enum PayoutMethod {
  PrintCheck = 'printCheck',
  Manual = 'manual',
  Ach = 'ach',
}

/** PayoutFailure */
export enum PayoutFailure {
  InitiateFailed = 'initiateFailed',
  NotAccepted = 'notAccepted',
  Unknown = 'unknown',
}

/** PaymentChannel */
export enum PaymentChannel {
  Ach = 'ach',
  Card = 'card',
}

/** PaymentAccountProvider */
export enum PaymentAccountProvider {
  Plaid = 'plaid',
  Stripe = 'stripe',
  Zelle = 'zelle',
  None = 'none',
}

/** OwnerContributionRequestStatus */
export enum OwnerContributionRequestStatus {
  Requested = 'requested',
  Pending = 'pending',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

/** OfflineTransactionPaymentMethod */
export enum OfflineTransactionPaymentMethod {
  Check = 'check',
  CashiersCheck = 'cashiersCheck',
  MoneyOrder = 'moneyOrder',
  Cash = 'cash',
  Other = 'other',
}

/** NotificationStatus */
export enum NotificationStatus {
  Pending = 'pending',
  Sent = 'sent',
  Skipped = 'skipped',
  Failed = 'failed',
}

/** NotificationSource */
export enum NotificationSource {
  System = 'system',
  Manual = 'manual',
}

/** NoteType */
export enum NoteType {
  Note = 'note',
  Delinquency = 'delinquency',
}

/** MessageType */
export enum MessageType {
  Participant = 'participant',
  PropertyManager = 'propertyManager',
  Bot = 'bot',
  Announcement = 'announcement',
}

/** MessageSource */
export enum MessageSource {
  App = 'app',
  Email = 'email',
  Text = 'text',
  System = 'system',
  Notification = 'notification',
}

/** MeetingScheduleStatus */
export enum MeetingScheduleStatus {
  Active = 'active',
  Ended = 'ended',
  Cancelled = 'cancelled',
}

/** MeetingScheduleSource */
export enum MeetingScheduleSource {
  Manual = 'manual',
  External = 'external',
}

/** ManagementFeeType */
export enum ManagementFeeType {
  Fixed = 'fixed',
  Percentage = 'percentage',
}

/** ManagementFeeDate */
export enum ManagementFeeDate {
  EndOfLastMonth = 'endOfLastMonth',
  Now = 'now',
}

/** ManagementFeeCalculationType */
export enum ManagementFeeCalculationType {
  Fixed = 'fixed',
  Percentage = 'percentage',
}

/** MaintenanceRequestStatus */
export enum MaintenanceRequestStatus {
  Closed = 'closed',
  Pending = 'pending',
  InProgress = 'inProgress',
  AiProcessing = 'aiProcessing',
  WaitingForWorkOrder = 'waitingForWorkOrder',
}

/** MagicUserType */
export enum MagicUserType {
  System = 'system',
  MagicDoor = 'magicDoor',
  PropertyManager = 'propertyManager',
  Tenant = 'tenant',
  Vendor = 'vendor',
  Owner = 'owner',
}

/** MagicDoorFeature */
export enum MagicDoorFeature {
  Ai = 'ai',
  CompanyLedger = 'companyLedger',
  TenantACHNumberLinking = 'tenantACHNumberLinking',
  CentralizedPayments = 'centralizedPayments',
}

/** LogicalOperator */
export enum LogicalOperator {
  And = 'and',
  Or = 'or',
}

/** LevelSearch */
export enum LevelSearch {
  Portfolio = 'portfolio',
  Property = 'property',
  Unit = 'unit',
  Lease = 'lease',
}

/** LeaseTerm */
export enum LeaseTerm {
  MonthToMonth = 'monthToMonth',
  HalfYear = 'halfYear',
  OneYear = 'oneYear',
  TwoYears = 'twoYears',
  ThreeYears = 'threeYears',
  Other = 'other',
}

/** LeaseTemplateType */
export enum LeaseTemplateType {
  Lease = 'lease',
  LeaseRenewal = 'leaseRenewal',
  LateRentNotice = 'lateRentNotice',
  Eviction = 'eviction',
  SignatureOnly = 'signatureOnly',
  Information = 'information',
}

/** LeaseStatus */
export enum LeaseStatus {
  Lease = 'lease',
  LeaseMonthToMonth = 'leaseMonthToMonth',
  MonthToMonth = 'monthToMonth',
  Eviction = 'eviction',
  Expired = 'expired',
  Draft = 'draft',
  Ended = 'ended',
  Future = 'future',
}

/** LeaseRenewalStatus */
export enum LeaseRenewalStatus {
  Offered = 'offered',
  Signing = 'signing',
  Finalized = 'finalized',
  Rejected = 'rejected',
  Retracted = 'retracted',
}

/** LeaseRecurringPaymentStatus */
export enum LeaseRecurringPaymentStatus {
  Active = 'active',
  Ended = 'ended',
  DueSoon = 'dueSoon',
}

/** LeaseRecurringPaymentMethod */
export enum LeaseRecurringPaymentMethod {
  Ach = 'ach',
  DebitCard = 'debitCard',
  Wallet = 'wallet',
  CreditCard = 'creditCard',
  Check = 'check',
  CashiersCheck = 'cashiersCheck',
  MoneyOrder = 'moneyOrder',
  Cash = 'cash',
  Other = 'other',
}

/** LeaseRecurringCreditStatus */
export enum LeaseRecurringCreditStatus {
  Active = 'active',
  Ended = 'ended',
  DueSoon = 'dueSoon',
}

/** LeaseRecurringChargeStatus */
export enum LeaseRecurringChargeStatus {
  Active = 'active',
  Ended = 'ended',
  DueSoon = 'dueSoon',
}

/** LeaseMoveOutRequestStatus */
export enum LeaseMoveOutRequestStatus {
  Requested = 'requested',
  Rejected = 'rejected',
  Approved = 'approved',
  Retracted = 'retracted',
}

/** LeaseFromType */
export enum LeaseFromType {
  RentalApplication = 'rentalApplication',
}

/** LeaseDocumentType */
export enum LeaseDocumentType {
  Lease = 'lease',
  LeaseRenewal = 'leaseRenewal',
}

/** LeaseDocumentStatus */
export enum LeaseDocumentStatus {
  Draft = 'draft',
  PendingSignatures = 'pendingSignatures',
  Completed = 'completed',
  Retracted = 'retracted',
}

/** LeaseDocumentSignerType */
export enum LeaseDocumentSignerType {
  PropertyManager = 'propertyManager',
  Tenant = 'tenant',
}

/** LeaseDocumentAnnotationType */
export enum LeaseDocumentAnnotationType {
  Text = 'text',
  Initials = 'initials',
  Signature = 'signature',
  DateOnly = 'dateOnly',
  DateTime = 'dateTime',
  Bool = 'bool',
  Flag = 'flag',
  Currency = 'currency',
  Autofill = 'autofill',
  FullName = 'fullName',
  Created = 'created',
  SignerText = 'signerText',
}

/** LeaseDepositTransactionStatus */
export enum LeaseDepositTransactionStatus {
  Future = 'future',
  Due = 'due',
  PastDue = 'pastDue',
  Paid = 'paid',
  Failed = 'failed',
  Returned = 'returned',
  Processing = 'processing',
  Settled = 'settled',
  Disputing = 'disputing',
}

/** LeaseDepositLedgerEntryType */
export enum LeaseDepositLedgerEntryType {
  Payment = 'payment',
  Deposit = 'deposit',
  Return = 'return',
  Transfer = 'transfer',
  Payout = 'payout',
}

/** LeaseChargeLedgerEntryType */
export enum LeaseChargeLedgerEntryType {
  Payment = 'payment',
  Charge = 'charge',
  LateFee = 'lateFee',
  Credit = 'credit',
  Return = 'return',
  Transfer = 'transfer',
  Payout = 'payout',
}

/** LeaseChargeLedgerEntryStatus */
export enum LeaseChargeLedgerEntryStatus {
  Future = 'future',
  Due = 'due',
  PastDue = 'pastDue',
  Paid = 'paid',
  Failed = 'failed',
  Returned = 'returned',
  Processing = 'processing',
  Settled = 'settled',
  Disputing = 'disputing',
}

/** LateFeesReportChargeSource */
export enum LateFeesReportChargeSource {
  System = 'system',
  Manual = 'manual',
}

/** IrisSubmissionFilingType */
export enum IrisSubmissionFilingType {
  Original = 'original',
  Correction = 'correction',
  Void = 'void',
}

/** IdentificationType */
export enum IdentificationType {
  Ssn = 'ssn',
  Ein = 'ein',
}

/** Gender */
export enum Gender {
  Male = 'male',
  Female = 'female',
  Other = 'other',
  PreferNotToSay = 'preferNotToSay',
}

/** FlyerTemplate */
export enum FlyerTemplate {
  QrCode = 'qrCode',
  TenantNotice = 'tenantNotice',
  Welcome = 'welcome',
}

/** ExternalTransactionType */
export enum ExternalTransactionType {
  Plaid = 'plaid',
  Stripe = 'stripe',
  Zelle = 'zelle',
  Offline = 'offline',
  MagicDoor = 'magicDoor',
}

/** ExpiringStatus */
export enum ExpiringStatus {
  None = 'none',
  Soon = 'soon',
  Imminent = 'imminent',
  Immediate = 'immediate',
}

/** EntityType */
export enum EntityType {
  Lease = 'lease',
  Unit = 'unit',
  Property = 'property',
  Portfolio = 'portfolio',
  Company = 'company',
  Tenant = 'tenant',
  Vendor = 'vendor',
  MaintenanceRequest = 'maintenanceRequest',
  WorkOrder = 'workOrder',
  Bill = 'bill',
  Transaction = 'transaction',
  Chat = 'chat',
  ChatMessage = 'chatMessage',
  PropertyManager = 'propertyManager',
  Unknown = 'unknown',
  RentalApplication = 'rentalApplication',
  LeaseTemplate = 'leaseTemplate',
  LeaseDocument = 'leaseDocument',
  AssociationViolation = 'associationViolation',
  Owner = 'owner',
  UnitListing = 'unitListing',
  File = 'file',
  WorkOrderGroup = 'workOrderGroup',
}

/** EmailTemplates */
export enum EmailTemplates {
  Empty = 'empty',
  CompanyGeneric = 'companyGeneric',
  MagicDoor = 'magicDoor',
}

/** EmailStatus */
export enum EmailStatus {
  NotSent = 'notSent',
  Disabled = 'disabled',
  NoRecipients = 'noRecipients',
  Sent = 'sent',
  Delivered = 'delivered',
  Bounce = 'bounce',
  Complaint = 'complaint',
  DeliveryDelay = 'deliveryDelay',
  Reject = 'reject',
  Failed = 'failed',
}

/** DestinationType */
export enum DestinationType {
  Email = 'email',
  Text = 'text',
}

/** DelinquentLeaseStatus */
export enum DelinquentLeaseStatus {
  Active = 'active',
  Notice = 'notice',
  MoveOut = 'moveOut',
  Eviction = 'eviction',
}

/** DataPathValueType */
export enum DataPathValueType {
  None = 'none',
  String = 'string',
  DateOnly = 'dateOnly',
  Currency = 'currency',
  Flag = 'flag',
}

/** CustomFieldComponentType */
export enum CustomFieldComponentType {
  Input = 'input',
  Textarea = 'textarea',
  Select = 'select',
  Number = 'number',
  Checkbox = 'checkbox',
  Date = 'date',
  DateTime = 'dateTime',
  File = 'file',
}

/** CreationSource */
export enum CreationSource {
  None = 'none',
  Direct = 'direct',
  Import = 'import',
  AutoPay = 'autoPay',
  Recurring = 'recurring',
  Public = 'public',
}

/** ConditionOperator */
export enum ConditionOperator {
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  Equal = 'equal',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  GreaterThan = 'greaterThan',
  NotEqual = 'notEqual',
}

/** CompanyChargeService */
export enum CompanyChargeService {
  AchReturnFee = 'achReturnFee',
  AchFailedProcessingFee = 'achFailedProcessingFee',
  AchTenantProcessingFee = 'achTenantProcessingFee',
  AchOutgoingProcessingFee = 'achOutgoingProcessingFee',
  TransunionScreening = 'transunionScreening',
  Subscription = 'subscription',
  TcrCampaign = 'tcrCampaign',
  DisputeProcessingFee = 'disputeProcessingFee',
  ZelleProcessingFee = 'zelleProcessingFee',
  AchOwnerContributionProcessingFee = 'achOwnerContributionProcessingFee',
  TextMessageFee = 'textMessageFee',
  PaymentFailureProcessingFee = 'paymentFailureProcessingFee',
  DamageWaiver = 'damageWaiver',
  ResidentBenefitPackage = 'residentBenefitPackage',
  Onboarding = 'onboarding',
  Support = 'support',
  Reimbursement = 'reimbursement',
  BankFeed = 'bankFeed',
}

/** CompanyBusinessMode */
export enum CompanyBusinessMode {
  PropertyManagement = 'propertyManagement',
  Hoa = 'hoa',
}

/** CheckIdentity */
export enum CheckIdentity {
  VendorBill = 'vendorBill',
  OwnerDistribution = 'ownerDistribution',
  CompanyPayout = 'companyPayout',
  LeaseBalanceRelease = 'leaseBalanceRelease',
}

/** ChatTypes */
export enum ChatTypes {
  Lease = 'lease',
  Tenant = 'tenant',
  Vendor = 'vendor',
  MaintenanceRequest = 'maintenanceRequest',
  WorkOrder = 'workOrder',
  WorkOrderGroup = 'workOrderGroup',
  Unknown = 'unknown',
  Owner = 'owner',
}

/** ChatTimelineItemKind */
export enum ChatTimelineItemKind {
  Message = 'message',
  Note = 'note',
  Action = 'action',
}

/** ChatParticipantType */
export enum ChatParticipantType {
  Tenant = 'tenant',
  Unknown = 'unknown',
  Vendor = 'vendor',
  PropertyManager = 'propertyManager',
  Company = 'company',
  Owner = 'owner',
}

/** ChatNoteKind */
export enum ChatNoteKind {
  Note = 'note',
  Action = 'action',
}

/** ChatNoteAuthor */
export enum ChatNoteAuthor {
  PropertyManager = 'propertyManager',
  Ai = 'ai',
  System = 'system',
}

/** ChatNoteAudience */
export enum ChatNoteAudience {
  PropertyManager = 'propertyManager',
  AiOnly = 'aiOnly',
}

/** ChartOfAccountType */
export enum ChartOfAccountType {
  Asset = 'asset',
  Equity = 'equity',
  Liability = 'liability',
  Revenue = 'revenue',
  Expense = 'expense',
  OtherRevenue = 'otherRevenue',
  OtherExpense = 'otherExpense',
}

/** ChargeFrequency */
export enum ChargeFrequency {
  Monthly = 'monthly',
  Weekly = 'weekly',
  Daily = 'daily',
  Monthly2XSplit = 'monthly2XSplit',
  Quarterly = 'quarterly',
  Yearly = 'yearly',
}

/** CashFlowGroupBy */
export enum CashFlowGroupBy {
  Total = 'total',
  Property = 'property',
  Portfolio = 'portfolio',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}

/** CardType */
export enum CardType {
  DebitCard = 'debitCard',
  CreditCard = 'creditCard',
}

/** CannotSendTextMessagesReason */
export enum CannotSendTextMessagesReason {
  HasNoPhoneNumber = 'hasNoPhoneNumber',
  TcrCampaignNotApproved = 'tcrCampaignNotApproved',
}

/** BankRoutingType */
export enum BankRoutingType {
  Checking = 'checking',
  Savings = 'savings',
}

/** BankAccountType */
export enum BankAccountType {
  Checking = 'checking',
  Savings = 'savings',
}

/** BankAccountSweepItemType */
export enum BankAccountSweepItemType {
  Credit = 'credit',
  Debit = 'debit',
  Deposit = 'deposit',
}

/** BankAccountSweepItemStatus */
export enum BankAccountSweepItemStatus {
  Settled = 'settled',
  FundsAvailable = 'fundsAvailable',
  Returned = 'returned',
  Failed = 'failed',
}

/** BankAccountConnectionStatus */
export enum BankAccountConnectionStatus {
  Incomplete = 'incomplete',
  Pending = 'pending',
  Approved = 'approved',
  Denied = 'denied',
}

/** BankAccountConnectType */
export enum BankAccountConnectType {
  Plaid = 'plaid',
  Stripe = 'stripe',
}

/** AssociationViolationStatus */
export enum AssociationViolationStatus {
  Received = 'received',
  InProgress = 'inProgress',
  Resolved = 'resolved',
}

/** App */
export enum App {
  CompanyApp = 'companyApp',
  CompanyWeb = 'companyWeb',
  TenantApp = 'tenantApp',
  VendorApp = 'vendorApp',
  OwnerApp = 'ownerApp',
  Homepage = 'homepage',
  Internal = 'internal',
}

/** AnnouncementStatus */
export enum AnnouncementStatus {
  Pending = 'pending',
  Sent = 'sent',
  PartiallyFailed = 'partiallyFailed',
  Failed = 'failed',
}

/** AnnouncementDeliveryBlockReason */
export enum AnnouncementDeliveryBlockReason {
  LeaseNotStarted = 'leaseNotStarted',
  NoContactInfo = 'noContactInfo',
  TcrNotReady = 'tcrNotReady',
}

/** AmenityType */
export enum AmenityType {
  Infrastructure = 'infrastructure',
  Utility = 'utility',
  Interior = 'interior',
  Exterior = 'exterior',
  Outdoor = 'outdoor',
  Community = 'community',
  Security = 'security',
  Parking = 'parking',
  Storage = 'storage',
  Recreation = 'recreation',
  GreenSpace = 'greenSpace',
  Service = 'service',
  Other = 'other',
}

/** AmenityAvalability */
export enum AmenityAvalability {
  Unavailable = 'unavailable',
  Available = 'available',
  Limited = 'limited',
  Pending = 'pending',
}

/** AiProcessingStatus */
export enum AiProcessingStatus {
  Pending = 'pending',
  InProgress = 'inProgress',
  Manual = 'manual',
  Processed = 'processed',
}

/** AccountsPayableGroupBy */
export enum AccountsPayableGroupBy {
  Total = 'total',
  Vendor = 'vendor',
  Property = 'property',
  Portfolio = 'portfolio',
}

/** AccountingBasis */
export enum AccountingBasis {
  Cash = 'cash',
  Accrual = 'accrual',
}

/** NotificationTargetDto */
export type NotificationTargetDto = BaseNotificationTargetDto &
  (
    | BaseNotificationTargetDtoTypeMapping<'TenantNotificationTargetDto', TenantNotificationTargetDto>
    | BaseNotificationTargetDtoTypeMapping<'LeaseNotificationTargetDto', LeaseNotificationTargetDto>
    | BaseNotificationTargetDtoTypeMapping<'OwnerNotificationTargetDto', OwnerNotificationTargetDto>
    | BaseNotificationTargetDtoTypeMapping<'VendorNotificationTargetDto', VendorNotificationTargetDto>
  );

/** CustomFieldOptionsDto */
export type CustomFieldOptionsDto = BaseCustomFieldOptionsDto &
  (
    | BaseCustomFieldOptionsDtoTypeMapping<'CustomStringFieldOptionsDto', CustomStringFieldOptionsDto>
    | BaseCustomFieldOptionsDtoTypeMapping<'CustomNumberFieldOptionsDto', CustomNumberFieldOptionsDto>
    | BaseCustomFieldOptionsDtoTypeMapping<'CustomBooleanFieldOptionsDto', CustomBooleanFieldOptionsDto>
    | BaseCustomFieldOptionsDtoTypeMapping<'CustomDateTimeFieldOptionsDto', CustomDateTimeFieldOptionsDto>
    | BaseCustomFieldOptionsDtoTypeMapping<'CustomReferenceFieldOptionsDto', CustomReferenceFieldOptionsDto>
  );

/** ConditionDto */
export type ConditionDto = BaseConditionDto &
  (
    | BaseConditionDtoTypeMapping<'RentAmountConditionDto', RentAmountConditionDto>
    | BaseConditionDtoTypeMapping<'TenantCountConditionDto', TenantCountConditionDto>
    | BaseConditionDtoTypeMapping<'MaintenanceRequestCountConditionDto', MaintenanceRequestCountConditionDto>
    | BaseConditionDtoTypeMapping<'LatePaymentCountConditionDto', LatePaymentCountConditionDto>
    | BaseConditionDtoTypeMapping<'LeaseBalanceConditionDto', LeaseBalanceConditionDto>
    | BaseConditionDtoTypeMapping<'SecurityDepositConditionDto', SecurityDepositConditionDto>
  );

/** AccountReportLineDto */
export interface AccountReportLineDto {
  name: string;
  children: AccountReportLineDto[];
  groups: Record<string, number>;
  groupTotal?: Record<string, number>;
  metadata?: Record<string, string>;
}

/** AccountsPayableReportColumnValueDto */
export interface AccountsPayableReportColumnValueDto {
  /** @format double */
  amount: number;
  /** @format int32 */
  billCount: number;
}

/** AccountsPayableReportDto */
export interface AccountsPayableReportDto {
  groupHeaders: ReportGroupHeaderDto[];
  lines: AccountsPayableReportLineDto[];
  grandTotals: Record<string, AccountsPayableReportColumnValueDto>;
  vendors: VendorDto[];
  properties: PropertyDto[];
  portfolios: PortfolioDto[];
}

/** AccountsPayableReportLineDto */
export interface AccountsPayableReportLineDto {
  name: string;
  vendorId?: string;
  propertyId?: string;
  portfolioId?: string;
  columns: Record<string, AccountsPayableReportColumnValueDto>;
}

/** AddAssociationViolationFilesDto */
export interface AddAssociationViolationFilesDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 1
   */
  uploadSessionIds: string[];
}

/** AddAssociationViolationLeaseBillDto */
export interface AddAssociationViolationLeaseBillDto {
  description: string;
  chartOfAccountId: string;
  /** @format double */
  amount: number;
  companyCharge: boolean;
}

/** AddCompanyPayoutGroupDto */
export interface AddCompanyPayoutGroupDto {
  propertyBankAccountId: string;
  propertyChartOfAccountId: string;
  companyBankAccountId: string;
  companyChartOfAccountId: string;
  lineItems: AddCompanyPayoutLineItemDto[];
  paymentType: PayoutMethod;
  paymentMethod?: TransactionPaymentMethod;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalTransactionId?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
}

/** AddCompanyPayoutLineItemDto */
export interface AddCompanyPayoutLineItemDto {
  entityType: string;
  entityId: string;
  itemId: string;
}

/** AddCompanyPayoutsDto */
export interface AddCompanyPayoutsDto {
  payouts: AddCompanyPayoutGroupDto[];
}

/** AddFileAttachmentDto */
export interface AddFileAttachmentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId: string;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description?: string;
  shareTypes?: MagicUserType[];
}

/** AddLeaseChargeCreditDto */
export interface AddLeaseChargeCreditDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /** @format date */
  issueDate: string;
}

/** AddLeaseChargeDto */
export interface AddLeaseChargeDto {
  /** @format date */
  billDate?: string;
  /** @format date */
  dueDate: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /** @default false */
  companyCharge: boolean;
}

/** AddLeaseChargeFileDto */
export interface AddLeaseChargeFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** AddLeaseChargeFilesDto */
export interface AddLeaseChargeFilesDto {
  /** @minItems 1 */
  files: AddLeaseChargeFileDto[];
}

/** AddLeaseChargePaymentDto */
export interface AddLeaseChargePaymentDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  paymentMethod?: OfflineTransactionPaymentMethod;
  /** @format date */
  date: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  reference?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  targetChargeIds?: string[];
}

/** AddLeaseDepositDto */
export interface AddLeaseDepositDto {
  /** @format date */
  billDate?: string;
  /** @format date */
  dueDate: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
}

/** AddLeaseDepositFileDto */
export interface AddLeaseDepositFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** AddLeaseDepositFilesDto */
export interface AddLeaseDepositFilesDto {
  /** @minItems 1 */
  files: AddLeaseDepositFileDto[];
}

/** AddLeaseDepositPaymentDto */
export interface AddLeaseDepositPaymentDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  paymentMethod?: OfflineTransactionPaymentMethod;
  /** @format date */
  date: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  reference?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  targetDepositIds?: string[];
}

/** AddManagementFeeCreditDto */
export interface AddManagementFeeCreditDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /** @format date */
  issueDate: string;
}

/** AddManagementFeeDto */
export interface AddManagementFeeDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  memo?: string;
  /** @format date-time */
  periodStart: string;
  /** @format date-time */
  periodEnd: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  creditAmount?: number;
}

/** AddManagementFeesDto */
export interface AddManagementFeesDto {
  /** @format date */
  chargeDate?: string;
  /**
   * Only for calculating fees until, not for charging manually
   * @format date-time
   */
  calculateFeesUntil?: string;
  /** @minItems 1 */
  managementFees: AddManagementFeeDto[];
}

/** AddOwnerContributionFileDto */
export interface AddOwnerContributionFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** AddOwnerContributionFilesDto */
export interface AddOwnerContributionFilesDto {
  /** @minItems 1 */
  files: AddOwnerContributionFileDto[];
}

/** AddOwnerDistributionFileDto */
export interface AddOwnerDistributionFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** AddOwnerDistributionFilesDto */
export interface AddOwnerDistributionFilesDto {
  /** @minItems 1 */
  files: AddOwnerDistributionFileDto[];
}

/** AddOwnerTransferFileDto */
export interface AddOwnerTransferFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** AddOwnerTransferFilesDto */
export interface AddOwnerTransferFilesDto {
  /** @minItems 1 */
  files: AddOwnerTransferFileDto[];
}

/** AddPropertyChargeDto */
export interface AddPropertyChargeDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  cashChartOfAccountId?: string;
  /** @format date */
  chargeDate?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  memo?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalTransactionId?: string;
  metadata?: Record<string, string>;
}

/** AddPropertyManagerPermissionDto */
export interface AddPropertyManagerPermissionDto {
  /**
   * The permission string to add, e.g. 'property:read', 'property:write', 'property:delete'
   * @minLength 1
   * @maxLength 100
   */
  permission: string;
}

/** AddPropertyManagerPropertyAccessDto */
export interface AddPropertyManagerPropertyAccessDto {
  /**
   * Whether to grant access to all properties
   * @default false
   */
  allProperties: boolean;
  /**
   * The portfolio ID to grant access to
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId?: string;
  /**
   * The property ID to grant access to
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
}

/** AddServiceBillDto */
export interface AddServiceBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /** @format date */
  chargeDate?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyChartOfAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyChartOfAccountId: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  memo?: string;
}

/** AddUnitListingImageItemDto */
export interface AddUnitListingImageItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  default?: boolean;
  /** @format int32 */
  order?: number;
}

/** AddUnitListingImagesDto */
export interface AddUnitListingImagesDto {
  /** @minItems 1 */
  images: AddUnitListingImageItemDto[];
}

/** AddUnitListingVideoItemDto */
export interface AddUnitListingVideoItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  default?: boolean;
  /** @format int32 */
  order?: number;
}

/** AddUnitListingVideosDto */
export interface AddUnitListingVideosDto {
  /** @minItems 1 */
  videos: AddUnitListingVideoItemDto[];
}

/** AddVendorBillFileDto */
export interface AddVendorBillFileDto {
  /**
   * [DEPRECATED] Use UploadSessionId instead
   * @deprecated
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** AddVendorBillFilesDto */
export interface AddVendorBillFilesDto {
  /** @minItems 1 */
  files: AddVendorBillFileDto[];
}

/** AddressDto */
export interface AddressDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  streetAddress1?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  streetAddress2?: string;
  /**
   * @minLength 2
   * @maxLength 150
   */
  city?: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  state?: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  zipCode?: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  country?: string;
  /** Indicates if the address is a valid US address */
  isValid: boolean;
}

/** AdjustLeaseChargeCreditDto */
export interface AdjustLeaseChargeCreditDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount?: number;
  /** @format date-time */
  issueDate?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
}

/** AdjustLeaseChargeDto */
export interface AdjustLeaseChargeDto {
  /** @format date */
  billDate?: string;
  /** @format date */
  dueDate?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount?: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId?: string;
  companyCharge?: boolean;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
}

/** AdjustLeaseChargePaymentDto */
export interface AdjustLeaseChargePaymentDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount?: number;
  paymentMethod?: OfflineTransactionPaymentMethod;
  /** @format date */
  date?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  reference?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  targetChargeIds?: string[];
}

/** AdjustLeaseDepositDto */
export interface AdjustLeaseDepositDto {
  /** @format date */
  billDate?: string;
  /** @format date */
  dueDate?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount?: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
}

/** AdjustLeaseDepositPaymentDto */
export interface AdjustLeaseDepositPaymentDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount?: number;
  paymentMethod?: OfflineTransactionPaymentMethod;
  /** @format date */
  date?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  reference?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  targetDepositIds?: string[];
}

/** AdjustManagementFeeCreditDto */
export interface AdjustManagementFeeCreditDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount?: number;
  /** @format date */
  issueDate?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
}

/** AdjustPropertyChargeDto */
export interface AdjustPropertyChargeDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  cashChartOfAccountId?: string;
  /** @format date */
  chargeDate?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount?: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  memo?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalTransactionId?: string;
}

/** AdjustServiceBillDto */
export interface AdjustServiceBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /** @format date */
  chargeDate?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount?: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyChartOfAccountId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyChartOfAccountId?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  memo?: string;
}

/** AllocateDepositRequestDto */
export interface AllocateDepositRequestDto {
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  description?: string;
  /** @format date */
  date?: string;
}

/** AmenityDto */
export interface AmenityDto {
  type: AmenityType;
  /**
   * @minLength 2
   * @maxLength 50
   */
  name: string;
  /**
   * @minLength 2
   * @maxLength 50
   */
  icon?: string;
  avalability: AmenityAvalability;
  description?: string;
}

/** AnnouncementDeliveryBlockDto */
export interface AnnouncementDeliveryBlockDto {
  reason: AnnouncementDeliveryBlockReason;
  message: string;
}

/** AnnouncementListDto */
export interface AnnouncementListDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId: string;
  /** @format date-time */
  sentAt: string;
  chatMessage?: string;
  emailMessage?: string;
  /** @maxLength 250 */
  subject?: string;
  /** @format int32 */
  targetsCount: number;
  status: AnnouncementStatus;
  failureReason?: string;
}

/** AnnouncementTargetLeaseDto */
export interface AnnouncementTargetLeaseDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  ended: boolean;
  monthToMonth: boolean;
  eviction: boolean;
  chatId?: string;
  tenants: LeaseTenantDto[];
  /** @format double */
  balance: number;
  /** @format double */
  currentRent: number;
  /** @format double */
  securityDepositPaid: number;
  /** @format double */
  securityDepositRequested: number;
  /** @format double */
  securityDepositDue: number;
  /** @format date */
  lastPaymentDate?: string;
  /** @format date */
  earliestUnpaidBillDueDate?: string;
  icons: string[];
  /** @format date */
  moveOutDate?: string;
  draft: boolean;
  status: LeaseStatus;
  expiringStatus: ExpiringStatus;
  /** @format int32 */
  pastDueDays?: number;
  /** @format double */
  postedBalance: number;
  canDeliver: boolean;
  blockReasons: AnnouncementDeliveryBlockDto[];
}

/** AnnouncementTargetOwnerDto */
export interface AnnouncementTargetOwnerDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  isCompany: boolean;
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  chatId?: string;
  language: string;
  icons: string[];
  address?: AddressDto;
  portalStatus: PortalStatus;
  canDeliver: boolean;
  blockReasons: AnnouncementDeliveryBlockDto[];
}

/** AnnouncementTargetTenantDto */
export interface AnnouncementTargetTenantDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons: string[];
  imageId?: string;
  canDeliver: boolean;
  blockReasons: AnnouncementDeliveryBlockDto[];
}

/** AnnouncementTargetVendorDto */
export interface AnnouncementTargetVendorDto {
  id: string;
  name: string;
  language: string;
  contact: ContactDto;
  memo?: string;
  active: boolean;
  website?: string;
  irs1099Form?: FederalTaxInformationDto;
  insurancePolicy?: InsurancePolicyDto;
  chatId?: string;
  icons: string[];
  type: VendorType;
  defaultMemo?: string;
  paymentSettings: PaymentSettingsDto;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  canDeliver: boolean;
  blockReasons: AnnouncementDeliveryBlockDto[];
}

/** AnnouncementsDto */
export interface AnnouncementsDto {
  announcements: AnnouncementListDto[];
  properties: PropertyDto[];
}

/** AppRegistrationInfoDto */
export interface AppRegistrationInfoDto {
  /** @minLength 1 */
  deviceToken: string;
  platform: Platform;
  /** @minLength 1 */
  appVersion: string;
}

/** AppliedLeaseChargeDto */
export interface AppliedLeaseChargeDto {
  leaseChargeId: string;
  /** @format double */
  appliedAmount: number;
  /** @format date */
  applied: string;
}

/** AppliedMagicDoorBillDto */
export interface AppliedMagicDoorBillDto {
  magicDoorBillId: string;
  /** @format double */
  appliedAmount: number;
  /** @format date */
  applied: string;
}

/** AppliedManagementFeeDto */
export interface AppliedManagementFeeDto {
  managementFeeId: string;
  /** @format double */
  appliedAmount: number;
  /** @format date */
  applied: string;
}

/** AssignChatDto */
export interface AssignChatDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyManagerId?: string;
}

/** AssociationViolationDto */
export interface AssociationViolationDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId?: string;
  leaseId?: string;
  status: AssociationViolationStatus;
  hoaVendorId: string;
  reference: string;
  /** @format date */
  violationReceivedDate: string;
  /** @format date */
  violationDate: string;
  /** @format date */
  fixByDate?: string;
  /** @format double */
  associationFine?: number;
  title: string;
  description: string;
  /** @format date-time */
  notificationSentAt?: string;
  files: FileDto[];
  propertyFineBill?: VendorBillItemDto;
  leaseFineBill?: LeaseChargeItemDto;
  portfolio: PortfolioDto;
  property: PropertyDto;
  unit?: UnitDto;
  lease?: LeaseDto;
  workOrders: WorkOrderListDto[];
  leaseBills: LeaseChargeItemDto[];
  owners: OwnerDto[];
  workOrderVendors: VendorDto[];
}

/** AssociationViolationListDto */
export interface AssociationViolationListDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId?: string;
  leaseId?: string;
  status: AssociationViolationStatus;
  hoaVendorId: string;
  reference: string;
  /** @format date */
  violationReceivedDate: string;
  /** @format date */
  violationDate: string;
  /** @format date */
  fixByDate?: string;
  /** @format double */
  associationFine?: number;
  title: string;
  description: string;
  /** @format date-time */
  notificationSentAt?: string;
}

/** AuthConfigDto */
export interface AuthConfigDto {
  authorizeUrl: string;
  tokenUrl: string;
  revokeUrl: string;
  introspectUrl: string;
  openIdConfigurationUrl: string;
}

/** AuthResultDto */
export interface AuthResultDto {
  success: boolean;
  companies?: CompanyOptionDto[];
  interactionCode?: string;
  twoFactor?: TwoFactorChallengeDto;
}

/** AvailablePhoneNumberDto */
export interface AvailablePhoneNumberDto {
  phoneNumber: string;
  /** @format double */
  monthlyCost: number;
  /** @format double */
  upfrontCost: number;
}

/** AvailablePhoneNumbersDto */
export interface AvailablePhoneNumbersDto {
  phoneNumbers: AvailablePhoneNumberDto[];
}

/** BalanceSheetReportDataDto */
export interface BalanceSheetReportDataDto {
  groupHeaders: ReportGroupHeader[];
  assets: AccountReportLineDto[];
  totalAssets: Record<string, number>;
  liabilities: AccountReportLineDto[];
  totalLiabilities: Record<string, number>;
  equity: AccountReportLineDto[];
  totalEquity: Record<string, number>;
}

/** BankAccountActivityDto */
export interface BankAccountActivityDto {
  /** @format date-time */
  date: string;
  payeeOrPayerName: string;
  transactionIdentity: TransactionIdentity;
  transactionPaymentMethod: TransactionPaymentMethod;
  transactionStatus: TransactionStatus;
  externalTransactionType?: ExternalTransactionType;
  externalTransactionId?: string;
  failureReason?: TransactionFailure;
  /** @format double */
  cashIn?: number;
  /** @format double */
  cashOut?: number;
  /** @format double */
  balance: number;
  description?: string;
  cleared: boolean;
  manuallyReconciled: boolean;
  /**
   * [DEPRECATED] Use ManuallyReconciled instead
   * @deprecated
   */
  reconciled: boolean;
}

/** BankAccountActivityReportDto */
export interface BankAccountActivityReportDto {
  account: BankAccountDto;
  dateRange: DateRangeDto;
  /** @format double */
  startingBalance: number;
  /** @format double */
  netChange: number;
  activities: BankAccountActivityDto[];
  activitiesTotal: BankAccountActivityTotalDto;
}

/** BankAccountActivityTotalDto */
export interface BankAccountActivityTotalDto {
  /** @format double */
  cashIn: number;
  /** @format double */
  cashOut: number;
}

/** BankAccountConnectionBalance */
export interface BankAccountConnectionBalance {
  /** @format double */
  available: number;
  /** @format double */
  pending: number;
}

/** BankAccountConnectionBalanceDto */
export interface BankAccountConnectionBalanceDto {
  /** @format double */
  available: number;
  /** @format double */
  pending: number;
}

/** BankAccountConnectionDto */
export interface BankAccountConnectionDto {
  status: BankAccountConnectionStatus;
  supports: PaymentChannel[];
  deniedReason?: string;
  externalAccountId?: string;
}

/** BankAccountConnectionsDto */
export interface BankAccountConnectionsDto {
  plaid: BankAccountPlaidConnectionDto;
  stripe: BankAccountStripeConnectionDto;
}

/** BankAccountDto */
export interface BankAccountDto {
  id: string;
  name: string;
  description?: string;
  active: boolean;
  accountNumber?: string;
  routingNumber?: string;
  type?: BankAccountType;
  scheduledSweepDays: number[];
  chartOfAccountIds: string[];
  companyAccount: boolean;
  creator: CreatorDto;
}

/** BankAccountPlaidConnectionDto */
export interface BankAccountPlaidConnectionDto {
  eligible: boolean;
  status?: BankAccountConnectionStatus;
  balance?: BankAccountConnectionBalanceDto;
  notEligibleReason?: string;
  deniedReason?: string;
  externalAccountId?: string;
  limits?: PlaidTransferLimitsDto;
}

/** BankAccountStripeConnectionDto */
export interface BankAccountStripeConnectionDto {
  eligible: boolean;
  status?: BankAccountConnectionStatus;
  balance?: BankAccountConnectionBalanceDto;
  notEligibleReason?: string;
  deniedReason?: string;
  externalAccountId?: string;
}

/** BankAccountSweepDetailsDto */
export interface BankAccountSweepDetailsDto {
  id: string;
  plaidOriginatorId: string;
  plaidLedgerId: string;
  plaidAccountId: string;
  plaidSweepId: string;
  sweepStatus: PlaidSweepStatus;
  type: PlaidSweepType;
  /** @format double */
  amount: number;
  /** @format date-time */
  posted?: string;
  /** @format date-time */
  settled?: string;
  /** @format date-time */
  fundsAvailable?: string;
  /** @format date-time */
  failed?: string;
  /** @format date-time */
  returned?: string;
  returnCode?: string;
  failureReason?: string;
  bankAccountId?: string;
  /** @format date-time */
  lastSynced?: string;
  /** @format date-time */
  created: string;
  items: BankAccountSweepItemDto[];
  summary: BankAccountSweepSummaryDto;
}

/** BankAccountSweepDto */
export interface BankAccountSweepDto {
  id: string;
  plaidOriginatorId: string;
  plaidLedgerId: string;
  plaidAccountId: string;
  plaidSweepId: string;
  sweepStatus: PlaidSweepStatus;
  type: PlaidSweepType;
  /** @format double */
  amount: number;
  /** @format date-time */
  posted?: string;
  /** @format date-time */
  settled?: string;
  /** @format date-time */
  fundsAvailable?: string;
  /** @format date-time */
  failed?: string;
  /** @format date-time */
  returned?: string;
  returnCode?: string;
  failureReason?: string;
  bankAccountId?: string;
  /** @format date-time */
  lastSynced?: string;
  /** @format date-time */
  created: string;
}

/** BankAccountSweepDtoPaginationDto */
export interface BankAccountSweepDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: BankAccountSweepDto[];
}

/** BankAccountSweepItemDto */
export interface BankAccountSweepItemDto {
  type: BankAccountSweepItemType;
  status: BankAccountSweepItemStatus;
  /** @format double */
  amount: number;
  /** @format date-time */
  date: string;
  /** @format double */
  fee?: number;
  plaidTransferId?: string;
  plaidSweepId?: string;
  description?: string;
  transactionId?: string;
  transactionIdentity?: TransactionIdentity;
  propertyId?: string;
  propertyName?: string;
  unitId?: string;
  unitName?: string;
  leaseId?: string;
  tenantId?: string;
  tenantName?: string;
  vendorId?: string;
  ownerId?: string;
  ownerName?: string;
}

/** BankAccountSweepLimitsDto */
export interface BankAccountSweepLimitsDto {
  /** @format int32 */
  interval: number;
}

/** BankAccountSweepSummaryDto */
export interface BankAccountSweepSummaryDto {
  /** @format int32 */
  totalCount: number;
  /** @format double */
  totalAmount: number;
  /** @format double */
  totalFees: number;
  /** @format double */
  netAmount: number;
  period?: DateTimeRangeDto;
}

/** BankRoutingDto */
export interface BankRoutingDto {
  bankName: string;
  routingNumber: string;
  accountNumber: string;
  type: BankRoutingType;
}

/** BatchCreateOwnerTaxDocumentDto */
export interface BatchCreateOwnerTaxDocumentDto {
  taxAmounts?: OwnerTaxDocumentAmountDto[];
}

/** BatchCreateTaxDocumentDto */
export interface BatchCreateTaxDocumentDto {
  taxAmounts?: CreateTaxDocumentAmountDto[];
}

/** BillPayProperty */
export interface BillPayProperty {
  property: PropertyDto;
  /** @format double */
  availableBalance: number;
  /** @format double */
  reserve: number;
  /** @format double */
  availableForPayment: number;
  defaultBankAccountId?: string;
  defaultCashChartOfAccountId?: string;
  bills: VendorBillItemDto[];
}

/** BillSettleProperty */
export interface BillSettleProperty {
  property: PropertyDto;
  /** @format double */
  availableBalance: number;
  /** @format double */
  reserve: number;
  /** @format double */
  availableForPayment: number;
  defaultBankAccountId?: string;
  defaultCashChartOfAccountId?: string;
  bills: VendorBillItemDto[];
}

/** BulkSendTenantPortalInviteDto */
export interface BulkSendTenantPortalInviteDto {
  scope?: PortalInviteScopeDto;
  /** @minItems 1 */
  messages: PortalInviteMessagePayloadDto[];
}

/** BuyPhoneNumberRequestDto */
export interface BuyPhoneNumberRequestDto {
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phoneNumber: string;
}

/** CalculateManagementFeesDto */
export interface CalculateManagementFeesDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyIds?: string[];
  managementFeeDate: ManagementFeeDate;
}

/** CalculatedLeaseRenewalOfferDto */
export interface CalculatedLeaseRenewalOfferDto {
  /** @format date */
  newEndDate: string;
  recurringChargeChanges: RecurringChargeChangeDto[];
  /** @format date-time */
  offerExpires?: string;
}

/** CalculatedPropertyDistributionDto */
export interface CalculatedPropertyDistributionDto {
  property: PropertyDto;
  defaultBankAccountId?: string;
  defaultCashChartOfAccountId?: string;
  /** @format double */
  currentPropertyBalance: number;
  /** @format double */
  propertyReserve: number;
  /** @format double */
  propertyBalance: number;
  /** @format double */
  availableForDistribution: number;
  defaultMemo: string;
  owners: OwnerDistributionInfoDto[];
}

/** CalculatedPropertyDistributionsDto */
export interface CalculatedPropertyDistributionsDto {
  properties: CalculatedPropertyDistributionDto[];
}

/** CashFlowReportDto */
export interface CashFlowReportDto {
  groupHeaders: ReportGroupHeaderDto[];
  income: AccountReportLineDto[];
  incomeTotal: Record<string, number>;
  expenses: AccountReportLineDto[];
  expensesTotal: Record<string, number>;
  otherIncome: AccountReportLineDto[];
  otherIncomeTotal: Record<string, number>;
  otherExpenses: AccountReportLineDto[];
  otherExpensesTotal: Record<string, number>;
  netOperatingIncome: Record<string, number>;
  netOtherIncome: Record<string, number>;
  netIncome: Record<string, number>;
  otherItems: AccountReportLineDto[];
  netOtherItems: Record<string, number>;
  cashFlow: Record<string, number>;
  beginningCash: Record<string, number>;
  endingCash: Record<string, number>;
}

/** ChargeAssociationFineToPropertyDto */
export interface ChargeAssociationFineToPropertyDto {
  /** @format date */
  dueDate?: string;
}

/** ChartOfAccountDto */
export interface ChartOfAccountDto {
  id: string;
  parentId?: string;
  /** @format int32 */
  number?: number;
  type: ChartOfAccountType;
  name: string;
  description?: string;
  creator: CreatorDto;
  isDefault: boolean;
}

/** ChartOfAccountReportDto */
export interface ChartOfAccountReportDto {
  chartOfAccount: ChartOfAccountDto;
  lineItems: LineItemReportDto[];
  /** @format double */
  startingBalance: number;
  /** @format double */
  totalDebit: number;
  /** @format double */
  totalCredit: number;
  /** @format double */
  endingBalance: number;
  /** @format double */
  netChange: number;
}

/** ChatCreateResponseDto */
export interface ChatCreateResponseDto {
  chatId?: string;
  failureReason?: string;
}

/** ChatMessageDto */
export interface ChatMessageDto {
  id: string;
  chatId: string;
  messageType: MessageType;
  participantId?: string;
  message?: string;
  messageLanguage?: string;
  translatedMessage?: string;
  translatedMessageLanguage?: string;
  translatedFailed: boolean;
  aiEnhanced: boolean;
  /** @format date-time */
  sentAt: string;
  sendText: boolean;
  textStatus?: TextStatus;
  /** @format date-time */
  textSentAt?: string;
  /** @format date-time */
  textDeliveredAt?: string;
  textSendStatuses?: Record<string, string>;
  textFailedReason?: string;
  sendEmail: boolean;
  source: MessageSource;
  files: ChatMessageFileDto[];
  read: boolean;
  /** @format date-time */
  readAt?: string;
  emailStatus?: EmailStatus;
  /** @format date-time */
  emailSentAt?: string;
  /** @format date-time */
  emailDeliveredAt?: string;
  aiProcessingStatus: AiProcessingStatus;
  /** @format date-time */
  aiProcessedAt?: string;
  handledByPropertyManagerId?: string;
  /** @format date-time */
  handledByPropertyManagerAt?: string;
}

/** ChatMessageFileDto */
export interface ChatMessageFileDto {
  id: string;
  /** @format date-time */
  created: string;
  name: string;
  extension: string;
  /** @format int32 */
  size: number;
  contentType: string;
  secureUrl: FileUrlDto;
  /**
   * [DEPRECATED] Use Id instead.
   * @deprecated
   */
  fileId: string;
  /**
   * [DEPRECATED] Use Name instead.
   * @deprecated
   */
  fileName: string;
  /**
   * [DEPRECATED] Use SecureUrl instead.
   * @deprecated
   */
  signedUrl: string;
  /**
   * [DEPRECATED] Use SecureUrl instead.
   * @deprecated
   */
  signedThumbUrl?: string;
  /**
   * [DEPRECATED] Use Size instead.
   * @deprecated
   * @format int32
   */
  fileSize: number;
  /**
   * [DEPRECATED] Use Created instead.
   * @deprecated
   * @format date-time
   */
  uploaded: string;
  /**
   * [DEPRECATED] Debug purpose only, Do not use in production.
   * @deprecated
   */
  claimed: boolean;
  /**
   * [DEPRECATED] Use Extension instead.
   * @deprecated
   */
  fileExtension: string;
  /**
   * [DEPRECATED] Use SecureUrl instead.
   * @deprecated
   */
  fileUrl: string;
  /**
   * [DEPRECATED] Use SecureUrl.VariantTemplate instead.
   * @deprecated
   */
  thumbUrl?: string;
}

/** ChatMessagesDto */
export interface ChatMessagesDto {
  /** @format int32 */
  totalCount: number;
  /**
   * [DEPRECATED] Use Items; removal tracked in a follow-up
   * @deprecated
   */
  messages: ChatMessageDto[];
  items: ChatTimelineItemDto[];
  propertyManagers: PropertyManagerDto[];
}

/** ChatNoteDto */
export interface ChatNoteDto {
  id: string;
  chatId: string;
  kind: ChatNoteKind;
  audience: ChatNoteAudience;
  author: ChatNoteAuthor;
  authorPropertyManagerId?: string;
  body: string;
  referencedEntityType?: EntityType;
  referencedEntityId?: string;
  editedByPropertyManagerId?: string;
  /** @format date-time */
  editedAt?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  metadata?: Record<string, string>;
}

/** ChatTimelineItemDto */
export interface ChatTimelineItemDto {
  id: string;
  kind: ChatTimelineItemKind;
  message?: ChatMessageDto;
  note?: ChatNoteDto;
}

/** CheckBillPaymentDto */
export interface CheckBillPaymentDto {
  billId?: string;
  data: Record<string, string | null>;
  /** @format double */
  amount: number;
}

/** CheckDto */
export interface CheckDto {
  id: string;
  companyId: string;
  /** @format int32 */
  checkNumber: number;
  vendorId?: string;
  ownerId?: string;
  tenantId?: string;
  bankAccountId: string;
  /** @format double */
  amount: number;
  memo?: string;
  /** @format date-time */
  createdOn: string;
  /** @format date-time */
  date: string;
  transactionId?: string;
  billPayments: CheckBillPaymentDto[];
  dataHeaders: string[];
  voided: boolean;
  voidReason?: string;
  amountString: string;
}

/** ClientVersionInfoDto */
export interface ClientVersionInfoDto {
  app: App;
  platform: Platform;
  appVersion: string;
  status?: VersionStatus;
}

/** CompanyDomainDto */
export interface CompanyDomainDto {
  /** @pattern ^[a-z0-9][a-z0-9-]+(\.[a-z0-9][a-z0-9-]+)*\.[a-z]{2,}$ */
  domain?: string;
}

/** CompanyDto */
export interface CompanyDto {
  id: string;
  name: string;
  email: string;
  subUrl: string;
  language: string;
  phoneNumber?: string;
  timeZoneInfo: string;
  customDomain?: string;
  address: AddressDto;
  onboarded: boolean;
  onboardingStatus?: string;
  publicUrl: string;
  /** @format date-time */
  trialAccountUntil?: string;
  features: MagicDoorFeature[];
  businessMode: CompanyBusinessMode;
  /** @format date-time */
  closedSince?: string;
  /** @format date-time */
  created: string;
}

/** CompanyInvoiceAllocationDto */
export interface CompanyInvoiceAllocationDto {
  transaction: TransactionItemDto;
  /** @format double */
  amount: number;
  /** @format date */
  paymentDate: string;
  /** @format date */
  voided?: string;
  voidReason?: string;
}

/** CompanyInvoiceChargeDto */
export interface CompanyInvoiceChargeDto {
  service: CompanyChargeService;
  /** @format double */
  amount: number;
  /** @format date */
  chargeDate: string;
  /** @format date */
  dueDate: string;
  description: string;
  metadata?: Record<string, string>;
}

/** CompanyInvoiceDto */
export interface CompanyInvoiceDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  billDate: string;
  /** @format date-time */
  dueDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
  reference?: string;
  metadata: Record<string, string>;
  creator: CreatorDto;
  summaries: CompanyInvoiceSummaryDto[];
  charges: CompanyInvoiceChargeDto[];
  allocations: CompanyInvoiceAllocationDto[];
  file?: FileDto;
}

/** CompanyInvoiceItemDto */
export interface CompanyInvoiceItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  billDate: string;
  /** @format date-time */
  dueDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
  reference?: string;
  metadata: Record<string, string>;
  creator: CreatorDto;
}

/** CompanyInvoicePaginationDto */
export interface CompanyInvoicePaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: CompanyInvoiceItemDto[];
}

/** CompanyInvoiceSummaryDto */
export interface CompanyInvoiceSummaryDto {
  service: CompanyChargeService;
  /** @format int32 */
  itemCount: number;
  /** @format double */
  itemTotal: number;
}

/** CompanyOptionDto */
export interface CompanyOptionDto {
  id: string;
  name: string;
  businessMode: CompanyBusinessMode;
}

/** CompanyPaymentsDto */
export interface CompanyPaymentsDto {
  hasRentPayments: boolean;
}

/** CompanyPayoutDto */
export interface CompanyPayoutDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  transferDate: string;
  /** @format double */
  amount: number;
  outTransactionId: string;
  inTransactionId: string;
  memo?: string;
  reference?: string;
  metadata: Record<string, string>;
  creator: CreatorDto;
  outTransaction: TransactionItemDto;
  inTransaction: TransactionItemDto;
  check?: CheckDto;
  outBankAccount: BankAccountDto;
  inBankAccount: BankAccountDto;
  outChartOfAccount: ChartOfAccountDto;
  inChartOfAccount: ChartOfAccountDto;
  creatorInfo: CreatorInfoDto;
}

/** CompanyPayoutGroupDto */
export interface CompanyPayoutGroupDto {
  /** The bank account from which funds should be transferred (Property/Owner trust account). Null for items like ManagementFee/ServiceBill that need PM to manually specify the source account. */
  propertyBankAccountId?: string;
  /** The cash chart of account from which funds should be transferred. Null for items like ManagementFee/ServiceBill that need PM to manually specify the source account. */
  propertyChartOfAccountId?: string;
  /** @format double */
  totalAmount: number;
  lineItems: CompanyPayoutLineItemDto[];
}

/** CompanyPayoutItemDto */
export interface CompanyPayoutItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  transferDate: string;
  /** @format double */
  amount: number;
  outTransactionId: string;
  inTransactionId: string;
  memo?: string;
  reference?: string;
  metadata: Record<string, string>;
  creator: CreatorDto;
}

/** CompanyPayoutLineItemDto */
export interface CompanyPayoutLineItemDto {
  entityType: string;
  entityId: string;
  itemId: string;
  chartOfAccountId: string;
  /** @format double */
  amount: number;
  /** @format date */
  postedDate: string;
  /** @format date */
  settledDate?: string;
  description: string;
  transactionId?: string;
  portfolioId?: string;
  propertyId?: string;
  unitId?: string;
  leaseId?: string;
  bankAccountId?: string;
  cashChartOfAccountId?: string;
}

/** CompanyPayoutPaginationDto */
export interface CompanyPayoutPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: CompanyPayoutItemDto[];
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
}

/** CompanyPayoutsDto */
export interface CompanyPayoutsDto {
  /** @format date-time */
  asOf?: string;
  groups: CompanyPayoutGroupDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  leases: LeaseDto[];
  units: UnitDto[];
  properties: PropertyDto[];
  portfolios: PortfolioDto[];
  defaultCompanyBankAccount: BankAccountDto;
}

/** CompanyPhoneNumberStatusDto */
export interface CompanyPhoneNumberStatusDto {
  canSend: boolean;
  forbiddenReason?: CannotSendTextMessagesReason;
  chatPhoneNumber?: string;
}

/** CompanyReferralLinkDto */
export interface CompanyReferralLinkDto {
  url: string;
}

/** CompanyStatusDto */
export interface CompanyStatusDto {
  phoneNumberSettled: boolean;
  businessInfoSubmitted: boolean;
  hasBankAccounts: boolean;
  plaidConnected: boolean;
  stripeConnected: boolean;
  hasPaymentAccounts: boolean;
  invoiceSettingsConfigured: boolean;
  rentPaymentSettingsConfigured: boolean;
  depositPaymentSettingsConfigured: boolean;
  rentalApplicationSettingsConfigured: boolean;
}

/** CompanySubUrlDto */
export interface CompanySubUrlDto {
  /**
   * @minLength 3
   * @maxLength 150
   * @pattern ^[a-z0-9][a-z0-9-_]+$
   */
  url: string;
}

/** CompanyVendorBillItemDto */
export interface CompanyVendorBillItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  companyBill: boolean;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
  reference?: string;
  sourceType?: VendorBillSourceType;
  sourceId?: string;
  vendorId: string;
  status: VendorBillStatus;
  assignedToId?: string;
  assignedById?: string;
  /** @format date-time */
  assignedAt?: string;
  lineItems: VendorBillLineItemDto[];
  files: VendorBillFileDto[];
  statusHistory: VendorBillStatusChangeDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  property?: PropertyDto;
}

/** ConditionGroupDto */
export interface ConditionGroupDto {
  operator: LogicalOperator;
  /** @minItems 1 */
  conditions: (
    | RentAmountConditionDto
    | TenantCountConditionDto
    | MaintenanceRequestCountConditionDto
    | LatePaymentCountConditionDto
    | LeaseBalanceConditionDto
    | SecurityDepositConditionDto
  )[];
}

/** ConnectBankAccountDto */
export interface ConnectBankAccountDto {
  /**
   * [DEPRECATED] Use CompanyBusinessInfoId instead.
   * @deprecated
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 2
   */
  statementFileIds?: string[];
  /**
   * Required for Plaid connection
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 2
   */
  statementUploadSessionIds?: string[];
  /**
   * Only applicable for Plaid connection, if not provided, will use the primary company business info
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyBusinessInfoId?: string;
  /** Only applicable for Stripe connection, if true, will return a client secret for embedding the Stripe onboarding page, otherwise will return a link to the Stripe onboarding page */
  isEmbedded?: boolean;
}

/** ConnectBankAccountResultDto */
export interface ConnectBankAccountResultDto {
  /** Stripe hosted onboarding link */
  link?: string;
  /** Stripe embedded onboarding client secret */
  clientSecret?: string;
}

/** ContactDto */
export interface ContactDto {
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * A valid email address.
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  address?: AddressDto;
}

/** ContactPhoneEmailDto */
export interface ContactPhoneEmailDto {
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * A valid email address.
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
}

/** CopyLeaseTemplateDto */
export interface CopyLeaseTemplateDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fromLeaseTemplateId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseTemplateCategoryId: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
}

/** CreateAssociationViolationRequestDto */
export interface CreateAssociationViolationRequestDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  status?: AssociationViolationStatus;
  /**
   * @minLength 0
   * @maxLength 150
   */
  reference?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  hoaVendorId: string;
  /** @format date */
  violationReceivedDate: string;
  /** @format date */
  violationDate: string;
  /** @format date */
  fixByDate?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  associationFine?: number;
  /**
   * @minLength 0
   * @maxLength 150
   */
  title?: string;
  description: string;
}

/** CreateBankAccountDto */
export interface CreateBankAccountDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  /**
   * A valid 4 to 17 digit account number.
   * @pattern ^[0-9]{4,17}$
   */
  accountNumber?: string;
  /**
   * A valid 9-digit bank routing number.
   * @pattern ^[0-9]{9}$
   */
  routingNumber?: string;
  type?: BankAccountType;
  scheduledSweepDays?: number[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 1
   */
  chartOfAccountIds?: string[];
  companyAccount: boolean;
}

/** CreateChartOfAccountDto */
export interface CreateChartOfAccountDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  parentId?: string;
  /**
   * @format int32
   * @min 100000
   * @max 899999
   */
  number?: number;
  type: ChartOfAccountType;
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  description?: string;
}

/** CreateChatNoteDto */
export interface CreateChatNoteDto {
  body: string;
  metadata?: Record<string, string>;
}

/** CreateCompanyPaymentAccountDto */
export interface CreateCompanyPaymentAccountDto {
  /**
   * Required for ACH accounts
   * @minLength 3
   * @maxLength 100
   */
  bankName?: string;
  /**
   * A valid 9-digit bank routing number.
   * @pattern ^[0-9]{9}$
   */
  routingNumber?: string;
  /**
   * A valid 4 to 17 digit account number.
   * @pattern ^[0-9]{4,17}$
   */
  accountNumber?: string;
  /** Required for ACH accounts */
  accountType?: BankRoutingType;
  /** Required for Stripe accounts */
  stripeSessionId?: string;
}

/** CreateCustomFieldDto */
export interface CreateCustomFieldDto {
  entityType: EntityType;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  public: boolean;
  filterable: boolean;
  listable: boolean;
  /** @format int32 */
  order: number;
  options:
    | CustomStringFieldOptionsDto
    | CustomNumberFieldOptionsDto
    | CustomBooleanFieldOptionsDto
    | CustomDateTimeFieldOptionsDto
    | CustomReferenceFieldOptionsDto;
}

/** CreateFileAttachmentFromTemplateDto */
export interface CreateFileAttachmentFromTemplateDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  letterDocumentTemplateId: string;
  /**
   * @minLength 3
   * @maxLength 250
   */
  fileName?: string;
}

/** CreateLeaseDocumentDto */
export interface CreateLeaseDocumentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 1
   */
  leaseTemplateIds?: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
}

/** CreateLeaseDocumentFromLetterTemplateDto */
export interface CreateLeaseDocumentFromLetterTemplateDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  signingDocumentTemplateId: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyManagerIds?: string[];
}

/** CreateLeaseDto */
export interface CreateLeaseDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId: string;
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  monthToMonth: boolean;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantIds: string[];
  rent: LeaseChargeRequestDto;
  otherCharges?: LeaseChargeRequestDto[];
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  proratedAmount?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  deposit?: number;
  draft: boolean;
  fromType?: LeaseFromType;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fromEntityId?: number;
}

/** CreateLeaseRecurringPaymentDto */
export interface CreateLeaseRecurringPaymentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  paymentFrequency: ChargeFrequency;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description?: string;
  paymentMethod?: OfflineTransactionPaymentMethod;
  /**
   * @minLength 0
   * @maxLength 150
   */
  reference?: string;
  createPastPayments: boolean;
}

/** CreateLeaseRenewalOfferAutomaticSettingDto */
export interface CreateLeaseRenewalOfferAutomaticSettingDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  addDaysBefore?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  rentIncrease?: number;
  /**
   * @format int32
   * @min 1
   * @max 60
   */
  newLeaseLengthMonths?: number;
  newRecurringCharges?: NewRecurringChargeDto[];
  conditions?: ConditionGroupDto[];
  sendTenantNotifyOnRenewal?: boolean;
  templates?: TemplateRefDto[];
}

/** CreateLeaseRenewalOfferDto */
export interface CreateLeaseRenewalOfferDto {
  /** @format date */
  newEndDate?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  customLeaseText?: string;
  recurringChargeChanges: RecurringChargeChangeDto[];
  newRecurringCharges?: NewRecurringChargeDto[];
  /** @format date-time */
  offerExpires?: string;
  requiresSigning: boolean;
  templates?: TemplateRefDto[];
}

/** CreateLeaseSubsidyDto */
export interface CreateLeaseSubsidyDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  ownerId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  subsidizerId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  subsidyType: SubsidyType;
  /**
   * @minLength 1
   * @maxLength 100
   */
  voucherNumber?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  subsidyFrequency: ChargeFrequency;
  /** @format date */
  effectiveDate: string;
  /** @format date */
  endDate?: string;
  createPastSubsidies: boolean;
}

/** CreateLeaseTemplateCategoryDto */
export interface CreateLeaseTemplateCategoryDto {
  /**
   * @minLength 0
   * @maxLength 150
   */
  name: string;
}

/** CreateLeaseTemplateDto */
export interface CreateLeaseTemplateDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseTemplateCategoryId: string;
  type?: LeaseTemplateType;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId: string;
}

/** CreateMeetingScheduleDto */
export interface CreateMeetingScheduleDto {
  /**
   * @minLength 0
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  link?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalProvider?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalIdentifier?: string;
  /** @format date-time */
  startTime: string;
  /** @format date-time */
  startTimeUtc?: string;
  /** @format date-time */
  endTime: string;
  /** @format date-time */
  endTimeUtc?: string;
  /** @format date-time */
  cancelled?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  cancellationReason?: string;
  source: MeetingScheduleSource;
}

/** CreateNoteDto */
export interface CreateNoteDto {
  /** @minLength 1 */
  content: string;
  type: NoteType;
}

/** CreateNotificationScheduleDto */
export interface CreateNotificationScheduleDto {
  target: TenantNotificationTargetDto | LeaseNotificationTargetDto | OwnerNotificationTargetDto | VendorNotificationTargetDto;
  template: NotificationTemplateDto;
  /** @format date-time */
  time: string;
}

/** CreateOrUpdatePortfolioDto */
export interface CreateOrUpdatePortfolioDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  icons?: string[];
}

/** CreateOwnerDto */
export interface CreateOwnerDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  isCompany: boolean;
  /**
   * A valid email address.
   * @minLength 0
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language?:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  address?: AddressDto;
  /**
   * @minLength 5
   * @maxLength 150
   */
  password?: string;
}

/** CreateOwnerPaymentAccountDto */
export interface CreateOwnerPaymentAccountDto {
  /**
   * Required for ACH accounts
   * @minLength 3
   * @maxLength 100
   */
  bankName?: string;
  /**
   * A valid 9-digit bank routing number.
   * @pattern ^[0-9]{9}$
   */
  routingNumber?: string;
  /**
   * A valid 4 to 17 digit account number.
   * @pattern ^[0-9]{4,17}$
   */
  accountNumber?: string;
  /** Required for ACH accounts */
  accountType?: BankRoutingType;
  /** Required for Stripe accounts */
  stripeSessionId?: string;
}

/** CreateOwnerTaxDocumentDto */
export interface CreateOwnerTaxDocumentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  accountId: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  rentAmount: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  otherAmount: number;
}

/** CreateOwnerTransferDto */
export interface CreateOwnerTransferDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  ownerId: string;
  /** @format date-time */
  transferDate?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fromPropertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  toPropertyId: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  reference?: string;
  paymentMethod?: TransactionPaymentMethod;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalTransactionId?: string;
  metadata?: Record<string, string>;
}

/** CreatePhoneChatDto */
export interface CreatePhoneChatDto {
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phoneNumber: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  participantName?: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  subject?: string;
}

/** CreatePolicyHandbookDto */
export interface CreatePolicyHandbookDto {
  level: PolicyHandbookLevel;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  levelId?: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  title: string;
  /**
   * @minLength 0
   * @maxLength 2000
   */
  description?: string;
  /** @minLength 1 */
  script: string;
  enabled: boolean;
}

/** CreatePropertyDto */
export interface CreatePropertyDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name?: string;
  address: RequiredAddressDto;
  type: PropertyType;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * [DEPRECATED] Use ImageSessionId instead
   * @deprecated
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  imageId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  imageSessionId?: string;
  magicTags?: Record<string, string>;
  /**
   * @format int32
   * @min 1
   * @max 200
   */
  totalFloors?: number;
}

/** CreatePropertyManagerDto */
export interface CreatePropertyManagerDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  /**
   * A valid email address.
   * @minLength 1
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  clearTextPassword?: string;
}

/** CreateRecurringLeaseChargeDto */
export interface CreateRecurringLeaseChargeDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  chargeFrequency: ChargeFrequency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description?: string;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
  createPastCharges: boolean;
  companyCharge: boolean;
}

/** CreateRecurringLeaseCreditDto */
export interface CreateRecurringLeaseCreditDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  creditFrequency: ChargeFrequency;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description?: string;
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  createPastCredits: boolean;
}

/** CreateRecurringVendorBillDto */
export interface CreateRecurringVendorBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  reference?: string;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  memo?: string;
  /** @default false */
  companyCharge: boolean;
  /**
   * @format int32
   * @min 0
   * @max 365
   */
  dueDays?: number;
  /** @minItems 1 */
  lineItems: RecurringVendorBillLineItemDto[];
  chargeFrequency: ChargeFrequency;
  /** @format date */
  startsFrom: string;
  /** @format date */
  ends?: string;
}

/** CreateSigningDocumentTemplateDto */
export interface CreateSigningDocumentTemplateDto {
  /**
   * @minLength 0
   * @maxLength 250
   */
  name?: string;
  templateType: LeaseTemplateType;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseTemplateCategoryId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId?: string;
}

/** CreateSubsidizerDto */
export interface CreateSubsidizerDto {
  type: SubsidizerType;
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /**
   * @minLength 2
   * @maxLength 2
   * @default "en"
   */
  language?:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  /**
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  website?: string;
  contact?: ContactPhoneEmailDto;
  address?: AddressDto;
  federalTaxInformation?: FederalTaxInformationDto;
  paymentSettings?: SubsidizerPaymentSettingsDto;
}

/** CreateTaxDocumentAmountDto */
export interface CreateTaxDocumentAmountDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  accountId: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
}

/** CreateTaxDocumentDto */
export interface CreateTaxDocumentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  accountId: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
}

/** CreateTenantDto */
export interface CreateTenantDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  /**
   * A valid email address.
   * @minLength 0
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language?:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  /**
   * A valid SSN or EIN.
   * @minLength 9
   * @maxLength 11
   * @pattern ^(\d{3}-?\d{2}-?\d{4}|\d{9}|\d{2}-?\d{7})$
   */
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons?: string[];
  /**
   * @minLength 5
   * @maxLength 150
   */
  password?: string;
  sendPortalInvite?: boolean;
}

/** CreateTenantPaymentAccountDto */
export interface CreateTenantPaymentAccountDto {
  /**
   * Required for ACH accounts
   * @minLength 3
   * @maxLength 100
   */
  bankName?: string;
  /**
   * A valid 9-digit bank routing number.
   * @pattern ^[0-9]{9}$
   */
  routingNumber?: string;
  /**
   * A valid 4 to 17 digit account number.
   * @pattern ^[0-9]{4,17}$
   */
  accountNumber?: string;
  /** Required for ACH accounts */
  accountType?: BankRoutingType;
  /** Required for Stripe accounts */
  stripeSessionId?: string;
}

/** CreateUnitDto */
export interface CreateUnitDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  address?: RequiredAddressDto;
  /**
   * Value must be a double greater than or equal to 0 and evenly divisible by 0.5.
   * @format double
   * @min 0
   */
  beds?: number;
  /**
   * Value must be a double greater than or equal to 0 and evenly divisible by 0.5.
   * @format double
   * @min 0
   */
  baths?: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  unitSizeSqft?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  marketRent?: number;
  /**
   * @format int32
   * @min 1
   * @max 200
   */
  floor?: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * [DEPRECATED] Use ImageSessionId instead
   * @deprecated
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  imageId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  imageSessionId?: string;
  createUnitListing?: boolean;
  magicTags?: Record<string, string>;
}

/** CreateVendorBillDto */
export interface CreateVendorBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId: string;
  /** @default false */
  companyBill: boolean;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  reference?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /** @minItems 1 */
  lineItems: CreateVendorBillLineItemDto[];
}

/** CreateVendorBillLineItemDto */
export interface CreateVendorBillLineItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
}

/** CreateVendorPaymentAccountDto */
export interface CreateVendorPaymentAccountDto {
  /**
   * Required for ACH accounts
   * @minLength 3
   * @maxLength 100
   */
  bankName?: string;
  /**
   * A valid 9-digit bank routing number.
   * @pattern ^[0-9]{9}$
   */
  routingNumber?: string;
  /**
   * A valid 4 to 17 digit account number.
   * @pattern ^[0-9]{4,17}$
   */
  accountNumber?: string;
  /** Required for ACH accounts */
  accountType?: BankRoutingType;
  /** Required for Stripe accounts */
  stripeSessionId?: string;
}

/** CreateWorkOrderFromAssociationViolationDto */
export interface CreateWorkOrderFromAssociationViolationDto {
  vendorId?: string;
  permissionToEnter: boolean;
}

/** CreatorDto */
export interface CreatorDto {
  type: MagicUserType;
  id?: string;
  deleted?: boolean;
  source: CreationSource;
  /**
   * [DEPRECATED] Use Type = MagicUserType.PropertyManager and Id instead.
   * @deprecated
   */
  propertyManagerId?: string;
  /**
   * [DEPRECATED] Use Type = MagicUserType.Tenant and Id instead.
   * @deprecated
   */
  tenantId?: string;
  /**
   * [DEPRECATED] Use Type = MagicUserType.Vendor and Id instead.
   * @deprecated
   */
  vendorId?: string;
  /**
   * [DEPRECATED] Use Type = MagicUserType.Owner and Id instead.
   * @deprecated
   */
  ownerId?: string;
}

/** CreatorInfoDto */
export interface CreatorInfoDto {
  vendor?: VendorDto;
  tenant?: TenantDto;
  propertyManager?: PropertyManagerDto;
  owner?: OwnerDto;
}

/** CustomBooleanFieldOptionsDto */
export type CustomBooleanFieldOptionsDto = (UtilRequiredKeys<BaseCustomFieldOptionsDto, 'type'> & {
  default?: boolean;
}) & {
  type: 'boolean';
};

/** CustomDateTimeFieldOptionsDto */
export type CustomDateTimeFieldOptionsDto = (UtilRequiredKeys<BaseCustomFieldOptionsDto, 'type'> & {
  dateOnly?: boolean;
  /** @format date-time */
  min?: string;
  /** @format date-time */
  max?: string;
  /** @format date-time */
  default?: string;
}) & {
  type: 'datetime';
};

/** CustomFieldDefinitionDto */
export interface CustomFieldDefinitionDto {
  id: string;
  name: string;
  description: string;
}

/** CustomFieldDto */
export interface CustomFieldDto {
  id: string;
  entityType: EntityType;
  name: string;
  description?: string;
  public: boolean;
  filterable: boolean;
  listable: boolean;
  /** @format int32 */
  order: number;
  options:
    | CustomStringFieldOptionsDto
    | CustomNumberFieldOptionsDto
    | CustomBooleanFieldOptionsDto
    | CustomDateTimeFieldOptionsDto
    | CustomReferenceFieldOptionsDto;
  active: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** CustomFieldPaginationDto */
export interface CustomFieldPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: CustomFieldDto[];
}

/** CustomFieldValueDto */
export interface CustomFieldValueDto {
  customFieldId: string;
  entityType: EntityType;
  entityId: string;
  stringValue?: string;
  stringArray?: string[];
  /** @format double */
  numberValue?: number;
  booleanValue?: boolean;
  /** @format date-time */
  dateTimeValue?: string;
  referenceValue?: string;
  referenceArray?: string[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  referenceFiles?: FileDto[];
}

/** CustomNumberFieldOptionsDto */
export type CustomNumberFieldOptionsDto = (UtilRequiredKeys<BaseCustomFieldOptionsDto, 'type'> & {
  /**
   * @format int32
   * @min -2147483648
   * @max 2147483647
   */
  min?: number;
  /**
   * @format int32
   * @min -2147483648
   * @max 2147483647
   */
  max?: number;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  step?: number;
  /**
   * @format int32
   * @min -2147483648
   * @max 2147483647
   */
  default?: number;
}) & {
  type: 'number';
};

/** CustomReferenceFieldOptionsDto */
export type CustomReferenceFieldOptionsDto = (UtilRequiredKeys<BaseCustomFieldOptionsDto, 'type'> & {
  referenceEntityType: EntityType;
  multiple?: boolean;
}) & {
  type: 'reference';
};

/** CustomStringFieldOptionsDto */
export type CustomStringFieldOptionsDto = (UtilRequiredKeys<BaseCustomFieldOptionsDto, 'type'> & {
  multiple?: boolean;
  multiline?: boolean;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  maxLength?: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  minLength?: number;
  /**
   * @minLength 0
   * @maxLength 2000
   */
  default?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  values?: string[];
  rejectUnknown?: boolean;
}) & {
  type: 'string';
};

/** DataPathDto */
export interface DataPathDto {
  key: string;
  name: string;
  type: DataPathValueType;
  children?: DataPathDto[];
  text?: string;
}

/** DataPathsDto */
export interface DataPathsDto {
  dataPaths: DataPathDto[];
}

/** DateDto */
export interface DateDto {
  /** @format date */
  date: string;
}

/** DateOnlyRangeDto */
export interface DateOnlyRangeDto {
  /** @format date */
  start?: string;
  /** @format date */
  end?: string;
}

/** DateRangeDto */
export interface DateRangeDto {
  /** @format date */
  start?: string;
  /** @format date */
  end?: string;
}

/** DateTimeRangeDto */
export interface DateTimeRangeDto {
  /** @format date-time */
  start?: string;
  /** @format date-time */
  end?: string;
}

/** DeleteAssociationViolationRequestDto */
export interface DeleteAssociationViolationRequestDto {
  /** @default true */
  deleteBills: boolean;
}

/** DeleteChartOfAccountDto */
export interface DeleteChartOfAccountDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  replacementId: string;
}

/** DeleteCheckRequestDto */
export interface DeleteCheckRequestDto {
  deleteTransactions: boolean;
}

/** DeleteLeaseRecurringChargeDto */
export interface DeleteLeaseRecurringChargeDto {
  /** @default false */
  deletePostedCharges: boolean;
}

/** DeleteLeaseRecurringCreditDto */
export interface DeleteLeaseRecurringCreditDto {
  deleteAllCredits: boolean;
}

/** DeleteLeaseRecurringPaymentDto */
export interface DeleteLeaseRecurringPaymentDto {
  deleteAllPayments: boolean;
}

/** DeleteLeaseSubsidyDto */
export interface DeleteLeaseSubsidyDto {
  /** @default false */
  deleteRelatedRecords: boolean;
}

/** DeleteVendorBillDto */
export interface DeleteVendorBillDto {
  /**
   * Whether to adjust the bill's payments
   * @default true
   */
  adjustPayments?: boolean;
}

/** DeleteVendorBillFilesDto */
export interface DeleteVendorBillFilesDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 1
   */
  fileIds: string[];
}

/** DelinquencyAccountDto */
export interface DelinquencyAccountDto {
  chartOfAccountId: string;
  /** @format double */
  amount: number;
}

/** DelinquencyNoteDto */
export interface DelinquencyNoteDto {
  id: string;
  content: string;
  /** @format date-time */
  created: string;
}

/** DelinquencyReportDto */
export interface DelinquencyReportDto {
  groups: DelinquencyReportGroupDto[];
  metadata: DelinquencyReportMetadataDto;
  chartOfAccounts: ChartOfAccountDto[];
}

/** DelinquencyReportGroupDto */
export interface DelinquencyReportGroupDto {
  portfolio: PortfolioDto;
  property: PropertyDto;
  items: DelinquencyReportItemDto[];
  metadata: DelinquencyReportMetadataDto;
}

/** DelinquencyReportItemDto */
export interface DelinquencyReportItemDto {
  lease: LeaseDto;
  unit: UnitDto;
  tenants: LeaseWithTenantDto[];
  delinquencyNotes: DelinquencyNoteDto[];
  delinquencyAccounts: DelinquencyAccountDto[];
  /** @format int32 */
  delinquencyBillsCount: number;
}

/** DelinquencyReportMetadataDto */
export interface DelinquencyReportMetadataDto {
  /** @format double */
  totalDeposit: number;
  totalDelinquencyAccounts: DelinquencyAccountDto[];
  /** @format int32 */
  totalDelinquencyBills: number;
}

/** DisburseOwnerDistributionLineDto */
export interface DisburseOwnerDistributionLineDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @minLength 0
   * @maxLength 250
   */
  memo?: string;
}

/** DisburseOwnerDistributionsDto */
export interface DisburseOwnerDistributionsDto {
  /** @minItems 1 */
  groups: DisburseOwnerDistributionsGroupDto[];
}

/** DisburseOwnerDistributionsGroupDto */
export interface DisburseOwnerDistributionsGroupDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  ownerId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  cashChartOfAccountId: string;
  paymentType: PayoutMethod;
  /**
   * Applicable only for `PrintCheck` or `Manual` disbursements
   * @format date
   */
  distributionDate?: string;
  /** Required if payment type is `Manual` */
  paymentMethod?: TransactionPaymentMethod;
  /**
   * Required if payment type is `Manual`
   * @minLength 0
   * @maxLength 100
   */
  externalTransactionId?: string;
  /**
   * Required if payment type is `ACH`
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentMethodId?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  memo?: string;
  lines: DisburseOwnerDistributionLineDto[];
}

/** DisburseOwnerDistributionsResultDto */
export interface DisburseOwnerDistributionsResultDto {
  disbursements: OwnerDisbursementDto[];
  properties: PropertyDto[];
  checks?: HydratedCheckDto[];
}

/** DistributionValidatePropertiesDto */
export interface DistributionValidatePropertiesDto {
  propertyIds?: string[];
}

/** DistributionValidationDto */
export interface DistributionValidationDto {
  needsAttentionProperties: InvalidPropertyDto[];
  validProperties: ValidPropertyDto[];
  owners: OwnerDto[];
}

/** DriverLicenseDto */
export interface DriverLicenseDto {
  /**
   * @minLength 1
   * @maxLength 50
   */
  number?: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  state?: string;
}

/** EligibleDto */
export interface EligibleDto {
  eligible: boolean;
  reason?: string;
}

/** EmailDto */
export interface EmailDto {
  id: string;
  targets: HydratedEmailTargetDto[];
  /** @format date-time */
  sent: string;
  subject: string;
  body: string;
  template?: EmailTemplates;
  metadata?: Record<string, string>;
  files: FileDto[];
  propertyManager?: PropertyManagerDto;
}

/** EmailListDto */
export interface EmailListDto {
  id: string;
  subject: string;
  /** @format date-time */
  sent: string;
  body: string;
  template?: EmailTemplates;
  metadata?: Record<string, string>;
  targets: EmailTargetDto[];
  propertyManagerId?: string;
}

/** EmailTargetDto */
export interface EmailTargetDto {
  email: string;
  ownerId?: string;
  tenantId?: string;
  leaseId?: string;
  vendorId?: string;
}

/** EmailsDto */
export interface EmailsDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: EmailListDto[];
  owners: OwnerDto[];
  tenants: TenantDto[];
  leases: LeaseDto[];
  vendors: VendorDto[];
  propertyManagers: PropertyManagerDto[];
}

/** EmergencyContactDto */
export interface EmergencyContactDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * A valid email address.
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  relationship?: string;
}

/** EntityCustomFieldDto */
export interface EntityCustomFieldDto {
  id: string;
  name: string;
  description?: string;
  public: boolean;
  filterable: boolean;
  listable: boolean;
  /** @format int32 */
  order: number;
  options:
    | CustomStringFieldOptionsDto
    | CustomNumberFieldOptionsDto
    | CustomBooleanFieldOptionsDto
    | CustomDateTimeFieldOptionsDto
    | CustomReferenceFieldOptionsDto;
  value?: CustomFieldValueDto;
}

/** EntityCustomFieldsDto */
export interface EntityCustomFieldsDto {
  customFields: EntityCustomFieldDto[];
}

/** EstimateOwnerDistributionAchArrivalTimesDto */
export interface EstimateOwnerDistributionAchArrivalTimesDto {
  /** @minItems 1 */
  groups: EstimateOwnerDistributionAchGroupDto[];
  /** @format date-time */
  baseDateTime?: string;
}

/** EstimateOwnerDistributionAchArrivalTimesResultDto */
export interface EstimateOwnerDistributionAchArrivalTimesResultDto {
  groups: EstimateOwnerDistributionAchPaymentGroupDto[];
}

/** EstimateOwnerDistributionAchGroupDto */
export interface EstimateOwnerDistributionAchGroupDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId: string;
  /** @minItems 1 */
  payments: EstimateOwnerDistributionAchItemDto[];
}

/** EstimateOwnerDistributionAchItemDto */
export interface EstimateOwnerDistributionAchItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentAccountId: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
}

/** EstimateOwnerDistributionAchPaymentDto */
export interface EstimateOwnerDistributionAchPaymentDto {
  paymentAccountId: string;
  /** @format double */
  amount: number;
  /** @format date-time */
  estimatedArrivalDate: string;
  /** @format date-time */
  estimatedDepositDate?: string;
  willBeScheduled: boolean;
}

/** EstimateOwnerDistributionAchPaymentGroupDto */
export interface EstimateOwnerDistributionAchPaymentGroupDto {
  bankAccountId: string;
  /** @format double */
  availableBalance: number;
  payments: EstimateOwnerDistributionAchPaymentDto[];
}

/** EstimateVendorBillAchArrivalTimesDto */
export interface EstimateVendorBillAchArrivalTimesDto {
  /** @minItems 1 */
  groups: EstimateVendorBillAchGroupDto[];
  /** @format date-time */
  baseDateTime?: string;
}

/** EstimateVendorBillAchArrivalTimesResultDto */
export interface EstimateVendorBillAchArrivalTimesResultDto {
  groups: EstimatedAchPaymentGroupDto[];
}

/** EstimateVendorBillAchGroupDto */
export interface EstimateVendorBillAchGroupDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId: string;
  /** @minItems 1 */
  payments: EstimateVendorBillAchItemDto[];
}

/** EstimateVendorBillAchItemDto */
export interface EstimateVendorBillAchItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentAccountId: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
}

/** EstimateVendorBillAchPaymentDto */
export interface EstimateVendorBillAchPaymentDto {
  paymentAccountId: string;
  /** @format double */
  amount: number;
  /** @format date-time */
  estimatedArrivalDate: string;
  /** @format date-time */
  estimatedDepositDate?: string;
  willBeScheduled: boolean;
}

/** EstimatedAchPaymentGroupDto */
export interface EstimatedAchPaymentGroupDto {
  bankAccountId: string;
  /** @format double */
  availableBalance: number;
  payments: EstimateVendorBillAchPaymentDto[];
}

/** ExpiringLeaseCounts */
export interface ExpiringLeaseCounts {
  /** @format int32 */
  lessThanOneMonth: number;
  /** @format int32 */
  oneToTwoMonths: number;
  /** @format int32 */
  twoToThreeMonths: number;
  /** @format int32 */
  moreThanThreeMonths: number;
  /** @format int32 */
  total: number;
}

/** FailedOwnerDistributionAchResultDto */
export interface FailedOwnerDistributionAchResultDto {
  owner: OwnerDto;
  bankAccount: BankAccountDto;
  transaction: TransactionItemDto;
  properties: OwnerDistributionPropertyResultDto[];
  failureReason: StartOutgoingAchFailure;
}

/** FailedVendorBillResultDto */
export interface FailedVendorBillResultDto {
  vendor: VendorDto;
  bankAccount: BankAccountDto;
  transaction: TransactionItemDto;
  payments: VendorBillPaymentResultDto[];
  failureReason: StartOutgoingAchFailure;
}

/** FeatureHighlightDto */
export interface FeatureHighlightDto {
  id: string;
  path: string;
  title: string;
  description: string;
  /** @format date-time */
  startDate: string;
}

/** FeatureHighlightsDto */
export interface FeatureHighlightsDto {
  items: FeatureHighlightDto[];
}

/** FederalTaxInformationDto */
export interface FederalTaxInformationDto {
  taxIdType: IdentificationType;
  /**
   * @minLength 1
   * @maxLength 200
   */
  taxId: string;
  overwriteAddress?: AddressDto;
  /**
   * @minLength 1
   * @maxLength 150
   */
  overwriteName?: string;
}

/** FileAttachmentDto */
export interface FileAttachmentDto {
  id: string;
  fileName: string;
  description?: string;
  /** @format date-time */
  created: string;
  uploaderName?: string;
  uploaderType?: string;
  shareTypes: string[];
  relationType: EntityType;
  relationId: string;
  file: FileDto;
  /**
   * [DEPRECATED] Use File.Id instead.
   * @deprecated
   */
  fileId: string;
  /**
   * [DEPRECATED] Use File.SecureUrl.Raw instead.
   * @deprecated
   */
  fileUrl: string;
  /**
   * [DEPRECATED] Use File.SecureUrl.VariantTemplate instead.
   * @deprecated
   */
  fileThumbUrl?: string;
  /**
   * [DEPRECATED] Use File.Size instead.
   * @deprecated
   * @format int32
   */
  fileSizeBytes: number;
  /**
   * [DEPRECATED] Use RelationId + RelationType instead.
   * @deprecated
   */
  propertyId?: string;
  /**
   * [DEPRECATED] Use RelationId + RelationType instead.
   * @deprecated
   */
  leaseId?: string;
}

/** FileDto */
export interface FileDto {
  id: string;
  /** @format date-time */
  created: string;
  name: string;
  extension: string;
  /** @format int32 */
  size: number;
  contentType: string;
  secureUrl: FileUrlDto;
  /**
   * [DEPRECATED] Use Id instead.
   * @deprecated
   */
  fileId: string;
  /**
   * [DEPRECATED] Use Name instead.
   * @deprecated
   */
  fileName: string;
  /**
   * [DEPRECATED] Use SecureUrl instead.
   * @deprecated
   */
  signedUrl: string;
  /**
   * [DEPRECATED] Use SecureUrl instead.
   * @deprecated
   */
  signedThumbUrl?: string;
  /**
   * [DEPRECATED] Use Size instead.
   * @deprecated
   * @format int32
   */
  fileSize: number;
  /**
   * [DEPRECATED] Use Created instead.
   * @deprecated
   * @format date-time
   */
  uploaded: string;
  /**
   * [DEPRECATED] Debug purpose only, Do not use in production.
   * @deprecated
   */
  claimed: boolean;
}

/** FileUrlDto */
export interface FileUrlDto {
  base: string;
  raw: string;
  variantTemplate: string;
  /** @format date-time */
  expires?: string;
}

/** GeneralLedgerReportDataDto */
export interface GeneralLedgerReportDataDto {
  properties: PropertyDto[];
  vendors: VendorDto[];
  tenants: TenantDto[];
  chartOfAccounts: ChartOfAccountReportDto[];
}

/** GetAnnouncementTargetsRequestDto */
export interface GetAnnouncementTargetsRequestDto {
  targetType: TargetType;
  /** Applicable only for Lease targets */
  includeEnded?: boolean;
  /** Applicable only for Tenant targets */
  hasActiveLease?: boolean;
  /** Applicable only for Tenant targets */
  hasLeaseWithoutPaymentMethod?: boolean;
  /** Applicable only for Tenant targets */
  hasNoPortalActivity?: boolean;
  /** Applicable only for Tenant or Lease targets */
  hasBalanceDue?: boolean;
  /**
   * Applicable only for Tenant or Lease or Owner targets
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioIds?: string[];
  /**
   * Applicable only for Tenant or Lease or Owner targets
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyIds?: string[];
  /**
   * Applicable only for Tenant or Lease targets
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitIds?: string[];
}

/** GetIrisSubmissionStatusRequestDto */
export interface GetIrisSubmissionStatusRequestDto {
  /** @format int32 */
  taxYear: number;
  vendorIds?: string[];
  ownerIds?: string[];
}

/** GetIrisSubmissionStatusResponseDto */
export interface GetIrisSubmissionStatusResponseDto {
  statuses: SubmissionStatusDto[];
}

/** HotpadsSyndicationStatusDto */
export interface HotpadsSyndicationStatusDto {
  status: SyndicationStatus;
  url: string;
}

/** HydratedAnnouncementDto */
export interface HydratedAnnouncementDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId: string;
  /** @format date-time */
  sentAt: string;
  chatMessage?: string;
  emailMessage?: string;
  /** @maxLength 250 */
  subject?: string;
  sendText: boolean;
  status: AnnouncementStatus;
  failureReason?: string;
  targets: HydratedAnnouncementTargetsDto;
  chatAttachments?: FileDto[];
  emailAttachments?: FileDto[];
}

/** HydratedAnnouncementPortfolioTargetsDto */
export interface HydratedAnnouncementPortfolioTargetsDto {
  portfolio: PortfolioDto;
  properties: HydratedAnnouncementPropertyTargetsDto[];
}

/** HydratedAnnouncementPropertyTargetsDto */
export interface HydratedAnnouncementPropertyTargetsDto {
  property: PropertyDto;
  units: HydratedAnnouncementUnitTargetsDto[];
}

/** HydratedAnnouncementTargetsDto */
export interface HydratedAnnouncementTargetsDto {
  portfolioTargets: HydratedAnnouncementPortfolioTargetsDto[];
  owners: AnnouncementTargetOwnerDto[];
  vendors: AnnouncementTargetVendorDto[];
  tenants: AnnouncementTargetTenantDto[];
  targetTypes: TargetType[];
}

/** HydratedAnnouncementUnitTargetsDto */
export interface HydratedAnnouncementUnitTargetsDto {
  unit: UnitDto;
  tenants: AnnouncementTargetTenantDto[];
  leases: AnnouncementTargetLeaseDto[];
  vendors: AnnouncementTargetVendorDto[];
  owners: AnnouncementTargetOwnerDto[];
}

/** HydratedBankAccountDto */
export interface HydratedBankAccountDto {
  id: string;
  name: string;
  description?: string;
  active: boolean;
  accountNumber?: string;
  routingNumber?: string;
  type?: BankAccountType;
  scheduledSweepDays: number[];
  chartOfAccountIds: string[];
  companyAccount: boolean;
  creator: CreatorDto;
  chartOfAccounts: ChartOfAccountDto[];
  connection: BankAccountConnectionDto;
  plaid?: PlaidConnectedStatusDto;
  stripe?: StripeConnectedStatusDto;
}

/** HydratedChatParticipantDto */
export interface HydratedChatParticipantDto {
  id: string;
  participantType: ChatParticipantType;
  accountId?: string;
  name?: string;
  phoneNumber?: string;
  email?: string;
  tenant?: TenantDto;
  active: boolean;
  profileImageId?: string;
  fullName?: string;
}

/** HydratedCheckDto */
export interface HydratedCheckDto {
  id: string;
  companyId: string;
  /** @format int32 */
  checkNumber: number;
  vendorId?: string;
  ownerId?: string;
  tenantId?: string;
  bankAccountId: string;
  /** @format double */
  amount: number;
  memo?: string;
  /** @format date-time */
  createdOn: string;
  /** @format date-time */
  date: string;
  transactionId?: string;
  billPayments: CheckBillPaymentDto[];
  dataHeaders: string[];
  voided: boolean;
  voidReason?: string;
  amountString: string;
  bankAccount: BankAccountDto;
  company: CompanyDto;
  vendor?: VendorDto;
  owner?: OwnerDto;
  tenant?: TenantDto;
  micrCode: string;
}

/** HydratedEmailTargetDto */
export interface HydratedEmailTargetDto {
  email: string;
  owner?: OwnerDto;
  tenants?: TenantDto[];
  lease?: LeaseDto;
  vendor?: VendorDto;
}

/** HydratedLeaseDocumentDto */
export interface HydratedLeaseDocumentDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  leaseId: string;
  leaseTemplateIds: string[];
  fileId: string;
  name: string;
  status: LeaseDocumentStatus;
  signers: LeaseDocumentSignerDto[];
  annotations: LeaseDocumentAnnotationDto[];
  type: LeaseDocumentType;
  file: FileDto;
}

/** HydratedLeaseDto */
export interface HydratedLeaseDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  ended: boolean;
  monthToMonth: boolean;
  eviction: boolean;
  chatId?: string;
  tenants: HydratedLeaseTenantDto[];
  /** @format double */
  balance: number;
  /** @format double */
  currentRent: number;
  /** @format double */
  securityDepositPaid: number;
  /** @format double */
  securityDepositRequested: number;
  /** @format double */
  securityDepositDue: number;
  /** @format date */
  lastPaymentDate?: string;
  /** @format date */
  earliestUnpaidBillDueDate?: string;
  icons: string[];
  /** @format date */
  moveOutDate?: string;
  draft: boolean;
  status: LeaseStatus;
  expiringStatus: ExpiringStatus;
  /** @format int32 */
  pastDueDays?: number;
  /** @format double */
  postedBalance: number;
  unit: UnitDto;
  property: PropertyDto;
  customFieldValues?: CustomFieldValueDto[];
}

/** HydratedLeaseDtoPaginationDto */
export interface HydratedLeaseDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedLeaseDto[];
}

/** HydratedLeasePaginationDto */
export interface HydratedLeasePaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedLeaseDto[];
  customFields: CustomFieldDto[];
}

/** HydratedLeaseTenantDto */
export interface HydratedLeaseTenantDto {
  tenant: TenantDto;
  /** @format date */
  moveIn: string;
  /** @format date */
  moveOut?: string;
  isMovedOut: boolean;
}

/** HydratedMagicChatDto */
export interface HydratedMagicChatDto {
  id: string;
  type: ChatTypes;
  typeKey: string;
  groupNumber?: string;
  participants: HydratedChatParticipantDto[];
  subject: string;
  participantLanguage: string;
  closed: boolean;
  /** @format date-time */
  created: string;
  latestMessageId?: string;
  /** @format date-time */
  lastMessageSentAt?: string;
  /** @format int32 */
  messageCount: number;
  latestMessage?: ChatMessageDto;
  lease?: LeaseDto;
  /** @format int32 */
  unreadMessages: number;
  propertyType?: PropertyType;
  unitId?: string;
  unitImageId?: string;
  propertyId?: string;
  propertyImageId?: string;
  assignedPropertyManager?: PropertyManagerDto;
  assignedByPropertyManager?: PropertyManagerDto;
  /** @format date-time */
  assignedAt?: string;
  pinned: boolean;
  /** @format date-time */
  humanEngagementRequested?: string;
}

/** HydratedMagicChatsDto */
export interface HydratedMagicChatsDto {
  chats: HydratedMagicChatDto[];
}

/** HydratedNewOwnerDto */
export interface HydratedNewOwnerDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  isCompany: boolean;
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  chatId?: string;
  language: string;
  icons: string[];
  address?: AddressDto;
  portalStatus: PortalStatus;
  ownerProperties: OwnerPropertyDto[];
  customFieldValues?: CustomFieldValueDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  paymentAccounts: PaymentAccountDto[];
  password: string;
}

/** HydratedOwnerDto */
export interface HydratedOwnerDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  isCompany: boolean;
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  chatId?: string;
  language: string;
  icons: string[];
  address?: AddressDto;
  portalStatus: PortalStatus;
  ownerProperties: OwnerPropertyDto[];
  customFieldValues?: CustomFieldValueDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  paymentAccounts: PaymentAccountDto[];
}

/** HydratedOwnerListDto */
export interface HydratedOwnerListDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  isCompany: boolean;
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  chatId?: string;
  language: string;
  icons: string[];
  address?: AddressDto;
  portalStatus: PortalStatus;
  ownerProperties: OwnerPropertyDto[];
  customFieldValues?: CustomFieldValueDto[];
}

/** HydratedOwnerListPaginationDto */
export interface HydratedOwnerListPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedOwnerListDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  customFields: CustomFieldDto[];
}

/** HydratedOwnerPropertyDto */
export interface HydratedOwnerPropertyDto {
  owner: OwnerDto;
  property: PropertyDto;
  portfolio: PortfolioDto;
  /** @format double */
  ownershipPercentage: number;
}

/** HydratedPortfolioDto */
export interface HydratedPortfolioDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  active: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /** @format int32 */
  propertyCount: number;
  icons: string[];
  /** @format int32 */
  activePropertyCount: number;
  properties: HydratedPortfolioPropertyDto[];
}

/** HydratedPortfolioPropertyDto */
export interface HydratedPortfolioPropertyDto {
  id: string;
  name?: string;
  displayName: string;
  address?: AddressDto;
  portfolioId: string;
  type: PropertyType;
  /** @format int32 */
  totalFloors?: number;
  /** @format int32 */
  unitCount: number;
  /** @format int32 */
  recentRentalApplications: number;
  active: boolean;
  imageId?: string;
  icons: string[];
  magicTags?: Record<string, string>;
  /** @format int32 */
  activeUnitCount: number;
}

/** HydratedPropertyDto */
export interface HydratedPropertyDto {
  id: string;
  name?: string;
  displayName: string;
  address?: AddressDto;
  portfolioId: string;
  type: PropertyType;
  /** @format int32 */
  totalFloors?: number;
  /** @format int32 */
  unitCount: number;
  /** @format int32 */
  recentRentalApplications: number;
  active: boolean;
  imageId?: string;
  icons: string[];
  magicTags?: Record<string, string>;
  image?: FileDto;
  portfolio: PortfolioDto;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  totalRent: number;
  /** @format double */
  currentBalance: number;
  /** @format double */
  postedBalance: number;
  /** @format double */
  totalDeposit: number;
  /** @format int32 */
  occupiedUnits: number;
  /** @format int32 */
  activeUnits: number;
  /** @format int32 */
  emptyUnits: number;
  owners: HydratedPropertyOwnerDto[];
  defaultUnit?: UnitDto;
  customFieldValues?: CustomFieldValueDto[];
}

/** HydratedPropertyOwnerDto */
export interface HydratedPropertyOwnerDto {
  owner: OwnerDto;
  /** @format double */
  ownershipPercentage: number;
}

/** HydratedPropertyPaginationDto */
export interface HydratedPropertyPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedPropertyDto[];
  customFields: CustomFieldDto[];
}

/** HydratedTenantDto */
export interface HydratedTenantDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons: string[];
  imageId?: string;
  primaryLeaseId?: string;
  currentLeases?: LeaseDto[];
  customFieldValues?: CustomFieldValueDto[];
  properties?: PropertyDto[];
  units?: UnitDto[];
}

/** HydratedTenantListDto */
export interface HydratedTenantListDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons: string[];
  imageId?: string;
  primaryLeaseId?: string;
  currentLeases?: LeaseDto[];
  customFieldValues?: CustomFieldValueDto[];
}

/** HydratedTenantListPaginationDto */
export interface HydratedTenantListPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedTenantListDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  customFields: CustomFieldDto[];
}

/** HydratedUnitDto */
export interface HydratedUnitDto {
  id: string;
  name: string;
  address?: AddressDto;
  /** @format double */
  beds?: number;
  /** @format double */
  baths?: number;
  /** @format int32 */
  unitSizeSqft?: number;
  /** @format double */
  marketRent?: number;
  /** @format int32 */
  floor?: number;
  propertyId: string;
  portfolioId: string;
  active: boolean;
  imageId?: string;
  icons: string[];
  magicTags?: Record<string, string>;
  image?: FileDto;
  property: PropertyDto;
  activeLeases: LeaseDto[];
  /** @format double */
  postedBalance: number;
  singleLineAddress?: string;
  /** @format int32 */
  recentRentalApplications: number;
  latestRentalApplicationId?: string;
  customFieldValues?: CustomFieldValueDto[];
}

/** HydratedUnitListingDto */
export interface HydratedUnitListingDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  status: UnitListingStatus;
  /** @format double */
  rentalPrice?: number;
  /** @format double */
  securityDeposit?: number;
  /** @format date */
  availableFrom?: string;
  leaseTerm?: LeaseTerm;
  title?: string;
  /** @format date */
  listed?: string;
  /** @format date-time */
  updated: string;
  pinned: boolean;
  primaryImage?: UnitListingImageDto;
  primaryVideo?: UnitListingVideoDto;
  propertyType?: PropertyType;
  singleLineAddress?: string;
  /** @format int32 */
  recentRentalApplications?: number;
  description?: string;
  descriptionTranslations?: TranslationDto[];
  images?: UnitListingImageDto[];
  videos?: UnitListingVideoDto[];
  tags?: string[];
  petPolicy?: PetPolicyDto;
  amenities?: AmenityDto[];
  locationAnalysis?: string;
  terms?: Record<string, string>;
  unit: UnitDto;
  portfolio: PortfolioDto;
  property: PropertyDto;
  /** Reasons why the unit listing cannot be listed, null if it can be listed */
  canNotBeListedReasons?: Record<string, string>;
}

/** HydratedUnitPaginationDto */
export interface HydratedUnitPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedUnitDto[];
  customFields: CustomFieldDto[];
}

/** HydratedVendorDto */
export interface HydratedVendorDto {
  id: string;
  name: string;
  language: string;
  contact: ContactDto;
  memo?: string;
  active: boolean;
  website?: string;
  irs1099Form?: FederalTaxInformationDto;
  insurancePolicy?: InsurancePolicyDto;
  chatId?: string;
  icons: string[];
  type: VendorType;
  defaultMemo?: string;
  paymentSettings: PaymentSettingsDto;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  paymentAccounts: PaymentAccountDto[];
  customFieldValues?: CustomFieldValueDto[];
}

/** HydratedWorkOrderDto */
export interface HydratedWorkOrderDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chatId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  groupChatId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  assignedPropertyManagerId?: string;
  reference: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  maintenanceRequestId?: string;
  status: WorkOrderStatus;
  /**
   * @minLength 1
   * @maxLength 150
   */
  title: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string;
  /** @format date */
  dueDate?: string;
  urgency: Urgency;
  /** @minLength 1 */
  description: string;
  internalDescription?: string;
  permissionToEnter: boolean;
  portfolio: PortfolioDto;
  property: PropertyDto;
  unit?: UnitDto;
  lease?: LeaseDto;
  vendor?: VendorDto;
  maintenanceRequest?: MaintenanceRequestListDto;
  assignedPropertyManager?: PropertyManagerDto;
  bills?: WorkOrderBillDto[];
  files: WorkOrderFileDto[];
  chartOfAccounts: ChartOfAccountDto[];
  owners: PropertyOwnerDto[];
  /** @format double */
  ownerApprovalLimit?: number;
  tenants: TenantDto[];
}

/** ImportUnitListingDto */
export interface ImportUnitListingDto {
  unitListingIds: string[];
}

/** ImportUnitListingRequestDto */
export interface ImportUnitListingRequestDto {
  portfolioIds?: string[];
  propertyIds?: string[];
  unitIds?: string[];
}

/** IncomeExpense */
export interface IncomeExpense {
  /** @format double */
  income: number;
  /** @format double */
  expense: number;
  /** @format double */
  net: number;
}

/** IncomeStatementDto */
export interface IncomeStatementDto {
  groupHeaders: ReportGroupHeader[];
  income: AccountReportLineDto[];
  expenses: AccountReportLineDto[];
  totalIncome: Record<string, number>;
  totalExpense: Record<string, number>;
  otherIncome: AccountReportLineDto[];
  otherExpenses: AccountReportLineDto[];
  totalOtherIncome: Record<string, number>;
  totalOtherExpense: Record<string, number>;
  netOperatingIncome: Record<string, number>;
  netOtherIncome: Record<string, number>;
  netIncome: Record<string, number>;
}

/** InsurancePolicyDto */
export interface InsurancePolicyDto {
  /**
   * @minLength 1
   * @maxLength 200
   */
  policyNumber: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  provider?: string;
  /** @format date */
  expirationDate?: string;
}

/** IntRangeDto */
export interface IntRangeDto {
  /** @format int32 */
  from?: number;
  /** @format int32 */
  to?: number;
  includeFrom?: boolean;
  includeTo?: boolean;
}

/** InvalidPropertyDto */
export interface InvalidPropertyDto {
  property: PropertyDto;
  isMissingOwnerInformation: boolean;
  owners: PropertyOwnerIdDto[];
  /** @format double */
  calculatedOwnershipPercentage: number;
}

/** InventoryReportDto */
export interface InventoryReportDto {
  portfolios: InventoryReportPortfolioDto[];
}

/** InventoryReportPortfolioDto */
export interface InventoryReportPortfolioDto {
  id: string;
  name: string;
  properties: InventoryReportPropertyDto[];
}

/** InventoryReportPropertyDto */
export interface InventoryReportPropertyDto {
  id: string;
  name: string;
  address: string;
  units: InventoryReportUnitDto[];
}

/** InventoryReportUnitDto */
export interface InventoryReportUnitDto {
  id: string;
  name: string;
}

/** IrisCorrectionOverrideDto */
export interface IrisCorrectionOverrideDto {
  accountType: TaxDocumentAccountType;
  /** @format int64 */
  accountId: string;
  recipientTin?: string;
  recipientTinType?: IdentificationType;
  recipientName?: string;
  recipientAddressLine1?: string;
  recipientAddressLine2?: string;
  recipientCity?: string;
  recipientState?: string;
  recipientZipCode?: string;
  /** @format double */
  amount?: number;
  /** @format double */
  federalIncomeTaxWithheld?: number;
}

/** LateFeesReportChargeDto */
export interface LateFeesReportChargeDto {
  id: string;
  source: LateFeesReportChargeSource;
  /** @format date-time */
  billDate: string;
  /** @format date-time */
  dueDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
}

/** LateFeesReportDto */
export interface LateFeesReportDto {
  groups: LateFeesReportGroupDto[];
  metadata: LateFeesReportMetadataDto;
}

/** LateFeesReportGroupDto */
export interface LateFeesReportGroupDto {
  portfolio: PortfolioDto;
  property: PropertyDto;
  items: LateFeesReportItemDto[];
}

/** LateFeesReportItemDto */
export interface LateFeesReportItemDto {
  lease: LeaseDto;
  unit: UnitDto;
  tenants: LateFeesReportItemTenantDto[];
  lateFees: LateFeesReportChargeDto[];
}

/** LateFeesReportItemTenantDto */
export interface LateFeesReportItemTenantDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons: string[];
  imageId?: string;
  /** @format date */
  moveInDate: string;
  /** @format date */
  moveOutDate?: string;
}

/** LateFeesReportMetadataDto */
export interface LateFeesReportMetadataDto {
  /** @format int32 */
  totalLateFees: number;
  /** @format double */
  totalAmount: number;
  /** @format double */
  totalDueAmount: number;
  /** @format double */
  totalAllocatedAmount: number;
}

/** LatePaymentCountConditionDto */
export type LatePaymentCountConditionDto = (UtilRequiredKeys<BaseConditionDto, 'type'> & {
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  count: number;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  lookbackPeriod: number;
  lookbackPeriodUnit: TimePeriod;
}) & {
  type: 'LatePaymentCount';
};

/** LeaseBalanceConditionDto */
export type LeaseBalanceConditionDto = (UtilRequiredKeys<BaseConditionDto, 'type'> & {
  /** @format double */
  amount: number;
}) & {
  type: 'LeaseBalance';
};

/** LeaseChargeAllocationDto */
export interface LeaseChargeAllocationDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  transactionId: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  /** @format date-time */
  applied: string;
  /** Timestamp when this allocation was voided (e.g., due to transaction failure). */
  payout?: PayoutInfoDto;
}

/** LeaseChargeCreditDto */
export interface LeaseChargeCreditDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  bankAccountId: string;
  chartOfAccountId: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  leaseId: string;
  /** @format double */
  amount: number;
  /** @format double */
  appliedAmount: number;
  /** @format double */
  availableAmount: number;
  /** @format date */
  creditDate: string;
  appliedLeaseCharges: AppliedLeaseChargeDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  bankAccount: BankAccountDto;
  chartOfAccount: ChartOfAccountDto;
  portfolio: PortfolioDto;
  property: PropertyDto;
  unit: UnitDto;
  lease: LeaseDto;
  leaseCharges: LeaseChargeItemDto[];
}

/** LeaseChargeDto */
export interface LeaseChargeDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  companyCharge: boolean;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
  reference?: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  leaseId: string;
  recurringChargeId?: string;
  leaseSubsidyId?: string;
  lineItems: LeaseChargeLineItemDto[];
  files: LeaseChargeFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  portfolio: PortfolioDto;
  property: PropertyDto;
  unit: UnitDto;
  lease: LeaseDto;
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  hydratedFiles: FileDto[];
  creatorInfo: CreatorInfoDto;
}

/** LeaseChargeFileDto */
export interface LeaseChargeFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** LeaseChargeItemDto */
export interface LeaseChargeItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  companyCharge: boolean;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
  reference?: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  leaseId: string;
  recurringChargeId?: string;
  leaseSubsidyId?: string;
  lineItems: LeaseChargeLineItemDto[];
  files: LeaseChargeFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
}

/** LeaseChargeLedgerDto */
export interface LeaseChargeLedgerDto {
  /** @format double */
  currentBalance: number;
  /** @format double */
  postedBalance: number;
  /** @format double */
  currentlyProcessingIn: number;
  /** @format double */
  currentlyProcessingOut: number;
  /** @format double */
  creditIssued: number;
  /** @format double */
  creditApplied: number;
  /** @format double */
  creditAvailable: number;
  /** @format date */
  lastPaymentDate?: string;
  /** @format date */
  earliestUnpaidChargeDueDate?: string;
  entries: LeaseChargeLedgerEntryDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  tenants: TenantDto[];
  subsidizers: SubsidizerItemDto[];
}

/** LeaseChargeLedgerEntryDto */
export interface LeaseChargeLedgerEntryDto {
  id: string;
  status: LeaseChargeLedgerEntryStatus;
  type: LeaseChargeLedgerEntryType;
  /** @format date */
  transactionDate: string;
  direction?: TransactionDirection;
  chartOfAccountIds: string[];
  companyCharge?: boolean;
  description?: string;
  /** @format double */
  amount: number;
  /** @format double */
  currentBalance: number;
  /** @format double */
  postedBalance: number;
  externalTransactionType?: ExternalTransactionType;
  externalTransactionId?: string;
}

/** LeaseChargeLineItemDto */
export interface LeaseChargeLineItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id?: string;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  order: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  allocations: LeaseChargeAllocationDto[];
  /**
   * Calculated allocated amount - read only
   * @format double
   */
  allocatedAmount: number;
  /**
   * Calculated due amount - read only
   * @format double
   */
  dueAmount: number;
}

/** LeaseChargeRequestDto */
export interface LeaseChargeRequestDto {
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
  companyCharge: boolean;
  chargeFrequency: ChargeFrequency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /** @format date */
  startFrom?: string;
}

/** LeaseDepositAllocationDto */
export interface LeaseDepositAllocationDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  transactionId: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  /** @format date-time */
  applied: string;
}

/** LeaseDepositDto */
export interface LeaseDepositDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
  reference?: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  leaseId: string;
  refundable: boolean;
  lineItems: LeaseDepositLineItemDto[];
  files: LeaseDepositFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  portfolio: PortfolioDto;
  property: PropertyDto;
  unit: UnitDto;
  lease: LeaseDto;
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  hydratedFiles: FileDto[];
  creatorInfo: CreatorInfoDto;
}

/** LeaseDepositFileDto */
export interface LeaseDepositFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** LeaseDepositLedgerDto */
export interface LeaseDepositLedgerDto {
  /** @format double */
  currentBalance: number;
  /** @format double */
  postedBalance: number;
  /** @format double */
  currentlyProcessingIn: number;
  /** @format double */
  currentlyProcessingOut: number;
  /** @format date */
  lastPaymentDate?: string;
  entries: LeaseDepositLedgerEntryDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  tenants: TenantDto[];
}

/** LeaseDepositLedgerEntryDto */
export interface LeaseDepositLedgerEntryDto {
  id: string;
  status: LeaseDepositTransactionStatus;
  type: LeaseDepositLedgerEntryType;
  /** @format date */
  transactionDate: string;
  direction?: TransactionDirection;
  chartOfAccountIds: string[];
  description?: string;
  /** @format double */
  amount: number;
  /** @format double */
  currentBalance: number;
  /** @format double */
  postedBalance: number;
  externalTransactionType?: ExternalTransactionType;
  externalTransactionId?: string;
}

/** LeaseDepositLineItemDto */
export interface LeaseDepositLineItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id?: string;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  order: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  allocations: LeaseDepositAllocationDto[];
  /**
   * Calculated allocated amount - read only
   * @format double
   */
  allocatedAmount: number;
  /**
   * Calculated due amount - read only
   * @format double
   */
  dueAmount: number;
}

/** LeaseDocumentAnnotationDto */
export interface LeaseDocumentAnnotationDto {
  /** @minLength 1 */
  id: string;
  signerId?: string;
  /**
   * @format int32
   * @min 1
   * @max 10000
   */
  page: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  x: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  y: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  width: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  height: number;
  /**
   * @format double
   * @min 1
   * @max 1000
   */
  fontSize: number;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  text?: string;
  type: LeaseDocumentAnnotationType;
  dataPath?: string;
  isInputField: boolean;
  isVisible?: boolean;
  isMandatory?: boolean;
}

/** LeaseDocumentDto */
export interface LeaseDocumentDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  leaseId: string;
  leaseTemplateIds: string[];
  fileId: string;
  name: string;
  status: LeaseDocumentStatus;
  signers: LeaseDocumentSignerDto[];
  annotations: LeaseDocumentAnnotationDto[];
  type: LeaseDocumentType;
}

/** LeaseDocumentSignatureDto */
export interface LeaseDocumentSignatureDto {
  /** @minLength 1 */
  destination: string;
  type: DestinationType;
  /** @format date-time */
  sentDate?: string;
  /** @format date-time */
  viewedDate?: string;
  /** @format date-time */
  signedDate?: string;
  signedIp?: string;
}

/** LeaseDocumentSignerDto */
export interface LeaseDocumentSignerDto {
  /** @minLength 1 */
  id: string;
  /**
   * @minLength 2
   * @maxLength 100
   */
  name: string;
  type: LeaseDocumentSignerType;
  signatureStatus: StatusType;
  /** @minLength 1 */
  signatureName: string;
  /** @minLength 1 */
  signatureInitials: string;
  emailSignature?: LeaseDocumentSignatureDto;
  textSignature?: LeaseDocumentSignatureDto;
}

/** LeaseDto */
export interface LeaseDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  ended: boolean;
  monthToMonth: boolean;
  eviction: boolean;
  chatId?: string;
  tenants: LeaseTenantDto[];
  /** @format double */
  balance: number;
  /** @format double */
  currentRent: number;
  /** @format double */
  securityDepositPaid: number;
  /** @format double */
  securityDepositRequested: number;
  /** @format double */
  securityDepositDue: number;
  /** @format date */
  lastPaymentDate?: string;
  /** @format date */
  earliestUnpaidBillDueDate?: string;
  icons: string[];
  /** @format date */
  moveOutDate?: string;
  draft: boolean;
  status: LeaseStatus;
  expiringStatus: ExpiringStatus;
  /** @format int32 */
  pastDueDays?: number;
  /** @format double */
  postedBalance: number;
}

/** LeaseInvoiceDto */
export interface LeaseInvoiceDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  /** @format date-time */
  issueDate: string;
  /** @format date */
  dueDate: string;
  /** @minLength 1 */
  invoiceNumber: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  totalAmount: number;
  /** @format date-time */
  lastSent?: string;
}

/** LeaseLateFeeAllocationDto */
export interface LeaseLateFeeAllocationDto {
  id?: string;
  transactionId: string;
  /** @format double */
  amount: number;
  /** @format date-time */
  applied: string;
  payout?: PayoutInfoDto;
}

/** LeaseLateFeeDto */
export interface LeaseLateFeeDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  companyCharge: boolean;
  /** @format date-time */
  billDate: string;
  /** @format date-time */
  dueDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
  reference?: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  leaseId: string;
  lineItems: LeaseLateFeeLineItemDto[];
  files: LeaseLateFeeFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  portfolio: PortfolioDto;
  property: PropertyDto;
  unit: UnitDto;
  lease: LeaseDto;
  chartOfAccounts: ChartOfAccountDto[];
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  leaseCharges: LeaseChargeItemDto[];
  hydratedFiles: FileDto[];
  creatorInfo: CreatorInfoDto;
}

/** LeaseLateFeeFileDto */
export interface LeaseLateFeeFileDto {
  fileId: string;
  description?: string;
}

/** LeaseLateFeeLineItemDto */
export interface LeaseLateFeeLineItemDto {
  id?: string;
  /** @format int32 */
  order: number;
  chartOfAccountId: string;
  leaseChargeId: string;
  description?: string;
  /** @format double */
  amount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  allocations: LeaseLateFeeAllocationDto[];
}

/** LeaseMagicTagsLeaseDto */
export interface LeaseMagicTagsLeaseDto {
  lease: LeaseDto;
  tenants: TenantDto[];
  customFieldValues: CustomFieldValueDto[];
  property: PropertyDto;
  unit: UnitDto;
}

/** LeaseMagicTagsReportDto */
export interface LeaseMagicTagsReportDto {
  leases: LeaseMagicTagsLeaseDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  customFieldDefinitions: CustomFieldDefinitionDto[];
}

/** LeaseMoveOutRequestDto */
export interface LeaseMoveOutRequestDto {
  id: string;
  leaseId: string;
  status: LeaseMoveOutRequestStatus;
  /** @format date-time */
  moveOutDate: string;
  reason?: string;
  /** @format date-time */
  createdDate: string;
  tenant?: TenantDto;
}

/** LeaseNotificationTargetDto */
export type LeaseNotificationTargetDto = (UtilRequiredKeys<BaseNotificationTargetDto, 'type'> & {
  leaseIds?: string[];
}) & {
  type: 'Lease';
};

/** LeaseRenewalOfferAutomaticSettingDto */
export interface LeaseRenewalOfferAutomaticSettingDto {
  id: string;
  companyId: string;
  portfolioId?: string;
  propertyId?: string;
  creator: CreatorDto;
  /** @format int32 */
  addDaysBefore: number;
  /** @format double */
  rentIncrease: number;
  /** @format int32 */
  newLeaseLengthMonths: number;
  newRecurringCharges: NewRecurringChargeDto[];
  conditions: ConditionGroupDto[];
  sendTenantNotifyOnRenewal: boolean;
  templates: TemplateRefDto[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** LeaseRenewalOfferAutomaticSettingGroupsDto */
export interface LeaseRenewalOfferAutomaticSettingGroupsDto {
  global: LeaseRenewalOfferAutomaticSettingDto[];
  portfolio: PortfolioGroupDto[];
  property: PropertyGroupDto[];
}

/** LeaseRenewalOfferDto */
export interface LeaseRenewalOfferDto {
  id: string;
  status: LeaseRenewalStatus;
  requiresSigning: boolean;
  recurringChargeChanges: RecurringChargeChangeDto[];
  newRecurringCharges: NewRecurringChargeDto[];
  /** @format date */
  newEndDate?: string;
  customLeaseText?: string;
  leaseDocumentId?: string;
  finalized: boolean;
  /** @format date */
  offerExpires?: string;
  currentCharges: RecurringLeaseChargeDto[];
  chartOfAccounts: ChartOfAccountDto[];
  templates: TemplateRefDto[];
}

/** LeaseRenewalOfferItemDto */
export interface LeaseRenewalOfferItemDto {
  id: string;
  status: LeaseRenewalStatus;
  requiresSigning: boolean;
  recurringChargeChanges: RecurringChargeChangeDto[];
  newRecurringCharges: NewRecurringChargeDto[];
  /** @format date */
  newEndDate?: string;
  customLeaseText?: string;
  leaseDocumentId?: string;
  finalized: boolean;
  automaticallyCreated: boolean;
  /** @format date */
  offerExpires?: string;
  currentCharges: RecurringLeaseChargeDto[];
  templates: TemplateRefDto[];
  leaseId: string;
  propertyId: string;
  unitId: string;
}

/** LeaseRenewalOfferPaginationDto */
export interface LeaseRenewalOfferPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: LeaseRenewalOfferItemDto[];
  chartOfAccounts: ChartOfAccountDto[];
  leases: LeaseDto[];
  properties: PropertyDto[];
  units: UnitDto[];
}

/** LeaseRenewalOfferSummariesDto */
export interface LeaseRenewalOfferSummariesDto {
  offers: LeaseRenewalOfferSummaryDto[];
}

/** LeaseRenewalOfferSummaryDto */
export interface LeaseRenewalOfferSummaryDto {
  id: string;
  status: LeaseRenewalStatus;
  /** @format double */
  newRent: number;
  /** @format date */
  newEndDate?: string;
  month2Month: boolean;
  /** @format date */
  offerExpires?: string;
}

/** LeaseSubsidyDto */
export interface LeaseSubsidyDto {
  id: string;
  leaseId: string;
  ownerId?: string;
  unitId: string;
  propertyId: string;
  portfolioId: string;
  subsidizerId: string;
  chartOfAccountId: string;
  subsidyType: SubsidyType;
  voucherNumber?: string;
  description: string;
  /** @format double */
  amount: number;
  subsidyFrequency: ChargeFrequency;
  /** @format date */
  effectiveDate: string;
  /** @format date */
  endDate?: string;
  /** @format date-time */
  lastSubsidy?: string;
  /** @format date-time */
  nextSubsidy?: string;
  active: boolean;
  creator?: CreatorDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  owner?: OwnerDto;
  subsidizer: SubsidizerItemDto;
  chartOfAccount: ChartOfAccountDto;
  creatorInfo: CreatorInfoDto;
}

/** LeaseSubsidyItemDto */
export interface LeaseSubsidyItemDto {
  id: string;
  leaseId: string;
  ownerId?: string;
  unitId: string;
  propertyId: string;
  portfolioId: string;
  subsidizerId: string;
  chartOfAccountId: string;
  subsidyType: SubsidyType;
  voucherNumber?: string;
  description: string;
  /** @format double */
  amount: number;
  subsidyFrequency: ChargeFrequency;
  /** @format date */
  effectiveDate: string;
  /** @format date */
  endDate?: string;
  /** @format date-time */
  lastSubsidy?: string;
  /** @format date-time */
  nextSubsidy?: string;
  active: boolean;
  creator?: CreatorDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** LeaseSubsidyPaginationDto */
export interface LeaseSubsidyPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: LeaseSubsidyItemDto[];
  chartOfAccounts: ChartOfAccountDto[];
  subsidizers: SubsidizerItemDto[];
  propertyManagers: PropertyManagerDto[];
  tenants: TenantDto[];
  vendors: VendorDto[];
  owners: OwnerDto[];
}

/** LeaseTemplateCategoryDto */
export interface LeaseTemplateCategoryDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  isDefault: boolean;
}

/** LeaseTemplateDto */
export interface LeaseTemplateDto {
  id: string;
  leaseTemplateCategoryId: string;
  name: string;
  description?: string;
  signers: LeaseTemplateSignerDto[];
  annotations: LeaseDocumentAnnotationDto[];
  type: LeaseTemplateType;
  isDefault: boolean;
  file: FileDto;
  /**
   * [DEPRECATED] Use File.Id instead.
   * @deprecated
   */
  fileId: string;
  /**
   * [DEPRECATED] Use File.Name instead.
   * @deprecated
   */
  fileName: string;
  /**
   * [DEPRECATED] Use File.Extension instead.
   * @deprecated
   */
  fileExtension: string;
  /**
   * [DEPRECATED] Use File.SecureUrl.Raw instead.
   * @deprecated
   */
  signedUrl: string;
  /**
   * [DEPRECATED] Use File.ContentType instead.
   * @deprecated
   */
  contentType: string;
  /**
   * [DEPRECATED] Use File.Size instead.
   * @deprecated
   * @format int32
   */
  fileSize: number;
}

/** LeaseTemplateSignerDto */
export interface LeaseTemplateSignerDto {
  /** @minLength 1 */
  id: string;
  /**
   * @minLength 2
   * @maxLength 100
   */
  name: string;
  type: LeaseDocumentSignerType;
}

/** LeaseTenantDto */
export interface LeaseTenantDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId: string;
  /** @format date */
  moveIn: string;
  /** @format date */
  moveOut?: string;
}

/** LeaseTransactionReceiptDto */
export interface LeaseTransactionReceiptDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  transactionId: string;
  /** @minLength 1 */
  receiptNumber: string;
  /** @format date-time */
  issueDate: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  totalAmount: number;
  paymentMethod: TransactionPaymentMethod;
  reference?: string;
  /** @format date-time */
  transactionDate: string;
  /** @format date-time */
  transactionUpdated: string;
  /** @format date-time */
  lastSent?: string;
  file: FileDto;
}

/** LeaseUnpaidLedgerReportDto */
export interface LeaseUnpaidLedgerReportDto {
  lease: LeaseDto;
  property: PropertyDto;
  unit: UnitDto;
  tenants: TenantDto[];
  unpaidCharges: LeaseChargeItemDto[];
  chartOfAccounts: ChartOfAccountDto[];
}

/** LeaseWithTenantDto */
export interface LeaseWithTenantDto {
  lease: LeaseTenantDto;
  tenant: TenantDto;
}

/** LineItemReportDto */
export interface LineItemReportDto {
  propertyId?: string;
  tenantId?: string;
  vendorId?: string;
  /** @format date-time */
  date: string;
  transactionId?: string;
  paymentMethod?: TransactionPaymentMethod;
  /** @format double */
  debit?: number;
  /** @format double */
  credit?: number;
  /** @format double */
  balance: number;
  memo?: string;
  payeeOrPayerName: string;
  billId: string;
}

/** MagicChatTextRequestDto */
export interface MagicChatTextRequestDto {
  /** @minLength 1 */
  myText: string;
}

/** MagicChatTextResponseDto */
export interface MagicChatTextResponseDto {
  suggestedText?: string;
  failed: boolean;
}

/** MagicDoorBillCreditDto */
export interface MagicDoorBillCreditDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  memo?: string;
  bankAccountId: string;
  chartOfAccountId: string;
  /** @format double */
  amount: number;
  /** @format double */
  appliedAmount: number;
  /** @format double */
  availableAmount: number;
  /** @format date */
  creditDate: string;
  appliedMagicDoorBills: AppliedMagicDoorBillDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  bankAccount: BankAccountDto;
  chartOfAccount: ChartOfAccountDto;
  magicDoorBills: CompanyInvoiceItemDto[];
}

/** MagicDoorBillCreditItemDto */
export interface MagicDoorBillCreditItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  memo?: string;
  bankAccountId: string;
  chartOfAccountId: string;
  /** @format double */
  amount: number;
  /** @format double */
  appliedAmount: number;
  /** @format double */
  availableAmount: number;
  /** @format date */
  creditDate: string;
  appliedMagicDoorBills: AppliedMagicDoorBillDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
}

/** MagicDoorBillCreditPaginationDto */
export interface MagicDoorBillCreditPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: MagicDoorBillCreditItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  magicDoorBills: CompanyInvoiceItemDto[];
}

/** MaintenanceRequestCountConditionDto */
export type MaintenanceRequestCountConditionDto = (UtilRequiredKeys<BaseConditionDto, 'type'> & {
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  count: number;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  lookbackPeriod: number;
  lookbackPeriodUnit: TimePeriod;
}) & {
  type: 'MaintenanceRequestCount';
};

/** MaintenanceRequestListDto */
export interface MaintenanceRequestListDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  assignedPropertyManagerId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chatId?: string;
  /** @minLength 1 */
  title: string;
  status: MaintenanceRequestStatus;
  urgency: Urgency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  categoryId?: string;
  disableAi: boolean;
  /** @format int32 */
  aiUrgencyScore: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  lastUpdated: string;
  aiProcessed: boolean;
  newRequest: boolean;
}

/** ManagementFeeConfigUsedDto */
export interface ManagementFeeConfigUsedDto {
  feeType: ManagementFeeCalculationType;
  /** @format double */
  feePercentage: number;
  /** @format double */
  minimumFee: number;
  /** @format double */
  maximumFee?: number;
  applyMinimumFeeWhenNoRevenue: boolean;
  includedAccountIds: string[];
  excludedAccountIds: string[];
}

/** ManagementFeeCreditAllocationDto */
export interface ManagementFeeCreditAllocationDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  creditTransactionId: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
}

/** ManagementFeeCreditDto */
export interface ManagementFeeCreditDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  memo?: string;
  bankAccountId: string;
  chartOfAccountId: string;
  portfolioId: string;
  propertyId: string;
  /** @format double */
  amount: number;
  /** @format double */
  appliedAmount: number;
  /** @format double */
  availableAmount: number;
  /** @format date */
  creditDate: string;
  appliedManagementFees: AppliedManagementFeeDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  bankAccount: BankAccountDto;
  chartOfAccount: ChartOfAccountDto;
  portfolio: PortfolioDto;
  property: PropertyDto;
  managementFees: ManagementFeeItemDto[];
}

/** ManagementFeeCreditItemDto */
export interface ManagementFeeCreditItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  memo?: string;
  bankAccountId: string;
  chartOfAccountId: string;
  portfolioId: string;
  propertyId: string;
  /** @format double */
  amount: number;
  /** @format double */
  appliedAmount: number;
  /** @format double */
  availableAmount: number;
  /** @format date */
  creditDate: string;
  appliedManagementFees: AppliedManagementFeeDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
}

/** ManagementFeeCreditPaginationDto */
export interface ManagementFeeCreditPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: ManagementFeeCreditItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  managementFees: ManagementFeeItemDto[];
}

/** ManagementFeeDto */
export interface ManagementFeeDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date */
  chargeDate: string;
  /** @format date */
  periodStart: string;
  /** @format date */
  periodEnd: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  paidAmount: number;
  /** @format double */
  creditedAmount: number;
  /** @format double */
  outstandingAmount: number;
  memo?: string;
  reference?: string;
  companyVendorId: string;
  lineItems: ManagementFeeLineItemDto[];
  files: ManagementFeeFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  vendor: VendorDto;
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  hydratedFiles: FileDto[];
  creatorInfo: CreatorInfoDto;
}

/** ManagementFeeFileDto */
export interface ManagementFeeFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** ManagementFeeItemDto */
export interface ManagementFeeItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date */
  chargeDate: string;
  /** @format date */
  periodStart: string;
  /** @format date */
  periodEnd: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  paidAmount: number;
  /** @format double */
  creditedAmount: number;
  /** @format double */
  outstandingAmount: number;
  memo?: string;
  reference?: string;
  companyVendorId: string;
  lineItems: ManagementFeeLineItemDto[];
  files: ManagementFeeFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
}

/** ManagementFeeLineItemDto */
export interface ManagementFeeLineItemDto {
  id?: string;
  /** @format int32 */
  order: number;
  propertyChartOfAccountId: string;
  companyChartOfAccountId: string;
  portfolioId: string;
  propertyId: string;
  unitId?: string;
  leaseId?: string;
  description?: string;
  /** @format double */
  amount: number;
  credits: ManagementFeeCreditAllocationDto[];
  /** @format double */
  creditedAmount: number;
  payout?: PayoutInfoDto;
  /** @format double */
  paidAmount: number;
  /** @format double */
  outstandingAmount: number;
}

/** ManagementFeePaginationDto */
export interface ManagementFeePaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: ManagementFeeItemDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  chartOfAccounts: ChartOfAccountDto[];
}

/** ManagementFeePeriodDto */
export interface ManagementFeePeriodDto {
  property: PropertyDto;
  /** @format int32 */
  year: number;
  /** @format int32 */
  month: number;
  /** @format double */
  managementFee: number;
  /** @format double */
  idealFee: number;
  /** @format double */
  alreadyBilled: number;
  /** @format double */
  revenue: number;
  settings: ManagementFeeSettingsDto;
  configUsed: ManagementFeeConfigUsedDto;
  feeDateRange: DateTimeRangeDto;
  memo: string;
}

/** ManagementFeeSettingsDto */
export interface ManagementFeeSettingsDto {
  ignoreChartOfAccounts: string[];
  includeChartOfAccounts: string[];
  feeType: ManagementFeeType;
  /** @format double */
  feePercentage: number;
  /** @format double */
  minimumFee: number;
  /** @format double */
  maximumFee?: number;
  applyMinimumFeeWhenNoRevenue: boolean;
  managementFeePropertyChartOfAccountId: string;
  managementFeeCompanyChartOfAccountId: string;
  /** @format int32 */
  lookbackMonths: number;
}

/** ManagementFeesResultDto */
export interface ManagementFeesResultDto {
  /** @format date-time */
  calculateFeesUntil: string;
  periods: ManagementFeePeriodDto[];
  credits: ManagementFeeCreditItemDto[];
  /** Total available credit amount for each property, key is property id, value is total available credit amount */
  creditTotals: Record<string, number>;
}

/** MeetingScheduleDto */
export interface MeetingScheduleDto {
  id: string;
  source: MeetingScheduleSource;
  title: string;
  description?: string;
  link?: string;
  externalProvider?: string;
  externalIdentifier?: string;
  /** @format date-time */
  startTime: string;
  /** @format date-time */
  endTime: string;
  metadata?: Record<string, string>;
  /** @format date-time */
  cancelled?: string;
  cancellationReason?: string;
  status: MeetingScheduleStatus;
}

/** MeetingScheduleDtoPaginationDto */
export interface MeetingScheduleDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: MeetingScheduleDto[];
}

/** MergeLeaseDocumentFromTemplatesDto */
export interface MergeLeaseDocumentFromTemplatesDto {
  addSignaturePages?: boolean;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  /** @minItems 1 */
  refs: TemplateRefDto[];
  signerIds?: string[];
  propertyManagerIds?: string[];
}

/** MergeLeaseDocumentFromTemplatesResultDto */
export interface MergeLeaseDocumentFromTemplatesResultDto {
  pdf: string;
  annotations: LeaseDocumentAnnotationDto[];
}

/** MoveInDto */
export interface MoveInDto {
  /** @format date */
  moveIn?: string;
}

/** MovePropertyDto */
export interface MovePropertyDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
}

/** MoveUnitDto */
export interface MoveUnitDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
}

/** NewPropertyManagerDto */
export interface NewPropertyManagerDto {
  id: string;
  companyId: string;
  email: string;
  phone?: string;
  firstName: string;
  lastName?: string;
  active: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  lastSeen?: string;
  name: string;
  imageId?: string;
  image?: PropertyManagerImageDto;
  /** @minLength 1 */
  clearTextPassword: string;
}

/** NewRecurringChargeDto */
export interface NewRecurringChargeDto {
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
  chargeFrequency: ChargeFrequency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  description?: string;
  companyCharge: boolean;
}

/** NextCheckNumberDto */
export interface NextCheckNumberDto {
  /** @format int32 */
  nextCheckNumber: number;
}

/** NoteDto */
export interface NoteDto {
  id: string;
  content: string;
  /** @format date-time */
  createdAt: string;
  propertyManager: PropertyManagerDto;
  type: NoteType;
}

/** NoteListDto */
export interface NoteListDto {
  id: string;
  content: string;
  /** @format date-time */
  createdAt: string;
  propertyManager: PropertyManagerDto;
  type: NoteType;
}

/** NotePaginationDto */
export interface NotePaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: NoteListDto[];
}

/** NotificationScheduleDto */
export interface NotificationScheduleDto {
  id: string;
  announcementId?: string;
  source: NotificationSource;
  target: TenantNotificationTargetDto | LeaseNotificationTargetDto | OwnerNotificationTargetDto | VendorNotificationTargetDto;
  template: NotificationTemplateDto;
  /** @format date-time */
  time: string;
  /** @format date-time */
  sent?: string;
  status: NotificationStatus;
  failureReason?: string;
  /** @format date-time */
  created: string;
}

/** NotificationScheduleDtoPaginationDto */
export interface NotificationScheduleDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: NotificationScheduleDto[];
}

/** NotificationTemplateDto */
export interface NotificationTemplateDto {
  /**
   * @minLength 0
   * @maxLength 200
   */
  subject: string;
  /**
   * @minLength 0
   * @maxLength 20000
   */
  emailMessage?: string;
  /**
   * @minLength 0
   * @maxLength 2000
   */
  textMessage?: string;
}

/** OtpAuthDto */
export interface OtpAuthDto {
  /**
   * @minLength 1
   * @maxLength 64
   */
  requestId: string;
  /**
   * @minLength 6
   * @maxLength 6
   */
  otp: string;
}

/** OwnerContributionAllocationDto */
export interface OwnerContributionAllocationDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  transactionId: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  /** @format date-time */
  applied: string;
  /**
   * Timestamp when this allocation was voided (e.g., due to transaction failure).
   * @format date-time
   */
  voided?: string;
  /** Reason for voiding this allocation (e.g., 'Transaction failed', 'Payment declined'). */
  voidReason?: string;
}

/** OwnerContributionDto */
export interface OwnerContributionDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date */
  contributionDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
  reference?: string;
  ownerId: string;
  lineItems: OwnerContributionLineItemDto[];
  files: OwnerContributionFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  owner: OwnerDto;
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  hydratedFiles: FileDto[];
  creatorInfo: CreatorInfoDto;
}

/** OwnerContributionFileDto */
export interface OwnerContributionFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** OwnerContributionItemDto */
export interface OwnerContributionItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date */
  contributionDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
  reference?: string;
  ownerId: string;
  lineItems: OwnerContributionLineItemDto[];
  files: OwnerContributionFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
}

/** OwnerContributionLineItemDto */
export interface OwnerContributionLineItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id?: string;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  order: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  allocations: OwnerContributionAllocationDto[];
  /**
   * Calculated allocated amount - read only
   * @format double
   */
  allocatedAmount: number;
  /**
   * Calculated due amount - read only
   * @format double
   */
  dueAmount: number;
}

/** OwnerContributionPaginationDto */
export interface OwnerContributionPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: OwnerContributionItemDto[];
  owners: OwnerDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  propertyManagers: PropertyManagerDto[];
  tenants: TenantDto[];
  vendors: VendorDto[];
}

/** OwnerContributionRequestDto */
export interface OwnerContributionRequestDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  owner?: OwnerDto;
  property?: PropertyDto;
  /** @format double */
  amount: number;
  /** @format date */
  requestDate: string;
  /** @format date */
  dueDate?: string;
  memo?: string;
  status: OwnerContributionRequestStatus;
  ownerContributionId?: string;
}

/** OwnerContributionRequestPaginationDto */
export interface OwnerContributionRequestPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: OwnerContributionRequestDto[];
}

/** OwnerDirectoryReportBillDueDto */
export interface OwnerDirectoryReportBillDueDto {
  billId: string;
  vendorId: string;
  /** @format date-time */
  dueDate: string;
  description: string;
  /** @format double */
  amount: number;
  /** @format double */
  totalAmount: number;
}

/** OwnerDirectoryReportBillDueTotalDto */
export interface OwnerDirectoryReportBillDueTotalDto {
  /** @format double */
  amount: number;
}

/** OwnerDirectoryReportDto */
export interface OwnerDirectoryReportDto {
  items: OwnerDirectoryReportItemDto[];
}

/** OwnerDirectoryReportItemDto */
export interface OwnerDirectoryReportItemDto {
  owner: OwnerDto;
  properties: OwnerDirectoryReportItemPropertyDto[];
}

/** OwnerDirectoryReportItemPropertyDto */
export interface OwnerDirectoryReportItemPropertyDto {
  portfolio: PortfolioDto;
  property: PropertyDto;
  ownerProperty: OwnerPropertyDto;
}

/** OwnerDirectoryReportTransactionTotalDto */
export interface OwnerDirectoryReportTransactionTotalDto {
  /** @format double */
  cashIn: number;
  /** @format double */
  cashOut: number;
}

/** OwnerDisbursementDto */
export interface OwnerDisbursementDto {
  paymentType: PayoutMethod;
  status: PayoutStatus;
  owner: OwnerDto;
  bankAccount: BankAccountDto;
  transaction?: TransactionItemDto;
  distributions: OwnerDistributionItemDto[];
  failureMessage?: string;
  failureCode?: PayoutFailure;
}

/** OwnerDistributionAchResultsDto */
export interface OwnerDistributionAchResultsDto {
  successful: OwnerDistributionResultDto[];
  scheduled: OwnerDistributionResultDto[];
  failed: FailedOwnerDistributionAchResultDto[];
}

/** OwnerDistributionAllocationDto */
export interface OwnerDistributionAllocationDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  transactionId: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  /** @format date-time */
  applied: string;
  /**
   * Timestamp when this allocation was voided (e.g., due to transaction failure).
   * @format date-time
   */
  voided?: string;
  /** Reason for voiding this allocation (e.g., 'Transaction failed', 'Payment declined'). */
  voidReason?: string;
}

/** OwnerDistributionDto */
export interface OwnerDistributionDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date */
  distributionDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
  reference?: string;
  ownerId: string;
  isOwnerRequested: boolean;
  leaseSubsidyId?: string;
  lineItems: OwnerDistributionLineItemDto[];
  files: OwnerDistributionFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  owner: OwnerDto;
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  hydratedFiles: FileDto[];
  creatorInfo: CreatorInfoDto;
}

/** OwnerDistributionFileDto */
export interface OwnerDistributionFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** OwnerDistributionInfoDto */
export interface OwnerDistributionInfoDto {
  owner: OwnerDto;
  /** @format double */
  ownershipPercentage: number;
  /** @format double */
  distributionAmount: number;
  paymentAccounts: OwnerDistributionPaymentAccountDto[];
}

/** OwnerDistributionItemDto */
export interface OwnerDistributionItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date */
  distributionDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
  reference?: string;
  ownerId: string;
  isOwnerRequested: boolean;
  leaseSubsidyId?: string;
  lineItems: OwnerDistributionLineItemDto[];
  files: OwnerDistributionFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
}

/** OwnerDistributionLineItemDto */
export interface OwnerDistributionLineItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id?: string;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  order: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  allocations: OwnerDistributionAllocationDto[];
  /**
   * Calculated allocated amount - read only
   * @format double
   */
  allocatedAmount: number;
  /**
   * Calculated due amount - read only
   * @format double
   */
  dueAmount: number;
}

/** OwnerDistributionPaginationDto */
export interface OwnerDistributionPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: OwnerDistributionItemDto[];
  owners: OwnerDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  propertyManagers: PropertyManagerDto[];
  tenants: TenantDto[];
  vendors: VendorDto[];
}

/** OwnerDistributionPaymentAccountDto */
export interface OwnerDistributionPaymentAccountDto {
  id: string;
  name: string;
  accountMask?: string;
}

/** OwnerDistributionPrintCheckResultDto */
export interface OwnerDistributionPrintCheckResultDto {
  owner: OwnerDto;
  bankAccount: BankAccountDto;
  transaction: TransactionItemDto;
  properties: OwnerDistributionPropertyResultDto[];
  check: HydratedCheckDto;
}

/** OwnerDistributionPropertyResultDto */
export interface OwnerDistributionPropertyResultDto {
  property: PropertyDto;
  distribution: OwnerDistributionItemDto;
}

/** OwnerDistributionResultDto */
export interface OwnerDistributionResultDto {
  owner: OwnerDto;
  bankAccount: BankAccountDto;
  transaction: TransactionItemDto;
  properties: OwnerDistributionPropertyResultDto[];
}

/** OwnerDistributionsResultDto */
export interface OwnerDistributionsResultDto {
  manual: OwnerDistributionResultDto[];
  printCheck: OwnerDistributionPrintCheckResultDto[];
  ach: OwnerDistributionAchResultsDto;
}

/** OwnerDto */
export interface OwnerDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  isCompany: boolean;
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  chatId?: string;
  language: string;
  icons: string[];
  address?: AddressDto;
  portalStatus: PortalStatus;
}

/** OwnerNotificationTargetDto */
export type OwnerNotificationTargetDto = (UtilRequiredKeys<BaseNotificationTargetDto, 'type'> & {
  ownerIds?: string[];
}) & {
  type: 'Owner';
};

/** OwnerPortalInviteResponseDto */
export interface OwnerPortalInviteResponseDto {
  /** @minLength 1 */
  newPassword: string;
}

/** OwnerPropertyDto */
export interface OwnerPropertyDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  ownerId: string;
  /** @format double */
  ownershipPercentage: number;
}

/** OwnerStatementReportDto */
export interface OwnerStatementReportDto {
  owner: OwnerDto;
  dateRange: DateRangeDto;
  properties: OwnerStatementReportPropertyDto[];
  tenants: Record<string, TenantDto>;
  vendors: Record<string, VendorDto>;
  /** @format double */
  unsettledManagementFeesTotal: number;
  /** @format double */
  unsettledServiceBillsTotal: number;
}

/** OwnerStatementReportPropertyDto */
export interface OwnerStatementReportPropertyDto {
  /** @format double */
  beginningCash: number;
  /** @format double */
  cashIn: number;
  /** @format double */
  cashOut: number;
  /** @format double */
  ownerContributions: number;
  /** @format double */
  ownerDistributions: number;
  /** @format double */
  companyCredits: number;
  /** @format double */
  endingCash: number;
  /** @format double */
  unpaid: number;
  /** @format double */
  propertyReserve: number;
  /** @format double */
  netOwnerFunds: number;
  property: PropertyDto;
  portfolio: PortfolioDto;
  ownerProperty: OwnerPropertyDto;
  transactions: OwnerStatementReportTransactionDto[];
  transactionsTotal: OwnerDirectoryReportTransactionTotalDto;
  billsDue: OwnerDirectoryReportBillDueDto[];
  billsDueTotal: OwnerDirectoryReportBillDueTotalDto;
}

/** OwnerStatementReportTransactionDto */
export interface OwnerStatementReportTransactionDto {
  billId: string;
  chartOfAccountId: string;
  tenantId: string;
  vendorId: string;
  transactionId: string;
  /** @format date */
  paymentDate: string;
  payeeOrPayerName: string;
  chartOfAccountName: string;
  description: string;
  /** @format double */
  cashIn: number;
  /** @format double */
  cashOut: number;
  /** @format double */
  balance: number;
}

/** OwnerTaxAmountDto */
export interface OwnerTaxAmountDto {
  accountId: string;
  /** @format int32 */
  calendarYear: number;
  /** @format double */
  rentAmount: number;
  /** @format double */
  otherAmount: number;
  documentAlreadyExists: boolean;
  amountHasChanged: boolean;
  hasTaxId: boolean;
  owner: OwnerDto;
}

/** OwnerTaxDocumentAmountDto */
export interface OwnerTaxDocumentAmountDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  accountId: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  rentAmount: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  otherAmount: number;
}

/** OwnerTaxDocumentDto */
export interface OwnerTaxDocumentDto {
  id: string;
  /** @format int32 */
  calendarYear: number;
  entityName?: string;
  entityId?: string;
  /** @format double */
  amount: number;
  taxDocumentType: TaxType;
  documentName?: string;
  documentUrl?: string;
  status: ProcessStatus;
  taskErrorMessage?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  annotations?: TaxDocumentAnnotation[];
  irsStatus?: string;
  /** @format double */
  otherAmount: number;
}

/** OwnerTaxDocumentListDto */
export interface OwnerTaxDocumentListDto {
  id: string;
  /** @format int32 */
  calendarYear: number;
  entityName?: string;
  entityId?: string;
  /** @format double */
  amount: number;
  taxDocumentType: TaxType;
  documentName?: string;
  documentUrl?: string;
  status: ProcessStatus;
  taskErrorMessage?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  annotations?: TaxDocumentAnnotation[];
  irsStatus?: string;
  /** @format double */
  otherAmount: number;
}

/** OwnerTaxDocumentPaginationDto */
export interface OwnerTaxDocumentPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: OwnerTaxDocumentListDto[];
}

/** OwnerTransferAccountDto */
export interface OwnerTransferAccountDto {
  chartOfAccountId: string;
  portfolioId: string;
  propertyId: string;
  transactionId: string;
}

/** OwnerTransferDto */
export interface OwnerTransferDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date */
  transferDate: string;
  /** @format double */
  amount: number;
  memo?: string;
  reference?: string;
  ownerId: string;
  source: OwnerTransferAccountDto;
  destination: OwnerTransferAccountDto;
  files: OwnerTransferFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  owner: OwnerDto;
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  hydratedFiles: FileDto[];
  creatorInfo: CreatorInfoDto;
}

/** OwnerTransferFileDto */
export interface OwnerTransferFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** OwnerTransferItemDto */
export interface OwnerTransferItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date */
  transferDate: string;
  /** @format double */
  amount: number;
  memo?: string;
  reference?: string;
  ownerId: string;
  source: OwnerTransferAccountDto;
  destination: OwnerTransferAccountDto;
  files: OwnerTransferFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
}

/** OwnerTransferPaginationDto */
export interface OwnerTransferPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: OwnerTransferItemDto[];
  owners: OwnerDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  propertyManagers: PropertyManagerDto[];
  tenants: TenantDto[];
  vendors: VendorDto[];
}

/** PaginatedAssociationViolationListDto */
export interface PaginatedAssociationViolationListDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: AssociationViolationListDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  vendors: VendorDto[];
}

/** PaginatedChecksDto */
export interface PaginatedChecksDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: CheckDto[];
  bankAccounts: BankAccountDto[];
  vendors: VendorDto[];
  owners: OwnerDto[];
  tenants: TenantDto[];
}

/** PaginatedHydratedLeaseDocumentDto */
export interface PaginatedHydratedLeaseDocumentDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: LeaseDocumentDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  files: FileDto[];
}

/** PaginatedUnitListingDto */
export interface PaginatedUnitListingDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: UnitListingDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
}

/** ParsedLineItemDto */
export interface ParsedLineItemDto {
  description?: string;
  /** @format double */
  quantity?: number;
  /** @format double */
  unitPrice?: number;
  /** @format double */
  amount?: number;
}

/** ParsedVendorBillResultDto */
export interface ParsedVendorBillResultDto {
  success: boolean;
  suggestion?: ParsedVendorBillSuggestionDto;
  rawOcrText?: string;
  /** @format float */
  ocrConfidence: number;
  /** @format int32 */
  processingTimeMs: number;
  error?: string;
}

/** ParsedVendorBillSuggestionDto */
export interface ParsedVendorBillSuggestionDto {
  vendorName?: string;
  /** @format date */
  billDate?: string;
  /** @format date */
  dueDate?: string;
  /** @format double */
  totalAmount?: number;
  reference?: string;
  memo?: string;
  currency?: string;
  lineItems: ParsedLineItemDto[];
  /** @format double */
  confidence: number;
  additionalFields: Record<string, string>;
}

/** PasswordAuthDto */
export interface PasswordAuthDto {
  /**
   * [DEPRECATED] Use Username instead.
   * @deprecated
   */
  email?: string;
  /**
   * The login of the user, can be an email or phone number.
   * @minLength 1
   */
  username: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  password: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId?: string;
}

/** PayBillsResultsDto */
export interface PayBillsResultsDto {
  manual: VendorBillResultDto[];
  printCheck: VendorBillPrintCheckResultDto[];
  ach: VendorBillAchResultsDto;
  properties: PropertyDto[];
}

/** PayCompanyInvoiceDto */
export interface PayCompanyInvoiceDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentAccountId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentMethodId?: string;
  /**
   * @minLength 5
   * @maxLength 50
   */
  idempotencyKey?: string;
}

/** PayVendorBillsDto */
export interface PayVendorBillsDto {
  /** @format date */
  paymentDate?: string;
  /** @minItems 1 */
  groups: PayVendorBillsGroupDto[];
}

/** PayVendorBillsGroupDto */
export interface PayVendorBillsGroupDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  cashChartOfAccountId: string;
  paymentType: PayoutMethod;
  /** Required if payment type is `Manual` */
  paymentMethod?: TransactionPaymentMethod;
  /**
   * Required if payment type is `Manual`
   * @minLength 0
   * @maxLength 100
   */
  externalTransactionId?: string;
  /**
   * Required if payment type is `ACH`
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentAccountId?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  memo?: string;
  payments: VendorBillPaymentDto[];
}

/** PaymentAccountDto */
export interface PaymentAccountDto {
  id: string;
  name: string;
  accountMask?: string;
  accountProvider: PaymentAccountProvider;
  mapped: boolean;
  bankInformation?: BankRoutingDto;
  stripe?: StripePaymentAccountDto;
  plaid?: PlaidPaymentAccountDto;
}

/** PaymentAccountsDto */
export interface PaymentAccountsDto {
  paymentAccounts: PaymentAccountDto[];
}

/** PaymentSettingsDto */
export interface PaymentSettingsDto {
  onePaymentPerBill: boolean;
}

/** PayoutInfoDto */
export interface PayoutInfoDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyLedgerTransferId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  outTransactionId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  inTransactionId: string;
  /** @format date-time */
  paidDate: string;
}

/** PayoutResultsDto */
export interface PayoutResultsDto {
  payouts: CompanyPayoutDto[];
}

/** PetPolicyDto */
export interface PetPolicyDto {
  allowed?: boolean;
  policies?: {
    cat?: boolean;
    dog?: boolean;
    fish?: boolean;
    bird?: boolean;
    reptile?: boolean;
    other?: boolean;
  };
  size?: PetSize;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  fee?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  deposit?: number;
  /**
   * @minLength 0
   * @maxLength 200
   */
  description?: string;
}

/** PlaidConnectedStatusDto */
export interface PlaidConnectedStatusDto {
  status: BankAccountConnectionStatus;
  balance: BankAccountConnectionBalance;
  deniedReason?: string;
  externalAccountId?: string;
}

/** PlaidPaymentAccountDto */
export interface PlaidPaymentAccountDto {
  plaidAccountNumber: string;
  plaidAccountName: string;
  plaidAccountOfficialName?: string;
  plaidAccountType: string;
}

/** PlaidTransferLimitsDto */
export interface PlaidTransferLimitsDto {
  isoCurrencyCode: string;
  /** @format double */
  maxDailyCreditAmount?: number;
  /** @format double */
  maxDailyDebitAmount?: number;
  /** @format double */
  maxMonthlyCreditAmount?: number;
  /** @format double */
  maxMonthlyDebitAmount?: number;
  /** @format double */
  maxSingleTransferCreditAmount?: number;
  /** @format double */
  maxSingleTransferDebitAmount?: number;
}

/** PolicyHandbookDto */
export interface PolicyHandbookDto {
  id: string;
  level: string;
  levelId?: string;
  title: string;
  description?: string;
  script: string;
  indexStatus: string;
  indexError?: string;
  /** @format date-time */
  indexedAt?: string;
  enabled: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** PolicyHandbookPaginationDto */
export interface PolicyHandbookPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: PolicyHandbookDto[];
}

/** PortalInviteEmailPayloadDto */
export interface PortalInviteEmailPayloadDto {
  subject?: string;
  /** @minLength 1 */
  body: string;
}

/** PortalInviteMessagePayloadDto */
export interface PortalInviteMessagePayloadDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  templateId?: string;
  /** @minLength 1 */
  kind: string;
  email: PortalInviteEmailPayloadDto;
  text: PortalInviteTextPayloadDto;
  /** @format date-time */
  scheduledSendAt?: string;
}

/** PortalInviteResponseDto */
export interface PortalInviteResponseDto {
  /** @minLength 1 */
  batchId: string;
}

/** PortalInviteScopeDto */
export interface PortalInviteScopeDto {
  portfolioIds?: string[];
  propertyIds?: string[];
}

/** PortalInviteTextPayloadDto */
export interface PortalInviteTextPayloadDto {
  /** @minLength 1 */
  body: string;
}

/** PortalSettingsDto */
export interface PortalSettingsDto {
  metadata: WebsiteMetadata;
  contact: ContactPhoneEmailDto;
  socialLinks: {
    twitter?: string;
    facebook?: string;
    instagram?: string;
    linkedIn?: string;
    youTube?: string;
    tikTok?: string;
  };
  translationLanguages: string[];
  iconFile?: FileDto;
  logoFile?: FileDto;
  coverFile?: FileDto;
  /**
   * [DEPRECATED] Use IconFile instead.
   * @deprecated
   */
  iconFileId?: string;
  /**
   * [DEPRECATED] Use IconFile.SecureUrl.Raw instead.
   * @deprecated
   */
  iconUrl?: string;
  /**
   * [DEPRECATED] Use IconFile.SecureUrl.VariantTemplate instead.
   * @deprecated
   */
  iconThumbUrl?: string;
  /**
   * [DEPRECATED] Use LogoFile instead.
   * @deprecated
   */
  logoFileId?: string;
  /**
   * [DEPRECATED] Use LogoFile.SecureUrl.Raw instead.
   * @deprecated
   */
  logoUrl?: string;
  /**
   * [DEPRECATED] Use LogoFile.SecureUrl.VariantTemplate instead.
   * @deprecated
   */
  logoThumbUrl?: string;
  /**
   * [DEPRECATED] Use CoverFile.Id instead.
   * @deprecated
   */
  coverFileId?: string;
  /**
   * [DEPRECATED] Use CoverFile.SecureUrl instead.
   * @deprecated
   */
  coverUrl?: string;
}

/** PortfolioDto */
export interface PortfolioDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  active: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /** @format int32 */
  propertyCount: number;
  icons: string[];
}

/** PortfolioGroupDto */
export interface PortfolioGroupDto {
  portfolio: PortfolioDto;
  settings: LeaseRenewalOfferAutomaticSettingDto[];
}

/** PortfolioOverviewDto */
export interface PortfolioOverviewDto {
  portfolio: PortfolioDto;
  summary: PortfolioSummary;
  /** @format date-time */
  cacheDate: string;
}

/** PortfolioSummary */
export interface PortfolioSummary {
  propertiesDistribution: {
    /** @format int32 */
    singleFamily?: number;
    /** @format int32 */
    multiFamily?: number;
    /** @format int32 */
    commercial?: number;
    /** @format int32 */
    condo?: number;
    /** @format int32 */
    townHome?: number;
    /** @format int32 */
    other?: number;
  };
  /** @format int32 */
  activeProperties: number;
  /** @format int32 */
  totalProperties: number;
  /** @format int32 */
  occupiedUnits: number;
  /** @format int32 */
  activeUnits: number;
  /** @format int32 */
  unlistedUnits: number;
  /** @format int32 */
  totalUnits: number;
  /** @format double */
  totalRent: number;
  /** @format double */
  totalDeposit: number;
  /** @format double */
  currentBalance: number;
  /** @format int32 */
  vacantUnits: number;
}

/** PostChatMessageDto */
export interface PostChatMessageDto {
  /**
   * @minLength 0
   * @maxLength 30000
   */
  message?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionIds?: string[];
  /** @default false */
  aiEnhanced: boolean;
  /** @default false */
  sendText: boolean;
  /** @default false */
  sendEmail: boolean;
}

/** PostOwnerContributionDto */
export interface PostOwnerContributionDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  ownerId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /** @format date */
  contributionDate: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  reference?: string;
  paymentMethod?: TransactionPaymentMethod;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalTransactionId?: string;
  metadata?: Record<string, string>;
}

/** PostOwnerDistributionItemDto */
export interface PostOwnerDistributionItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  distributionAmount: number;
  /**
   * @minLength 0
   * @maxLength 250
   */
  memo?: string;
}

/** PostOwnerDistributionsDto */
export interface PostOwnerDistributionsDto {
  /** @minItems 1 */
  groups: PostOwnerDistributionsGroupDto[];
}

/** PostOwnerDistributionsGroupDto */
export interface PostOwnerDistributionsGroupDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  ownerId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  cashChartOfAccountId: string;
  paymentType: PayoutMethod;
  /** Required if payment type is `Manual` */
  paymentMethod?: TransactionPaymentMethod;
  /**
   * Required if payment type is `Manual`
   * @minLength 0
   * @maxLength 100
   */
  externalTransactionId?: string;
  /**
   * Required if payment type is `ACH`
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentAccountId?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  memo?: string;
  /** @format date */
  distributionDate?: string;
  distributions: PostOwnerDistributionItemDto[];
}

/** PrepaidRentReportDto */
export interface PrepaidRentReportDto {
  groups: PrepaidRentReportGroupDto[];
  metadata: PrepaidRentReportMetadataDto;
}

/** PrepaidRentReportGroupDto */
export interface PrepaidRentReportGroupDto {
  portfolio: PortfolioDto;
  property: PropertyDto;
  items: PrepaidRentReportItemDto[];
}

/** PrepaidRentReportItemDto */
export interface PrepaidRentReportItemDto {
  lease: LeaseDto;
  unit: UnitDto;
  tenants: PrepaidRentReportItemTenantDto[];
}

/** PrepaidRentReportItemTenantDto */
export interface PrepaidRentReportItemTenantDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons: string[];
  imageId?: string;
  /** @format date */
  moveInDate: string;
  /** @format date */
  moveOutDate?: string;
}

/** PrepaidRentReportMetadataDto */
export interface PrepaidRentReportMetadataDto {
  /** @format int32 */
  totalLeases: number;
  /** @format double */
  totalPrepaidAmount: number;
}

/** PropertyBalanceDto */
export interface PropertyBalanceDto {
  /** @format double */
  income: number;
  /** @format double */
  expense: number;
  /** @format double */
  balance: number;
}

/** PropertyChargeDto */
export interface PropertyChargeDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date */
  chargeDate: string;
  /** @format double */
  amount: number;
  memo?: string;
  reference?: string;
  chartOfAccountId: string;
  transactionId: string;
  portfolioId: string;
  propertyId: string;
  unitId?: string;
  leaseId?: string;
  returnedTransactionId?: string;
  /** @format double */
  returnedAmount?: number;
  /** @format date-time */
  returnedDate?: string;
  returnedReason?: string;
  files: PropertyChargeFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  portfolio: PortfolioDto;
  property: PropertyDto;
  unit?: UnitDto;
  lease?: LeaseDto;
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  creatorInfo: CreatorInfoDto;
}

/** PropertyChargeFileDto */
export interface PropertyChargeFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** PropertyChargeItemDto */
export interface PropertyChargeItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date */
  chargeDate: string;
  /** @format double */
  amount: number;
  memo?: string;
  reference?: string;
  chartOfAccountId: string;
  transactionId: string;
  portfolioId: string;
  propertyId: string;
  unitId?: string;
  leaseId?: string;
  returnedTransactionId?: string;
  /** @format double */
  returnedAmount?: number;
  /** @format date-time */
  returnedDate?: string;
  returnedReason?: string;
  files: PropertyChargeFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
}

/** PropertyChargePaginationDto */
export interface PropertyChargePaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: PropertyChargeItemDto[];
  properties: PropertyDto[];
  chartOfAccounts: ChartOfAccountDto[];
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  units: UnitDto[];
  leases: LeaseDto[];
}

/** PropertyDirectoryReportDto */
export interface PropertyDirectoryReportDto {
  items: PropertyDirectoryReportItemDto[];
}

/** PropertyDirectoryReportItemDto */
export interface PropertyDirectoryReportItemDto {
  property: PropertyDto;
  managementFeeType: ManagementFeeType;
  /** @format double */
  managementFeeRate: number;
  /** @format double */
  minimumManagementFee: number;
  /** @format double */
  maximumManagementFee: number;
  /** @format double */
  reserve: number;
  owners: OwnerDto[];
}

/** PropertyDto */
export interface PropertyDto {
  id: string;
  name?: string;
  displayName: string;
  address?: AddressDto;
  portfolioId: string;
  type: PropertyType;
  /** @format int32 */
  totalFloors?: number;
  /** @format int32 */
  unitCount: number;
  /** @format int32 */
  recentRentalApplications: number;
  active: boolean;
  imageId?: string;
  icons: string[];
  magicTags?: Record<string, string>;
}

/** PropertyGroupDto */
export interface PropertyGroupDto {
  property: PropertyDto;
  settings: LeaseRenewalOfferAutomaticSettingDto[];
}

/** PropertyManagerDto */
export interface PropertyManagerDto {
  id: string;
  companyId: string;
  email: string;
  phone?: string;
  firstName: string;
  lastName?: string;
  active: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  lastSeen?: string;
  name: string;
  imageId?: string;
  image?: PropertyManagerImageDto;
}

/** PropertyManagerImageDto */
export interface PropertyManagerImageDto {
  fileId: string;
  signedUrl: string;
  signedThumbUrl?: string;
}

/** PropertyManagerMenuAccessDto */
export interface PropertyManagerMenuAccessDto {
  /** The first-level menu access keys. Valid keys: onboarding, home, properties, listing, leasing, users, accounting, reports, maintenance, associations, communications, ai, settings. */
  menuAccess: string[];
}

/** PropertyManagerNotificationSettingDto */
export interface PropertyManagerNotificationSettingDto {
  key: string;
  name: string;
  description: string;
  enabled: boolean;
  receiveEmail: boolean;
  receiveAppPush: boolean;
  defaultOn: boolean;
}

/** PropertyManagerPermissionsDto */
export interface PropertyManagerPermissionsDto {
  /** The permission strings for the property manager */
  permissions: string[];
}

/** PropertyManagerPropertyAccessDto */
export interface PropertyManagerPropertyAccessDto {
  /** Whether the property manager has access to all properties */
  allProperties: boolean;
  /** The property IDs the property manager has access to */
  propertyIds?: string[];
  /** The portfolio IDs the property manager has access to */
  portfolioIds?: string[];
}

/** PropertyOverviewDto */
export interface PropertyOverviewDto {
  property: PropertyDto;
  summary: PropertySummary;
  revenue: PropertyRevenueDto;
  owners: PropertyOwnerDto[];
  maintenanceRequests: MaintenanceRequestListDto[];
  upcomingRenewalLeases: LeaseDto[];
  outstandingBalanceLeases: LeaseDto[];
  tenants: TenantDto[];
  units: UnitDto[];
  expiringLeaseCounts: ExpiringLeaseCounts;
  /** @format date-time */
  cacheDate: string;
}

/** PropertyOwnerDto */
export interface PropertyOwnerDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  isCompany: boolean;
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  chatId?: string;
  language: string;
  icons: string[];
  address?: AddressDto;
  portalStatus: PortalStatus;
  /** @format double */
  ownershipPercentage: number;
}

/** PropertyOwnerIdDto */
export interface PropertyOwnerIdDto {
  ownerId: string;
  /** @format double */
  ownershipPercentage: number;
}

/** PropertyOwnershipDto */
export interface PropertyOwnershipDto {
  /** @format double */
  ownershipPercentage: number;
}

/** PropertyReserveReportDto */
export interface PropertyReserveReportDto {
  properties: PropertyReserveReportItemDto[];
  metadata: PropertyReserveReportMetadataDto;
}

/** PropertyReserveReportItemDto */
export interface PropertyReserveReportItemDto {
  property: PropertyDto;
  /** @format double */
  currentFunds: number;
  /** @format double */
  reserve: number;
  /** @format double */
  availableFunds: number;
}

/** PropertyReserveReportMetadataDto */
export interface PropertyReserveReportMetadataDto {
  /** @format double */
  totalCurrentFunds: number;
  /** @format double */
  totalReserve: number;
  /** @format double */
  totalAvailableFunds: number;
  /** @format int32 */
  propertyCount: number;
}

/** PropertyRevenueDto */
export interface PropertyRevenueDto {
  group: Record<string, IncomeExpense>;
  /** @format double */
  income: number;
  /** @format double */
  expenses: number;
  /** @format double */
  balance: number;
}

/** PropertySummary */
export interface PropertySummary {
  /** @format int32 */
  totalUnits: number;
  /** @format int32 */
  occupiedUnits: number;
  /** @format int32 */
  activeUnits: number;
  /** @format int32 */
  unlistedUnits: number;
  /** @format double */
  totalRent: number;
  /** @format double */
  totalDeposit: number;
  /** @format double */
  currentBalance: number;
  /** @format int32 */
  vacantUnits: number;
}

/** ProratedAmountResultDto */
export interface ProratedAmountResultDto {
  /** @format double */
  proratedAmount: number;
}

/** PublicLanguage */
export interface PublicLanguage {
  name: string;
  code: string;
}

/** RecoverPasswordDto */
export interface RecoverPasswordDto {
  /**
   * A valid email address.
   * @minLength 1
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId?: string;
}

/** RecurringChargeChangeDto */
export interface RecurringChargeChangeDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  recurringChargeId: string;
  /**
   * @format double
   * @min 0
   * @max 1.7976931348623157e+308
   */
  newAmount: number;
  newDescription?: string;
}

/** RecurringLeaseChargeDto */
export interface RecurringLeaseChargeDto {
  id: string;
  /** @format double */
  amount: number;
  chargeFrequency: ChargeFrequency;
  chartOfAccountId: string;
  description?: string;
  companyCharge: boolean;
  /** @format date */
  lastCharge?: string;
  /** @format date */
  nextCharge?: string;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
  status: LeaseRecurringChargeStatus;
  chartOfAccount: ChartOfAccountDto;
}

/** RecurringLeaseChargesDto */
export interface RecurringLeaseChargesDto {
  recurringCharges: RecurringLeaseChargeDto[];
}

/** RecurringLeaseCreditDto */
export interface RecurringLeaseCreditDto {
  id: string;
  /** @format double */
  amount: number;
  creditFrequency: ChargeFrequency;
  description?: string;
  /** @format date */
  lastCredit?: string;
  /** @format date */
  nextCredit?: string;
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  status: LeaseRecurringCreditStatus;
}

/** RecurringLeaseCreditsDto */
export interface RecurringLeaseCreditsDto {
  recurringCredits: RecurringLeaseCreditDto[];
}

/** RecurringLeasePaymentDto */
export interface RecurringLeasePaymentDto {
  id: string;
  leaseId: string;
  tenantId?: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  /** @format double */
  amount?: number;
  paymentFrequency: ChargeFrequency;
  paymentMethod: LeaseRecurringPaymentMethod;
  description?: string;
  reference?: string;
  /** @format date */
  lastPayment?: string;
  /** @format date */
  nextPayment?: string;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
  status: LeaseRecurringPaymentStatus;
  tenant?: TenantDto;
}

/** RecurringLeasePaymentsDto */
export interface RecurringLeasePaymentsDto {
  recurringPayments: RecurringLeasePaymentDto[];
}

/** RecurringVendorBillDto */
export interface RecurringVendorBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId: string;
  reference?: string;
  memo?: string;
  companyCharge: boolean;
  /** @format int32 */
  dueDays?: number;
  lineItems: RecurringVendorBillLineItemDto[];
  chargeFrequency: ChargeFrequency;
  /** @format date */
  startsFrom: string;
  /** @format date */
  ends?: string;
  active: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** RecurringVendorBillDtoPaginationDto */
export interface RecurringVendorBillDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: RecurringVendorBillDto[];
}

/** RecurringVendorBillLineItemDto */
export interface RecurringVendorBillLineItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
}

/** ReleaseDepositRequestDto */
export interface ReleaseDepositRequestDto {
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
}

/** ReleaseLeaseBalanceDto */
export interface ReleaseLeaseBalanceDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /** @maxLength 500 */
  memo?: string;
  paymentType: PayoutMethod;
  /**
   * Applicable only for `PrintCheck` or `Manual` settlements
   * @format date
   */
  paymentDate?: string;
  /** Required if payment type is `Manual` */
  paymentMethod?: TransactionPaymentMethod;
  /**
   * Optional if payment type is `Manual`
   * @maxLength 100
   */
  externalTransactionId?: string;
  /**
   * Required if payment type is `ACH`
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentAccountId?: string;
  /**
   * Required if payment type is `ACH`
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentMethodId?: string;
}

/** RemoveLeaseChargeFilesDto */
export interface RemoveLeaseChargeFilesDto {
  /** @minItems 1 */
  fileIds: string[];
}

/** RemoveLeaseDepositFilesDto */
export interface RemoveLeaseDepositFilesDto {
  /** @minItems 1 */
  fileIds: string[];
}

/** RemoveOwnerContributionFilesDto */
export interface RemoveOwnerContributionFilesDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 1
   */
  fileIds: string[];
}

/** RemoveOwnerDistributionFilesDto */
export interface RemoveOwnerDistributionFilesDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 1
   */
  fileIds: string[];
}

/** RemoveOwnerTransferFilesDto */
export interface RemoveOwnerTransferFilesDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 1
   */
  fileIds: string[];
}

/** RemovePropertyManagerPermissionDto */
export interface RemovePropertyManagerPermissionDto {
  /**
   * The permission string to add, e.g. 'property:read', 'property:write', 'property:delete'
   * @minLength 1
   * @maxLength 100
   */
  permission: string;
}

/** RemovePropertyManagerPropertyAccessDto */
export interface RemovePropertyManagerPropertyAccessDto {
  /**
   * Whether to grant access to all properties
   * @default false
   */
  allProperties: boolean;
  /**
   * The portfolio ID to grant access to
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId?: string;
  /**
   * The property ID to grant access to
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
}

/** RentAmountConditionDto */
export type RentAmountConditionDto = (UtilRequiredKeys<BaseConditionDto, 'type'> & {
  /**
   * @format double
   * @min 0
   * @max 1.7976931348623157e+308
   */
  amount: number;
}) & {
  type: 'RentAmount';
};

/** RentRollReportDto */
export interface RentRollReportDto {
  groups: RentRollReportGroupDto[];
  metadata: RentRollReportMetadataDto;
  customFields?: CustomFieldDto[];
}

/** RentRollReportGroupDto */
export interface RentRollReportGroupDto {
  portfolio: PortfolioDto;
  property: PropertyDto;
  items: RentRollReportItemDto[];
}

/** RentRollReportItemDto */
export interface RentRollReportItemDto {
  unit: UnitDto;
  lease?: LeaseDto;
  tenants?: RentRollReportItemTenantDto[];
  customFieldValues?: CustomFieldValueDto[];
  /** @format double */
  subsidyAmount: number;
  status: RentStatus;
}

/** RentRollReportItemTenantDto */
export interface RentRollReportItemTenantDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons: string[];
  imageId?: string;
  /** @format date */
  moveInDate: string;
  /** @format date */
  moveOutDate?: string;
}

/** RentRollReportMetadataDto */
export interface RentRollReportMetadataDto {
  /** @format int32 */
  totalUnits: number;
  /** @format double */
  occupancyRate: number;
  /** @format int32 */
  totalSqft: number;
  /** @format double */
  totalRent: number;
  /** @format double */
  totalSubsidy: number;
  /** @format double */
  totalDeposit: number;
}

/** ReplaceLeaseDocumentFileDto */
export interface ReplaceLeaseDocumentFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId: string;
}

/** ReplaceSigningDocumentTemplateFileDto */
export interface ReplaceSigningDocumentTemplateFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId: string;
  ifMatchToken?: string;
}

/** ReplaceSigningDocumentTemplateFileResultDto */
export interface ReplaceSigningDocumentTemplateFileResultDto {
  token: string;
  docxUrl: string;
}

/** ReportGroupHeader */
export interface ReportGroupHeader {
  id: string;
  name: string;
}

/** ReportGroupHeaderDto */
export interface ReportGroupHeaderDto {
  id: string;
  name: string;
}

/** RequestOwnerContributionDto */
export interface RequestOwnerContributionDto {
  /** @format int64 */
  ownerId?: string;
  /** @format int64 */
  propertyId: string;
  /**
   * @format double
   * @min 0.01
   * @max 1.7976931348623157e+308
   */
  amount: number;
  /** @format date */
  requestDate: string;
  /** @format date */
  dueDate?: string;
  /** @maxLength 1000 */
  memo?: string;
}

/** RequestUploadSessionDto */
export interface RequestUploadSessionDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  fileName: string;
  /**
   * @format int32
   * @min 1
   * @max 9223372036854776000
   */
  fileSize: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  contentType: string;
}

/** RequiredAddressDto */
export interface RequiredAddressDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  streetAddress1: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  streetAddress2?: string;
  /**
   * @minLength 2
   * @maxLength 150
   */
  city: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  state: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  zipCode: string;
  /**
   * @minLength 3
   * @maxLength 25
   */
  country?: string;
}

/** ResetPasswordDto */
export interface ResetPasswordDto {
  /**
   * @minLength 3
   * @maxLength 100
   */
  token: string;
  /**
   * @minLength 6
   * @maxLength 100
   */
  requestId: string;
  /**
   * @minLength 5
   * @maxLength 150
   */
  newPassword: string;
}

/** ResolveSelfManagedDto */
export interface ResolveSelfManagedDto {
  selfManaged: boolean;
  /**
   * Required if self-managed is false
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  defaultCompanyBankAccountId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyBankAccountIds?: string[];
}

/** ReturnLeaseChargePaymentDto */
export interface ReturnLeaseChargePaymentDto {
  /**
   * @minLength 0
   * @maxLength 200
   */
  reason?: string;
}

/** SecurityDepositConditionDto */
export type SecurityDepositConditionDto = (UtilRequiredKeys<BaseConditionDto, 'type'> & {
  /** @format double */
  amount: number;
}) & {
  type: 'SecurityDeposit';
};

/** SelectSearchLeaseResultDto */
export interface SelectSearchLeaseResultDto {
  lease: LeaseDto;
  tenants?: TenantDto[];
}

/** SelectSearchPortfolioResultDto */
export interface SelectSearchPortfolioResultDto {
  portfolio: PortfolioDto;
  properties?: SelectSearchPropertyResultDto[];
}

/** SelectSearchPropertyResultDto */
export interface SelectSearchPropertyResultDto {
  property: PropertyDto;
  units?: SelectSearchUnitResultDto[];
}

/** SelectSearchRequestDto */
export interface SelectSearchRequestDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  search: string;
  levelSearch: LevelSearch;
  includeTenants: boolean;
  includeEndedLeases: boolean;
  includeDeactivated: boolean;
  includeFutureLease: boolean;
  excludeUnlistedUnit: boolean;
}

/** SelectSearchResultDto */
export interface SelectSearchResultDto {
  portfolios: SelectSearchPortfolioResultDto[];
}

/** SelectSearchUnitResultDto */
export interface SelectSearchUnitResultDto {
  unit: UnitDto;
  leases?: SelectSearchLeaseResultDto[];
}

/** SelfManagedFlagDto */
export interface SelfManagedFlagDto {
  selfManaged?: boolean;
  needChoose: boolean;
}

/** SendAnnouncementRequestDto */
export interface SendAnnouncementRequestDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  subject?: string;
  /**
   * @minLength 1
   * @maxLength 5000
   */
  chatMessage?: string;
  /**
   * @minLength 1
   * @maxLength 30000
   */
  emailMessage?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @maxItems 5
   */
  chatAttachmentSessionIds?: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @maxItems 5
   */
  emailAttachmentSessionIds?: string[];
  sendText: boolean;
  /**
   * Must be in the future.
   * @format date-time
   */
  scheduledSendAt?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  ownerIds?: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorIds?: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantIds?: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseIds?: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  documentTemplateIds?: string[];
  /**
   * [DEPRECATED] Use ChatAttachmentSessionIds instead.
   * @deprecated
   * @maxItems 5
   */
  chatAttachmentFiles?: string[];
  /**
   * [DEPRECATED] Use EmailAttachmentSessionIds instead.
   * @deprecated
   * @maxItems 5
   */
  emailAttachmentFiles?: string[];
}

/** SendAssociationViolationNoticeDto */
export interface SendAssociationViolationNoticeDto {
  chatMessage?: string;
  emailMessage?: string;
  subject?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 1
   */
  chatAttachmentSessionIds?: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 1
   */
  emailAttachmentSessionIds?: string[];
}

/** SendEmailJsonDto */
export interface SendEmailJsonDto {
  /** @minLength 1 */
  subject: string;
  /** @minLength 1 */
  body: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  attachmentSessionIds?: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  documentTemplateIds?: string[];
}

/** SendMagicLinkDto */
export interface SendMagicLinkDto {
  /**
   * A valid email address.
   * @minLength 1
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId?: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  redirect?: string;
}

/** SendOtpDto */
export interface SendOtpDto {
  /**
   * @format tel
   * @minLength 1
   */
  phone: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId?: string;
}

/** SendResultDto */
export interface SendResultDto {
  companies?: CompanyOptionDto[];
  requestId?: string;
}

/** SendTenantPortalInviteDto */
export interface SendTenantPortalInviteDto {
  messages?: PortalInviteMessagePayloadDto[];
}

/** SendTwoFactorCodeDto */
export interface SendTwoFactorCodeDto {
  /** @minLength 1 */
  mfaSessionToken: string;
  method: TwoFactorMethodType;
}

/** ServiceBillDto */
export interface ServiceBillDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date */
  chargeDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  paidAmount: number;
  /** @format double */
  outstandingAmount: number;
  memo?: string;
  reference?: string;
  companyVendorId: string;
  lineItems: ServiceBillLineItemDto[];
  files: ServiceBillFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  vendor: VendorDto;
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  hydratedFiles: FileDto[];
  creatorInfo: CreatorInfoDto;
}

/** ServiceBillFileDto */
export interface ServiceBillFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** ServiceBillItemDto */
export interface ServiceBillItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date */
  chargeDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  paidAmount: number;
  /** @format double */
  outstandingAmount: number;
  memo?: string;
  reference?: string;
  companyVendorId: string;
  lineItems: ServiceBillLineItemDto[];
  files: ServiceBillFileDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
}

/** ServiceBillLineItemDto */
export interface ServiceBillLineItemDto {
  id?: string;
  /** @format int32 */
  order: number;
  propertyChartOfAccountId: string;
  companyChartOfAccountId: string;
  portfolioId: string;
  propertyId: string;
  unitId?: string;
  leaseId?: string;
  description?: string;
  /** @format double */
  amount: number;
  payout?: PayoutInfoDto;
  /** @format double */
  paidAmount: number;
  /** @format double */
  outstandingAmount: number;
}

/** ServiceBillPaginationDto */
export interface ServiceBillPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: ServiceBillItemDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  chartOfAccounts: ChartOfAccountDto[];
}

/** SetChatHumanEngagementDto */
export interface SetChatHumanEngagementDto {
  requested: boolean;
}

/** SetCustomFieldValueDto */
export interface SetCustomFieldValueDto {
  stringValue?: string;
  stringArray?: string[];
  /** @format double */
  numberValue?: number;
  booleanValue?: boolean;
  /** @format date-time */
  dateTimeValue?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  referenceValue?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  referenceArray?: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  referenceFileUploadSessionId?: string;
  /**
   * Append-only - list of file upload session ids to be added as reference files to the custom field value
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  referenceFileUploadSessionIds?: string[];
}

/** SetFileAttachmentShareTypesDto */
export interface SetFileAttachmentShareTypesDto {
  shareTypes?: MagicUserType[];
}

/** SetLeaseMoveOutRequestDto */
export interface SetLeaseMoveOutRequestDto {
  /** @format date */
  moveOutDate: string;
}

/** SetMessagesReadDto */
export interface SetMessagesReadDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 1
   */
  messageIds: string[];
}

/** SetPropertyManagerNotificationSettingDto */
export interface SetPropertyManagerNotificationSettingDto {
  enabled: boolean;
  receiveEmail?: boolean;
  receiveAppPush?: boolean;
}

/** SetVendorBillSourceDto */
export interface SetVendorBillSourceDto {
  /**
   * The work order this bill belongs to, or null to detach it
   * @format int64
   */
  workOrderId?: string;
}

/** SettleVendorBillPaymentDto */
export interface SettleVendorBillPaymentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorBillId: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
}

/** SettleVendorBillsDto */
export interface SettleVendorBillsDto {
  /** @minItems 1 */
  groups: SettleVendorBillsGroupDto[];
}

/** SettleVendorBillsGroupDto */
export interface SettleVendorBillsGroupDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  cashChartOfAccountId: string;
  paymentType: PayoutMethod;
  /**
   * Applicable only for `PrintCheck` or `Manual` settlements
   * @format date
   */
  paymentDate?: string;
  /** Required if payment type is `Manual` */
  paymentMethod?: TransactionPaymentMethod;
  /**
   * Required if payment type is `Manual`
   * @minLength 0
   * @maxLength 100
   */
  externalTransactionId?: string;
  /**
   * Required if payment type is `ACH`
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentMethodId?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  memo?: string;
  payments: SettleVendorBillPaymentDto[];
}

/** SettleVendorBillsResultDto */
export interface SettleVendorBillsResultDto {
  settlements: SettleVendorBillsSettlementDto[];
  properties: PropertyDto[];
  checks?: HydratedCheckDto[];
}

/** SettleVendorBillsSettlementDto */
export interface SettleVendorBillsSettlementDto {
  paymentType: PayoutMethod;
  status: PayoutStatus;
  vendor: VendorDto;
  bankAccount: BankAccountDto;
  transaction?: TransactionItemDto;
  payments: SettledVendorBillPaymentDto[];
  failureMessage?: string;
  failureCode?: PayoutFailure;
}

/** SettledVendorBillPaymentDto */
export interface SettledVendorBillPaymentDto {
  bill: VendorBillItemDto;
  /** @format double */
  amount: number;
}

/** SigningDocumentTemplateDto */
export interface SigningDocumentTemplateDto {
  id: string;
  companyId: string;
  documentId: string;
  name?: string;
  templateType: LeaseTemplateType;
  leaseTemplateCategoryId?: string;
  docxUrl: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** SigningDocumentTemplateItemDto */
export interface SigningDocumentTemplateItemDto {
  id: string;
  name?: string;
  templateType: LeaseTemplateType;
  leaseTemplateCategoryId?: string;
  documentId: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** SigningTemplateKeyDto */
export interface SigningTemplateKeyDto {
  key: string;
  name: string;
  description?: string;
  group: string;
  kind: string;
}

/** StandardizedImportData */
export interface StandardizedImportData {
  tenants: StandardizedImportDataTenant[];
  properties: StandardizedImportDataProperty[];
}

/** StandardizedImportDataAddress */
export interface StandardizedImportDataAddress {
  street1: string;
  street2?: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
}

/** StandardizedImportDataCharge */
export interface StandardizedImportDataCharge {
  name: string;
  'chart-of-account': string;
  /** @format double */
  amount: number;
}

/** StandardizedImportDataLease */
export interface StandardizedImportDataLease {
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  month2month: boolean;
  tenants: string[];
  charges: StandardizedImportDataCharge[];
  /** @format double */
  deposit: number;
}

/** StandardizedImportDataProperty */
export interface StandardizedImportDataProperty {
  id: string;
  name: string;
  type: StandardizedImportDataPropertyType;
  address?: StandardizedImportDataAddress;
  units: StandardizedImportDataUnit[];
}

/** StandardizedImportDataTenant */
export interface StandardizedImportDataTenant {
  id: string;
  'first-name': string;
  'last-name'?: string;
  email?: string;
  /** @format date */
  'date-of-birth'?: string;
  ssn?: string;
  phone?: string;
  gender?: StandardizedImportDataGender;
  'current-address'?: StandardizedImportDataAddress;
}

/** StandardizedImportDataUnit */
export interface StandardizedImportDataUnit {
  id: string;
  'property-id': string;
  name: string;
  /** @format int32 */
  beds?: number;
  /** @format int32 */
  baths?: number;
  /** @format int32 */
  sqft?: number;
  leases: StandardizedImportDataLease[];
}

/** StripeCheckoutDto */
export interface StripeCheckoutDto {
  sessionId: string;
  clientSecret: string;
}

/** StripeConnectedStatusDto */
export interface StripeConnectedStatusDto {
  status: BankAccountConnectionStatus;
  balance: BankAccountConnectionBalance;
  deniedReason?: string;
  externalAccountId?: string;
}

/** StripePaymentAccountDto */
export interface StripePaymentAccountDto {
  cardType?: CardType;
  brand?: string;
  country: string;
  /** @format int32 */
  expMonth?: number;
  /** @format int32 */
  expYear?: number;
  last4?: string;
}

/** StripePayoutDetailsDto */
export interface StripePayoutDetailsDto {
  id: string;
  stripeAccountId: string;
  /** @format double */
  amount: number;
  currency: string;
  description?: string;
  statementDescriptor?: string;
  method: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  arrivalDate: string;
  status: string;
  automatic: boolean;
  type: string;
  destinationId?: string;
  items: StripePayoutItemDto[];
  summary: StripePayoutSummaryDto;
}

/** StripePayoutDto */
export interface StripePayoutDto {
  id: string;
  stripeAccountId: string;
  /** @format double */
  amount: number;
  currency: string;
  description?: string;
  statementDescriptor?: string;
  method: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  arrivalDate: string;
  status: string;
  automatic: boolean;
  type: string;
  destinationId?: string;
}

/** StripePayoutItemDto */
export interface StripePayoutItemDto {
  id: string;
  type: StripeType;
  cardType: CardType;
  walletType: WalletType;
  /** @format double */
  totalAmount: number;
  /** @format double */
  totalFees: number;
  /** @format date-time */
  date: string;
  description: string;
  transactionId: string;
  transactionIdentity?: TransactionIdentity;
  propertyId?: string;
  propertyName?: string;
  unitId?: string;
  unitName?: string;
  leaseId?: string;
  tenantId?: string;
  tenantName?: string;
  vendorId?: string;
  ownerId?: string;
  ownerName?: string;
}

/** StripePayoutSummaryDto */
export interface StripePayoutSummaryDto {
  /** @format int32 */
  totalCount: number;
  /** @format double */
  totalAmount: number;
  /** @format double */
  totalFees: number;
  /** @format double */
  netAmount: number;
}

/** SubmissionStatusDto */
export interface SubmissionStatusDto {
  /** @format int64 */
  accountId: string;
  accountType: string;
  status: string;
  errorMessage?: string;
  irisSubmissionId?: string;
  filingType?: string;
  receiptId?: string;
  originalIrisSubmissionId?: string;
}

/** SubmitIrisCorrectionDto */
export interface SubmitIrisCorrectionDto {
  /** @format int32 */
  taxYear: number;
  vendorIds?: string[];
  ownerIds?: string[];
  filingType: IrisSubmissionFilingType;
  overrides?: IrisCorrectionOverrideDto[];
}

/** SubmitIrisTransmissionDto */
export interface SubmitIrisTransmissionDto {
  /** @format int32 */
  taxYear: number;
  vendorIds?: string[];
  ownerIds?: string[];
}

/** SubsidizerDto */
export interface SubsidizerDto {
  id: string;
  name: string;
  language: string;
  memo?: string;
  active: boolean;
  website?: string;
  contact?: ContactPhoneEmailDto;
  address?: AddressDto;
  federalTaxInformation?: FederalTaxInformationDto;
  paymentSettings?: SubsidizerPaymentSettingsDto;
  type: SubsidizerType;
  creator?: CreatorDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  creatorInfo?: CreatorInfoDto;
}

/** SubsidizerItemDto */
export interface SubsidizerItemDto {
  id: string;
  name: string;
  language: string;
  memo?: string;
  active: boolean;
  website?: string;
  contact?: ContactPhoneEmailDto;
  address?: AddressDto;
  federalTaxInformation?: FederalTaxInformationDto;
  paymentSettings?: SubsidizerPaymentSettingsDto;
  type: SubsidizerType;
  creator?: CreatorDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** SubsidizerPaginationDto */
export interface SubsidizerPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: SubsidizerItemDto[];
  propertyManagers: PropertyManagerDto[];
  tenants: TenantDto[];
  vendors: VendorDto[];
  owners: OwnerDto[];
}

/** SubsidizerPaymentSettingsDto */
export interface SubsidizerPaymentSettingsDto {
  paymentMethod?: SubsidizerPaymentMethod;
}

/** SuggestedLeaseEndDateDto */
export interface SuggestedLeaseEndDateDto {
  /** @format date */
  suggestedEndDate: string;
}

/** TaxDocumentAnnotation */
export interface TaxDocumentAnnotation {
  id: string;
  /** @format int32 */
  page: number;
  /** @format double */
  x: number;
  /** @format double */
  y: number;
  /** @format double */
  width: number;
  /** @format double */
  height: number;
  /** @format double */
  fontSize: number;
  value: TaxDocumentAnnotationValue;
  text: string;
  type: string;
  dataPath?: string;
}

/** TaxDocumentAnnotationValue */
export interface TaxDocumentAnnotationValue {
  text?: string;
  /** @format double */
  currencyValue?: number;
  type?: TaxDocumentAnnotationType;
  hasValue: boolean;
}

/** TaxDocumentCalendarYearDto */
export interface TaxDocumentCalendarYearDto {
  calendarYears: number[];
}

/** TaxDocumentDto */
export interface TaxDocumentDto {
  id: string;
  /** @format int32 */
  calendarYear: number;
  entityName?: string;
  entityId?: string;
  /** @format double */
  amount: number;
  taxDocumentType: TaxType;
  documentName?: string;
  documentUrl?: string;
  status: ProcessStatus;
  taskErrorMessage?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  annotations?: TaxDocumentAnnotation[];
  irsStatus?: string;
}

/** TaxDocumentListDto */
export interface TaxDocumentListDto {
  id: string;
  /** @format int32 */
  calendarYear: number;
  entityName?: string;
  entityId?: string;
  /** @format double */
  amount: number;
  taxDocumentType: TaxType;
  documentName?: string;
  documentUrl?: string;
  status: ProcessStatus;
  taskErrorMessage?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  annotations?: TaxDocumentAnnotation[];
  irsStatus?: string;
}

/** TaxDocumentYearDto */
export interface TaxDocumentYearDto {
  /** @format int32 */
  calendarYear: number;
  /** @format int32 */
  taxDocumentsCount: number;
}

/** TemplateRefDto */
export interface TemplateRefDto {
  kind: TemplateRefKind;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
}

/** TenantAutoPayDto */
export interface TenantAutoPayDto {
  id: string;
  tenantPaymentAccountId?: string;
  paymentMethodId?: string;
  type: TenantAutoPayType;
  /** @format double */
  fixedAmount?: number;
  /** @format double */
  maximumAmount?: number;
  frequency: ChargeFrequency;
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  /** @format date */
  lastPayment?: string;
  /** @format date */
  nextPayment?: string;
  lease: LeaseDto;
  tenant: TenantDto;
  portfolio: PortfolioDto;
  property: PropertyDto;
  unit: UnitDto;
}

/** TenantCountConditionDto */
export type TenantCountConditionDto = (UtilRequiredKeys<BaseConditionDto, 'type'> & {
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  count: number;
}) & {
  type: 'TenantCount';
};

/** TenantCountsDto */
export interface TenantCountsDto {
  /** @format int32 */
  totalTenants: number;
  /** @format int32 */
  activeTenants: number;
  /** @format int32 */
  newTenantsToday: number;
  /** @format int32 */
  unInvitedTenants: number;
  /** @format int32 */
  sendingInvitesCount: number;
}

/** TenantCreatedDto */
export interface TenantCreatedDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons: string[];
  imageId?: string;
  password: string;
}

/** TenantDirectoryReportDto */
export interface TenantDirectoryReportDto {
  items: TenantDirectoryReportItemDto[];
}

/** TenantDirectoryReportItemDto */
export interface TenantDirectoryReportItemDto {
  tenant: TenantDto;
  leases: TenantDirectoryReportItemLeaseDto[];
}

/** TenantDirectoryReportItemLeaseDto */
export interface TenantDirectoryReportItemLeaseDto {
  lease: LeaseTenantDto;
  unit: UnitDto;
  property: PropertyDto;
}

/** TenantDto */
export interface TenantDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons: string[];
  imageId?: string;
}

/** TenantNotificationTargetDto */
export type TenantNotificationTargetDto = (UtilRequiredKeys<BaseNotificationTargetDto, 'type'> & {
  tenantIds?: string[];
  hasBalanceDue?: boolean;
  hasLeaseWithoutPaymentMethod?: boolean;
  hasActiveLease?: boolean;
  noPortalActivity?: boolean;
}) & {
  type: 'Tenant';
};

/** TransactionDto */
export interface TransactionDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  creator: CreatorDto;
  type: TransactionType;
  identity: TransactionIdentity;
  direction: TransactionDirection;
  /** @format double */
  amount: number;
  paymentMethod: TransactionPaymentMethod;
  status: TransactionStatus;
  /** @format date */
  transactionDate: string;
  /** @format date */
  finalizedDate?: string;
  reference?: string;
  memo?: string;
  bankAccountId: string;
  chartOfAccountId: string;
  portfolioId?: string;
  propertyId?: string;
  unitId?: string;
  leaseId?: string;
  tenantId?: string;
  ownerId?: string;
  vendorId?: string;
  subsidizerId?: string;
  rentalApplicationId?: string;
  externalTransactionType?: ExternalTransactionType;
  externalTransactionId?: string;
  failureReason?: TransactionFailure;
  paymentProcessorErrorMessage?: string;
  transferGroupId?: string;
  linkedTransactionId?: string;
  checkId?: string;
  recurringPaymentId?: string;
  leaseSubsidyId?: string;
  allowedChartOfAccountIds: string[];
  metadata: Record<string, string>;
  bankAccount: BankAccountDto;
  chartOfAccount: ChartOfAccountDto;
  property?: PropertyDto;
  unit?: UnitDto;
  lease?: LeaseDto;
  tenant?: TenantDto;
  subsidizer?: SubsidizerItemDto;
  vendor?: VendorDto;
  owner?: OwnerDto;
  check?: CheckDto;
  creatorInfo: CreatorInfoDto;
}

/** TransactionItemDto */
export interface TransactionItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  creator: CreatorDto;
  type: TransactionType;
  identity: TransactionIdentity;
  direction: TransactionDirection;
  /** @format double */
  amount: number;
  paymentMethod: TransactionPaymentMethod;
  status: TransactionStatus;
  /** @format date */
  transactionDate: string;
  /** @format date */
  finalizedDate?: string;
  reference?: string;
  memo?: string;
  bankAccountId: string;
  chartOfAccountId: string;
  portfolioId?: string;
  propertyId?: string;
  unitId?: string;
  leaseId?: string;
  tenantId?: string;
  ownerId?: string;
  vendorId?: string;
  subsidizerId?: string;
  rentalApplicationId?: string;
  externalTransactionType?: ExternalTransactionType;
  externalTransactionId?: string;
  failureReason?: TransactionFailure;
  paymentProcessorErrorMessage?: string;
  transferGroupId?: string;
  linkedTransactionId?: string;
  checkId?: string;
  recurringPaymentId?: string;
  leaseSubsidyId?: string;
  allowedChartOfAccountIds: string[];
  metadata: Record<string, string>;
}

/** TransactionPaginationDto */
export interface TransactionPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  tenants: TenantDto[];
  vendors: VendorDto[];
  subsidizers: SubsidizerItemDto[];
  owners: OwnerDto[];
}

/** TranslationDto */
export interface TranslationDto {
  /**
   * @minLength 2
   * @maxLength 10
   */
  language: string;
  /** @minLength 1 */
  value: string;
}

/** TruliaSyndicationStatusDto */
export interface TruliaSyndicationStatusDto {
  status: SyndicationStatus;
  url: string;
}

/** TwoFactorChallengeDto */
export interface TwoFactorChallengeDto {
  state: TwoFactorState;
  mfaSessionToken: string;
  /** @format date-time */
  expiresAt: string;
  methods?: TwoFactorMethodDto[];
  sentTo?: TwoFactorMethodDto;
  otpRequestId?: string;
  /** @format date-time */
  otpExpiresAt?: string;
}

/** TwoFactorMethodDto */
export interface TwoFactorMethodDto {
  type: TwoFactorMethodType;
  masked: string;
}

/** UnassignedBankAccountDto */
export interface UnassignedBankAccountDto {
  id: string;
  name: string;
  description?: string;
  active: boolean;
  accountNumber?: string;
  routingNumber?: string;
  type?: BankAccountType;
  scheduledSweepDays: number[];
  chartOfAccountIds: string[];
  companyAccount: boolean;
  creator: CreatorDto;
  cannotBeCompanyAccount: boolean;
  cannotBeCompanyAccountReason?: string;
}

/** UnitDto */
export interface UnitDto {
  id: string;
  name: string;
  address?: AddressDto;
  /** @format double */
  beds?: number;
  /** @format double */
  baths?: number;
  /** @format int32 */
  unitSizeSqft?: number;
  /** @format double */
  marketRent?: number;
  /** @format int32 */
  floor?: number;
  propertyId: string;
  portfolioId: string;
  active: boolean;
  imageId?: string;
  icons: string[];
  magicTags?: Record<string, string>;
}

/** UnitListingApplicationInviteDto */
export interface UnitListingApplicationInviteDto {
  /** @minLength 1 */
  name: string;
  /**
   * A valid email address.
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * Phone number of the applicant, required if email is not provided
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
}

/** UnitListingDto */
export interface UnitListingDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  status: UnitListingStatus;
  /** @format double */
  rentalPrice?: number;
  /** @format double */
  securityDeposit?: number;
  /** @format date */
  availableFrom?: string;
  leaseTerm?: LeaseTerm;
  title?: string;
  /** @format date */
  listed?: string;
  /** @format date-time */
  updated: string;
  pinned: boolean;
  primaryImage?: UnitListingImageDto;
  primaryVideo?: UnitListingVideoDto;
  propertyType?: PropertyType;
  singleLineAddress?: string;
  /** @format int32 */
  recentRentalApplications?: number;
}

/** UnitListingImageDto */
export interface UnitListingImageDto {
  id: string;
  /** @format date-time */
  created: string;
  name: string;
  extension: string;
  /** @format int32 */
  size: number;
  contentType: string;
  secureUrl: FileUrlDto;
  /**
   * [DEPRECATED] Use Id instead.
   * @deprecated
   */
  fileId: string;
  /**
   * [DEPRECATED] Use Name instead.
   * @deprecated
   */
  fileName: string;
  /**
   * [DEPRECATED] Use SecureUrl instead.
   * @deprecated
   */
  signedUrl: string;
  /**
   * [DEPRECATED] Use SecureUrl instead.
   * @deprecated
   */
  signedThumbUrl?: string;
  /**
   * [DEPRECATED] Use Size instead.
   * @deprecated
   * @format int32
   */
  fileSize: number;
  /**
   * [DEPRECATED] Use Created instead.
   * @deprecated
   * @format date-time
   */
  uploaded: string;
  /**
   * [DEPRECATED] Debug purpose only, Do not use in production.
   * @deprecated
   */
  claimed: boolean;
  description?: string;
  default?: boolean;
  /** @format int32 */
  order?: number;
}

/** UnitListingSyndicationStatusDto */
export interface UnitListingSyndicationStatusDto {
  zillowStatus?: ZillowSyndicationStatusDto;
  hotpadsStatus?: HotpadsSyndicationStatusDto;
  truliaStatus?: TruliaSyndicationStatusDto;
}

/** UnitListingVideoDto */
export interface UnitListingVideoDto {
  id: string;
  /** @format date-time */
  created: string;
  name: string;
  extension: string;
  /** @format int32 */
  size: number;
  contentType: string;
  secureUrl: FileUrlDto;
  /**
   * [DEPRECATED] Use Id instead.
   * @deprecated
   */
  fileId: string;
  /**
   * [DEPRECATED] Use Name instead.
   * @deprecated
   */
  fileName: string;
  /**
   * [DEPRECATED] Use SecureUrl instead.
   * @deprecated
   */
  signedUrl: string;
  /**
   * [DEPRECATED] Use SecureUrl instead.
   * @deprecated
   */
  signedThumbUrl?: string;
  /**
   * [DEPRECATED] Use Size instead.
   * @deprecated
   * @format int32
   */
  fileSize: number;
  /**
   * [DEPRECATED] Use Created instead.
   * @deprecated
   * @format date-time
   */
  uploaded: string;
  /**
   * [DEPRECATED] Debug purpose only, Do not use in production.
   * @deprecated
   */
  claimed: boolean;
  description?: string;
  default?: boolean;
  /** @format int32 */
  order?: number;
}

/** UnitMasterListingDto */
export interface UnitMasterListingDto {
  /** @minLength 1 */
  title: string;
  keywords: string[];
  /** @minLength 1 */
  description: string;
}

/** UnitMasterListingRequestDto */
export interface UnitMasterListingRequestDto {
  /**
   * @minLength 1
   * @maxLength 1000
   */
  prompt?: string;
}

/** UnreadMessagePaginationDto */
export interface UnreadMessagePaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: ChatMessageDto[];
  chats: HydratedMagicChatDto[];
}

/** UpdateAssociationViolationRequestDto */
export interface UpdateAssociationViolationRequestDto {
  /** @format date */
  violationReceivedDate: string;
  /** @format date */
  violationDate: string;
  /** @format date */
  fixByDate?: string;
  /** @format double */
  associationFine: number;
  title: string;
  description: string;
}

/** UpdateAssociationViolationStatusRequestDto */
export interface UpdateAssociationViolationStatusRequestDto {
  status: AssociationViolationStatus;
}

/** UpdateBankAccountDto */
export interface UpdateBankAccountDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  /**
   * A valid 4 to 17 digit account number.
   * @pattern ^[0-9]{4,17}$
   */
  accountNumber?: string;
  /**
   * A valid 9-digit bank routing number.
   * @pattern ^[0-9]{9}$
   */
  routingNumber?: string;
  type?: BankAccountType;
  scheduledSweepDays?: number[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 1
   */
  chartOfAccountIds?: string[];
}

/** UpdateChartOfAccountDto */
export interface UpdateChartOfAccountDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  parentId?: string;
  /**
   * @format int32
   * @min 100000
   * @max 899999
   */
  number?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  name?: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  description?: string;
}

/** UpdateChatDto */
export interface UpdateChatDto {
  /** @minLength 1 */
  subject: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  participantLanguage?:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  assignedPropertyManagerId?: string;
  pinned?: boolean;
}

/** UpdateChatNoteDto */
export interface UpdateChatNoteDto {
  body: string;
}

/** UpdateCompanyDto */
export interface UpdateCompanyDto {
  /**
   * @minLength 2
   * @maxLength 150
   */
  name: string;
  /**
   * A valid email address.
   * @minLength 1
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  address: RequiredAddressDto;
}

/** UpdateCompanyOnboardingStatusDto */
export interface UpdateCompanyOnboardingStatusDto {
  /**
   * @minLength 0
   * @maxLength 150
   */
  status: string;
}

/** UpdateCustomFieldDto */
export interface UpdateCustomFieldDto {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  public?: boolean;
  filterable?: boolean;
  listable?: boolean;
  /** @format int32 */
  order?: number;
  options?:
    | CustomStringFieldOptionsDto
    | CustomNumberFieldOptionsDto
    | CustomBooleanFieldOptionsDto
    | CustomDateTimeFieldOptionsDto
    | CustomReferenceFieldOptionsDto;
  active?: boolean;
}

/** UpdateFileAttachmentDto */
export interface UpdateFileAttachmentDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  fileName: string;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description?: string;
}

/** UpdateLeaseChargeFilesDto */
export interface UpdateLeaseChargeFilesDto {
  /** @minItems 1 */
  files: LeaseChargeFileDto[];
}

/** UpdateLeaseDepositFilesDto */
export interface UpdateLeaseDepositFilesDto {
  /** @minItems 1 */
  files: LeaseDepositFileDto[];
}

/** UpdateLeaseDocumentDto */
export interface UpdateLeaseDocumentDto {
  /** @minLength 1 */
  name: string;
  signers: UpdateLeaseDocumentSignerDto[];
  annotations: LeaseDocumentAnnotationDto[];
}

/** UpdateLeaseDocumentSignerDto */
export interface UpdateLeaseDocumentSignerDto {
  /** @minLength 1 */
  id: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  signatureName: string;
  /**
   * @minLength 1
   * @maxLength 10
   */
  signatureInitials: string;
  type: LeaseDocumentSignerType;
}

/** UpdateLeaseDto */
export interface UpdateLeaseDto {
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  eviction: boolean;
  monthToMonth: boolean;
  icons: string[];
}

/** UpdateLeaseEvictionStatusDto */
export interface UpdateLeaseEvictionStatusDto {
  eviction: boolean;
}

/** UpdateLeaseRecurringPaymentDto */
export interface UpdateLeaseRecurringPaymentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  paymentFrequency: ChargeFrequency;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description?: string;
  paymentMethod?: OfflineTransactionPaymentMethod;
  /**
   * @minLength 0
   * @maxLength 150
   */
  reference?: string;
  updatePastPayments: boolean;
}

/** UpdateLeaseSubsidyDto */
export interface UpdateLeaseSubsidyDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  ownerId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  subsidizerId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId?: string;
  subsidyType?: SubsidyType;
  /**
   * @minLength 1
   * @maxLength 100
   */
  voucherNumber?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  subsidyFrequency?: ChargeFrequency;
  /** @format date */
  effectiveDate?: string;
  /** @format date */
  endDate?: string;
  updatePastSubsidies: boolean;
}

/** UpdateLeaseTemplateDto */
export interface UpdateLeaseTemplateDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseTemplateCategoryId: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  description?: string;
  signers: LeaseTemplateSignerDto[];
  annotations: LeaseDocumentAnnotationDto[];
  type?: LeaseTemplateType;
}

/** UpdateMeetingScheduleDto */
export interface UpdateMeetingScheduleDto {
  /**
   * @minLength 0
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  link?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalProvider?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalIdentifier?: string;
  /** @format date-time */
  startTime: string;
  /** @format date-time */
  startTimeUtc?: string;
  /** @format date-time */
  endTime: string;
  /** @format date-time */
  endTimeUtc?: string;
  /** @format date-time */
  cancelled?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  cancellationReason?: string;
}

/** UpdateNoteDto */
export interface UpdateNoteDto {
  /** @minLength 1 */
  content: string;
}

/** UpdateNotificationScheduleDto */
export interface UpdateNotificationScheduleDto {
  target: TenantNotificationTargetDto | LeaseNotificationTargetDto | OwnerNotificationTargetDto | VendorNotificationTargetDto;
  template: NotificationTemplateDto;
  /** @format date-time */
  time: string;
}

/** UpdateOwnerContributionDto */
export interface UpdateOwnerContributionDto {
  /** @format date */
  contributionDate?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  reference?: string;
  lineItems?: OwnerContributionLineItemDto[];
  metadata?: Record<string, string>;
}

/** UpdateOwnerContributionFilesDto */
export interface UpdateOwnerContributionFilesDto {
  /** @minItems 1 */
  files: OwnerContributionFileDto[];
}

/** UpdateOwnerDistributionDto */
export interface UpdateOwnerDistributionDto {
  /** @format date */
  distributionDate?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
}

/** UpdateOwnerDistributionFilesDto */
export interface UpdateOwnerDistributionFilesDto {
  /** @minItems 1 */
  files: OwnerDistributionFileDto[];
}

/** UpdateOwnerDto */
export interface UpdateOwnerDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  isCompany: boolean;
  /**
   * A valid email address.
   * @minLength 0
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language?:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  address?: AddressDto;
}

/** UpdateOwnerPasswordDto */
export interface UpdateOwnerPasswordDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  password: string;
}

/** UpdateOwnerTransferDto */
export interface UpdateOwnerTransferDto {
  /** @format date-time */
  transferDate?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount?: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fromPropertyId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  toPropertyId?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  reference?: string;
  paymentMethod?: TransactionPaymentMethod;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalTransactionId?: string;
  metadata?: Record<string, string>;
}

/** UpdateOwnerTransferFilesDto */
export interface UpdateOwnerTransferFilesDto {
  /** @minItems 1 */
  files: OwnerTransferFileDto[];
}

/** UpdatePolicyHandbookDto */
export interface UpdatePolicyHandbookDto {
  level: PolicyHandbookLevel;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  levelId?: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  title: string;
  /**
   * @minLength 0
   * @maxLength 2000
   */
  description?: string;
  /** @minLength 1 */
  script: string;
  enabled: boolean;
}

/** UpdatePortalSettingsDto */
export interface UpdatePortalSettingsDto {
  /**
   * [DEPRECATED] Use IconUploadSessionId instead
   * @deprecated
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  iconFileId?: string;
  /**
   * [DEPRECATED] Use LogoUploadSessionId instead
   * @deprecated
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  logoFileId?: string;
  /**
   * [DEPRECATED] Use CoverUploadSessionId instead
   * @deprecated
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  coverFileId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  iconUploadSessionId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  logoUploadSessionId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  coverUploadSessionId?: string;
  metadata?: WebsiteMetadata;
  contact?: ContactPhoneEmailDto;
  socialLinks?: {
    twitter?: string;
    facebook?: string;
    instagram?: string;
    linkedIn?: string;
    youTube?: string;
    tikTok?: string;
  };
  /**
   * @minLength 2
   * @maxLength 2
   */
  translationLanguages?:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
}

/** UpdatePropertyDto */
export interface UpdatePropertyDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name?: string;
  address: RequiredAddressDto;
  type: PropertyType;
  /**
   * [DEPRECATED] Use ImageSessionId instead
   * @deprecated
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  imageId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  imageSessionId?: string;
  icons?: string[];
  magicTags?: Record<string, string>;
  /**
   * @format int32
   * @min 1
   * @max 200
   */
  totalFloors?: number;
}

/** UpdatePropertyImageDto */
export interface UpdatePropertyImageDto {
  /**
   * [DEPRECATED] Use UploadSessionId instead
   * @deprecated
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId?: string;
}

/** UpdatePropertyMagicTagDto */
export interface UpdatePropertyMagicTagDto {
  magicTags: Record<string, string>;
}

/** UpdatePropertyManagerActiveDto */
export interface UpdatePropertyManagerActiveDto {
  active: boolean;
}

/** UpdatePropertyManagerDto */
export interface UpdatePropertyManagerDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  /**
   * A valid email address.
   * @minLength 1
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
}

/** UpdatePropertyManagerImageDto */
export interface UpdatePropertyManagerImageDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId: string;
}

/** UpdatePropertyManagerMeDto */
export interface UpdatePropertyManagerMeDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  /**
   * A valid email address.
   * @minLength 1
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
}

/** UpdatePropertyManagerMePasswordDto */
export interface UpdatePropertyManagerMePasswordDto {
  /**
   * @minLength 5
   * @maxLength 150
   */
  clearTextPassword: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  currentPassword: string;
}

/** UpdatePropertyManagerMenuAccessDto */
export interface UpdatePropertyManagerMenuAccessDto {
  /** The complete list of enabled menu access keys. "*" = all menus. Valid keys: onboarding, home, properties, listing, leasing, users, accounting, reports, maintenance, associations, communications, ai, settings. */
  menuAccess: string[];
}

/** UpdatePropertyManagerPasswordDto */
export interface UpdatePropertyManagerPasswordDto {
  /**
   * @minLength 5
   * @maxLength 150
   */
  clearTextPassword: string;
}

/** UpdateRecurringLeaseChargeDto */
export interface UpdateRecurringLeaseChargeDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  chargeFrequency: ChargeFrequency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description?: string;
  companyCharge?: boolean;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
  updatePastCharges: boolean;
}

/** UpdateRecurringLeaseCreditDto */
export interface UpdateRecurringLeaseCreditDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  creditFrequency: ChargeFrequency;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description?: string;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
  updatePastCredits: boolean;
}

/** UpdateRecurringVendorBillDto */
export interface UpdateRecurringVendorBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId: string;
  reference?: string;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  memo?: string;
  /** @default false */
  companyCharge: boolean;
  /**
   * @format int32
   * @min 0
   * @max 365
   */
  dueDays?: number;
  /** @minItems 1 */
  lineItems: RecurringVendorBillLineItemDto[];
  chargeFrequency: ChargeFrequency;
  /** @format date */
  ends?: string;
}

/** UpdateSubsidizerDto */
export interface UpdateSubsidizerDto {
  type?: SubsidizerType;
  /**
   * @minLength 1
   * @maxLength 200
   */
  name?: string;
  /**
   * @minLength 2
   * @maxLength 10
   */
  language?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  website?: string;
  contact?: ContactPhoneEmailDto;
  address?: AddressDto;
  federalTaxInformation?: FederalTaxInformationDto;
  paymentSettings?: SubsidizerPaymentSettingsDto;
}

/** UpdateTenantDto */
export interface UpdateTenantDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  /**
   * A valid email address.
   * @minLength 0
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language?:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  /**
   * A valid SSN or EIN.
   * @minLength 9
   * @maxLength 11
   * @pattern ^(\d{3}-?\d{2}-?\d{4}|\d{9}|\d{2}-?\d{7})$
   */
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons?: string[];
}

/** UpdateTenantPasswordDto */
export interface UpdateTenantPasswordDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  password: string;
}

/** UpdateUnitDto */
export interface UpdateUnitDto {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  address?: RequiredAddressDto;
  /**
   * Value must be a double greater than or equal to 0 and evenly divisible by 0.5.
   * @format double
   * @min 0
   */
  beds?: number;
  /**
   * Value must be a double greater than or equal to 0 and evenly divisible by 0.5.
   * @format double
   * @min 0
   */
  baths?: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  unitSizeSqft?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  marketRent?: number;
  /**
   * @format int32
   * @min 1
   * @max 200
   */
  floor?: number;
  /**
   * [DEPRECATED] Use ImageSessionId instead
   * @deprecated
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  imageId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  imageSessionId?: string;
  icons?: string[];
  magicTags?: Record<string, string>;
}

/** UpdateUnitImageDto */
export interface UpdateUnitImageDto {
  /**
   * [DEPRECATED] Use UploadSessionId instead
   * @deprecated
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  uploadSessionId?: string;
}

/** UpdateUnitListingDto */
export interface UpdateUnitListingDto {
  status?: UnitListingStatus;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  rentalPrice?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  securityDeposit?: number;
  /** @format date */
  availableFrom?: string;
  leaseTerm?: LeaseTerm;
  /**
   * @minLength 1
   * @maxLength 150
   */
  title?: string;
  /**
   * @minLength 1
   * @maxLength 2500
   */
  description?: string;
  /**
   * [DEPRECATED] Use Images endpoint separately instead
   * @deprecated
   * @maxItems 50
   */
  images?: UpdateUnitListingFileItemDto[];
  /**
   * [DEPRECATED] Use Videos endpoint separately instead
   * @deprecated
   * @maxItems 5
   */
  videos?: UpdateUnitListingFileItemDto[];
  /** @maxItems 50 */
  tags?: string[];
  petPolicy?: PetPolicyDto;
  /** @maxItems 30 */
  amenities?: AmenityDto[];
  terms?: Record<string, string>;
  listed?: boolean;
  pinned?: boolean;
}

/** UpdateUnitListingFileItemDto */
export interface UpdateUnitListingFileItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  default?: boolean;
  /** @maxLength 200 */
  description?: string;
  signedUrl?: string;
  signedThumbUrl?: string;
}

/** UpdateUnitListingImageItemDto */
export interface UpdateUnitListingImageItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  default?: boolean;
  /** @format int32 */
  order?: number;
}

/** UpdateUnitListingImagesDto */
export interface UpdateUnitListingImagesDto {
  /** @minItems 1 */
  images: UpdateUnitListingImageItemDto[];
}

/** UpdateUnitListingVideoItemDto */
export interface UpdateUnitListingVideoItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  default?: boolean;
  /** @format int32 */
  order?: number;
}

/** UpdateUnitListingVideosDto */
export interface UpdateUnitListingVideosDto {
  /** @minItems 1 */
  videos: UpdateUnitListingVideoItemDto[];
}

/** UpdateUnitMagicTagDto */
export interface UpdateUnitMagicTagDto {
  magicTags: Record<string, string>;
}

/** UpdateVendorBillDto */
export interface UpdateVendorBillDto {
  companyBill?: boolean;
  /** @format date */
  billDate?: string;
  /** @format date */
  dueDate?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId?: string;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  reference?: string;
  /** @minItems 1 */
  lineItems: UpdateVendorBillLineItemDto[];
  adjustPayments: boolean;
}

/** UpdateVendorBillFilesDto */
export interface UpdateVendorBillFilesDto {
  /** @minItems 1 */
  files: VendorBillFileDto[];
}

/** UpdateVendorBillLineItemDto */
export interface UpdateVendorBillLineItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
}

/** UploadResultDto */
export interface UploadResultDto {
  fileId: string;
  signedUrl: string;
  thumbSignedUrl?: string;
}

/** UploadSessionDto */
export interface UploadSessionDto {
  sessionId: string;
  endpoint: string;
  method: string;
  fields: Record<string, string>;
  /** @format date-time */
  expires: string;
}

/** ValidPropertyDto */
export interface ValidPropertyDto {
  property: PropertyDto;
  owners: PropertyOwnerIdDto[];
}

/** ValidateDto */
export interface ValidateDto {
  isValid: boolean;
}

/** VendorBillAchResultsDto */
export interface VendorBillAchResultsDto {
  successful: VendorBillResultDto[];
  scheduled: VendorBillResultDto[];
  failed: FailedVendorBillResultDto[];
}

/** VendorBillAllocationDto */
export interface VendorBillAllocationDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  transactionId: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  /** @format date-time */
  applied: string;
  /**
   * Timestamp when this allocation was voided (e.g., due to transaction failure).
   * @format date-time
   */
  voided?: string;
  /** Reason for voiding this allocation (e.g., 'Transaction failed', 'Payment declined'). */
  voidReason?: string;
}

/** VendorBillDto */
export interface VendorBillDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  companyBill: boolean;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
  reference?: string;
  sourceType?: VendorBillSourceType;
  sourceId?: string;
  vendorId: string;
  status: VendorBillStatus;
  assignedToId?: string;
  assignedById?: string;
  /** @format date-time */
  assignedAt?: string;
  lineItems: VendorBillLineItemDto[];
  files: VendorBillFileDto[];
  statusHistory: VendorBillStatusChangeDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
  vendor: VendorDto;
  properties: PropertyDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  chartOfAccounts: ChartOfAccountDto[];
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  hydratedFiles: FileDto[];
  creatorInfo: CreatorInfoDto;
}

/** VendorBillFileDto */
export interface VendorBillFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** VendorBillItemDto */
export interface VendorBillItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  companyBill: boolean;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  memo?: string;
  reference?: string;
  sourceType?: VendorBillSourceType;
  sourceId?: string;
  vendorId: string;
  status: VendorBillStatus;
  assignedToId?: string;
  assignedById?: string;
  /** @format date-time */
  assignedAt?: string;
  lineItems: VendorBillLineItemDto[];
  files: VendorBillFileDto[];
  statusHistory: VendorBillStatusChangeDto[];
  metadata: Record<string, string>;
  creator: CreatorDto;
}

/** VendorBillLineItemDto */
export interface VendorBillLineItemDto {
  id?: string;
  /** @format int32 */
  order: number;
  chartOfAccountId: string;
  portfolioId?: string;
  propertyId?: string;
  unitId?: string;
  leaseId?: string;
  description?: string;
  /** @format double */
  amount: number;
  allocations: VendorBillAllocationDto[];
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
}

/** VendorBillPaginationDto */
export interface VendorBillPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: VendorBillItemDto[];
  vendors: VendorDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  transactions: TransactionItemDto[];
  bankAccounts: BankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
  propertyManagers: PropertyManagerDto[];
  tenants: TenantDto[];
  owners: OwnerDto[];
}

/** VendorBillPaymentDto */
export interface VendorBillPaymentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  billId: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
}

/** VendorBillPaymentResultDto */
export interface VendorBillPaymentResultDto {
  bill: VendorBillItemDto;
  /** @format double */
  amount: number;
}

/** VendorBillPrintCheckResultDto */
export interface VendorBillPrintCheckResultDto {
  vendor: VendorDto;
  bankAccount: BankAccountDto;
  transaction: TransactionItemDto;
  payments: VendorBillPaymentResultDto[];
  check: HydratedCheckDto;
}

/** VendorBillResultDto */
export interface VendorBillResultDto {
  vendor: VendorDto;
  bankAccount: BankAccountDto;
  transaction: TransactionItemDto;
  payments: VendorBillPaymentResultDto[];
}

/** VendorBillStatusChangeDto */
export interface VendorBillStatusChangeDto {
  status: VendorBillStatus;
  changedById?: string;
  /** @format date-time */
  changedAt: string;
  reason?: string;
}

/** VendorBillsToPayDto */
export interface VendorBillsToPayDto {
  properties: BillPayProperty[];
  companyVendorBills: CompanyVendorBillItemDto[];
  vendors: HydratedVendorDto[];
}

/** VendorBillsToSettleDto */
export interface VendorBillsToSettleDto {
  properties: BillSettleProperty[];
  companyVendorBills: CompanyVendorBillItemDto[];
  vendors: HydratedVendorDto[];
}

/** VendorDto */
export interface VendorDto {
  id: string;
  name: string;
  language: string;
  contact: ContactDto;
  memo?: string;
  active: boolean;
  website?: string;
  irs1099Form?: FederalTaxInformationDto;
  insurancePolicy?: InsurancePolicyDto;
  chatId?: string;
  icons: string[];
  type: VendorType;
  defaultMemo?: string;
  paymentSettings: PaymentSettingsDto;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
}

/** VendorNotificationTargetDto */
export type VendorNotificationTargetDto = (UtilRequiredKeys<BaseNotificationTargetDto, 'type'> & {
  vendorIds?: string[];
}) & {
  type: 'Vendor';
};

/** VendorTaxAmountDto */
export interface VendorTaxAmountDto {
  accountId: string;
  /** @format int32 */
  calendarYear: number;
  /** @format double */
  amount: number;
  documentAlreadyExists: boolean;
  amountHasChanged: boolean;
  hasTaxId: boolean;
  vendor: VendorDto;
}

/** VendorTaxDocumentPaginationDto */
export interface VendorTaxDocumentPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: TaxDocumentListDto[];
}

/** VerifyTwoFactorCodeDto */
export interface VerifyTwoFactorCodeDto {
  /** @minLength 1 */
  mfaSessionToken: string;
  /** @minLength 1 */
  otpRequestId: string;
  /**
   * @minLength 4
   * @maxLength 10
   */
  code: string;
}

/** VoidCheckRequestDto */
export interface VoidCheckRequestDto {
  /**
   * @minLength 0
   * @maxLength 900
   */
  voidReason?: string;
}

/** WebsiteMetadata */
export interface WebsiteMetadata {
  title: string;
  titleTemplate: string;
  description: string;
  keywords: string[];
  themeColor: string;
  theme: WebsiteTheme;
}

/** WorkOrderBillDto */
export interface WorkOrderBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  files?: WorkOrderDraftBillFileDto[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  billId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId?: string;
  approved: boolean;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate?: string;
  lineItems: WorkOrderBillLineItemDto[];
}

/** WorkOrderBillLineItemDto */
export interface WorkOrderBillLineItemDto {
  /**
   * @minLength 0
   * @maxLength 150
   */
  memo?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000, with at most 2 decimal places.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId?: string;
}

/** WorkOrderDraftBillFileDto */
export interface WorkOrderDraftBillFileDto {
  id: string;
  /** @format date-time */
  created: string;
  name: string;
  extension: string;
  /** @format int32 */
  size: number;
  contentType: string;
  secureUrl: FileUrlDto;
  /**
   * [DEPRECATED] Use Id instead.
   * @deprecated
   */
  fileId: string;
  /**
   * [DEPRECATED] Use Name instead.
   * @deprecated
   */
  fileName: string;
  /**
   * [DEPRECATED] Use SecureUrl instead.
   * @deprecated
   */
  signedUrl: string;
  /**
   * [DEPRECATED] Use SecureUrl instead.
   * @deprecated
   */
  signedThumbUrl?: string;
  /**
   * [DEPRECATED] Use Size instead.
   * @deprecated
   * @format int32
   */
  fileSize: number;
  /**
   * [DEPRECATED] Use Created instead.
   * @deprecated
   * @format date-time
   */
  uploaded: string;
  /**
   * [DEPRECATED] Debug purpose only, Do not use in production.
   * @deprecated
   */
  claimed: boolean;
  /**
   * @minLength 0
   * @maxLength 250
   */
  description?: string;
}

/** WorkOrderFileDto */
export interface WorkOrderFileDto {
  id: string;
  /** @format date-time */
  created: string;
  name: string;
  extension: string;
  /** @format int32 */
  size: number;
  contentType: string;
  secureUrl: FileUrlDto;
  /**
   * [DEPRECATED] Use Id instead.
   * @deprecated
   */
  fileId: string;
  /**
   * [DEPRECATED] Use Name instead.
   * @deprecated
   */
  fileName: string;
  /**
   * [DEPRECATED] Use SecureUrl instead.
   * @deprecated
   */
  signedUrl: string;
  /**
   * [DEPRECATED] Use SecureUrl instead.
   * @deprecated
   */
  signedThumbUrl?: string;
  /**
   * [DEPRECATED] Use Size instead.
   * @deprecated
   * @format int32
   */
  fileSize: number;
  /**
   * [DEPRECATED] Use Created instead.
   * @deprecated
   * @format date-time
   */
  uploaded: string;
  /**
   * [DEPRECATED] Debug purpose only, Do not use in production.
   * @deprecated
   */
  claimed: boolean;
  description?: string;
  /** @format date */
  addedOn: string;
}

/** WorkOrderListDto */
export interface WorkOrderListDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chatId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  groupChatId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  assignedPropertyManagerId?: string;
  reference: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  maintenanceRequestId?: string;
  status: WorkOrderStatus;
  /**
   * @minLength 1
   * @maxLength 150
   */
  title: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string;
  /** @format date */
  dueDate?: string;
  urgency: Urgency;
}

/** ZillowSyndicationStatusDto */
export interface ZillowSyndicationStatusDto {
  status: SyndicationStatus;
  url: string;
}

/** NotificationTargetDto */
interface BaseNotificationTargetDto {
  type: 'Lease' | 'Owner' | 'Tenant' | 'Vendor';
}

type BaseNotificationTargetDtoTypeMapping<Key, Type> = {
  type: Key;
} & Type;

/** CustomFieldOptionsDto */
interface BaseCustomFieldOptionsDto {
  type: 'boolean' | 'datetime' | 'number' | 'reference' | 'string';
  required: boolean;
  componentType?: CustomFieldComponentType;
}

type BaseCustomFieldOptionsDtoTypeMapping<Key, Type> = {
  type: Key;
} & Type;

/** ConditionDto */
interface BaseConditionDto {
  type: 'LatePaymentCount' | 'LeaseBalance' | 'MaintenanceRequestCount' | 'RentAmount' | 'SecurityDeposit' | 'TenantCount';
  operator: ConditionOperator;
}

type BaseConditionDtoTypeMapping<Key, Type> = {
  type: Key;
} & Type;

export interface GetAnnouncementParams {
  /** @format int64 */
  announcementId: string;
}

export interface GetAnnouncementsParams {
  /** @format date-time */
  'sentAt.start'?: string;
  /** @format date-time */
  'sentAt.end'?: string;
  portfolioIds?: string[];
  propertyIds?: string[];
  unitIds?: string[];
  leaseIds?: string[];
  vendorIds?: string[];
  ownerIds?: string[];
}

export interface GetAssociationViolationsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  portfolioIds?: string[];
  propertyIds?: string[];
  unitIds?: string[];
  leaseIds?: string[];
  statuses?: AssociationViolationStatus[];
  hoaVendorIds?: string[];
  /** @format date-time */
  'fixByDate.start'?: string;
  /** @format date-time */
  'fixByDate.end'?: string;
  /** @format date-time */
  'violationDate.start'?: string;
  /** @format date-time */
  'violationDate.end'?: string;
  /** @format date-time */
  'violationReceivedDate.start'?: string;
  /** @format date-time */
  'violationReceivedDate.end'?: string;
}

export interface GetAssociationViolationParams {
  /** @format int64 */
  violationId: string;
}

export interface UpdateAssociationViolationParams {
  /** @format int64 */
  violationId: string;
}

export interface DeleteAssociationViolationParams {
  /** @format int64 */
  violationId: string;
}

export interface RequestAssociationViolationFileUploadSessionParams {
  /** @format int64 */
  violationId: string;
}

export interface RequestAssociationViolationFileUploadSession2Params {
  /** @format int64 */
  violationId: string;
}

export interface AddAssociationViolationFilesParams {
  /** @format int64 */
  violationId: string;
}

export interface AddAssociationViolationFiles2Params {
  /** @format int64 */
  violationId: string;
}

export interface DeleteFileParams {
  /** @format int64 */
  violationId: string;
  /** @format int64 */
  fileId: string;
}

export interface DeleteFile2Params {
  /** @format int64 */
  violationId: string;
  /** @format int64 */
  fileId: string;
}

export interface CreateFineBillParams {
  /** @format int64 */
  violationId: string;
}

export interface UpdateStatusParams {
  /** @format int64 */
  violationId: string;
}

export interface CreateWorkOrderFromAssociationViolationParams {
  /** @format int64 */
  violationId: string;
}

export interface RequestAssociationViolationNotificationUploadSessionParams {
  /** @format int64 */
  violationId: string;
}

export interface SendAssociationViolationLeaseNoticeParams {
  /** @format int64 */
  violationId: string;
}

export interface SendAssociationViolationOwnerNoticeParams {
  /** @format int64 */
  violationId: string;
}

export interface AddLeaseBillAssociationViolationNoticeParams {
  /** @format int64 */
  violationId: string;
}

export interface GetBankAccountParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface UpdateBankAccountParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface DeactivateBankAccountParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface GetBankAccountConnectionsParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface RequestBankAccountStatementUploadSessionParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface CreateBankAccountConnectionParams {
  /** @format int64 */
  bankAccountId: string;
  type: BankAccountConnectType;
}

export interface GetBankAccountSweepsParams {
  /** @format date-time */
  'created.start'?: string;
  /** @format date-time */
  'created.end'?: string;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format int64 */
  bankAccountId: string;
}

export interface SweepPlaidBalanceParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface GetBankAccountSweepDetailsParams {
  /** @format int64 */
  bankAccountId: string;
  /** @format int64 */
  sweepId: string;
}

export interface GetBankAccountPayoutsParams {
  /** @format date-time */
  'created.start'?: string;
  /** @format date-time */
  'created.end'?: string;
  /** @format int64 */
  bankAccountId: string;
}

export interface GetBankAccountPayoutDetailsParams {
  /** @format int64 */
  bankAccountId: string;
  payoutId: string;
}

export interface UpdateChartOfAccountParams {
  /** @format int64 */
  chartOfAccountId: string;
}

export interface DeleteChartOfAccountParams {
  /** @format int64 */
  chartOfAccountId: string;
}

export interface GetChatsParams {
  closed?: boolean;
  humanEngagementRequested?: boolean;
  assignedPropertyManagerId?: string;
}

export interface GetChatParams {
  /** @format int64 */
  chatId: string;
}

export interface UpdateChatParams {
  /** @format int64 */
  chatId: string;
}

export interface ArchiveChatParams {
  /** @format int64 */
  chatId: string;
}

export interface UnarchiveChatParams {
  /** @format int64 */
  chatId: string;
}

export interface MagicChatMessageParams {
  /** @format int64 */
  chatId: string;
}

export interface UnderstandMessageParams {
  /** @format int64 */
  chatId: string;
  /** @format int64 */
  messageId: string;
}

export interface GetMessagesParams {
  /** @format date-time */
  before?: string;
  /** @format date-time */
  after?: string;
  /**
   * @format int32
   * @min 0
   * @max 250
   */
  take?: number;
  search?: string;
  fileName?: string;
  /** @format int64 */
  chatId: string;
}

export interface PostChatMessageParams {
  /** @format int64 */
  chatId: string;
}

export interface RequestChatMessageUploadSessionParams {
  /** @format int64 */
  chatId: string;
}

export interface SetMessagesReadParams {
  chatId: string;
}

export interface SetMessagesRead2Params {
  /** @format int64 */
  chatId: string;
}

export interface MarkMessageAsHandledParams {
  /** @format int64 */
  chatId: string;
  /** @format int64 */
  messageId: string;
}

export interface GetMessages2Params {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  messageType?: MessageType;
}

export interface SearchParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  search?: string;
  fileName?: string;
}

export interface AddChatNoteParams {
  /** @format int64 */
  chatId: string;
}

export interface UpdateChatNoteParams {
  /** @format int64 */
  chatId: string;
  /** @format int64 */
  noteId: string;
}

export interface DeleteChatNoteParams {
  /** @format int64 */
  chatId: string;
  /** @format int64 */
  noteId: string;
}

export interface SetChatHumanEngagementParams {
  /** @format int64 */
  chatId: string;
}

export interface AssignChatParams {
  /** @format int64 */
  chatId: string;
}

export interface GetChecksPaginatedParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  checkIdentity?: CheckIdentity;
  vendorIds?: string[];
  ownerIds?: string[];
  tenantIds?: string[];
  bankAccountIds?: string[];
  /** @format date */
  dateFrom?: string;
  /** @format date */
  dateTo?: string;
  /** @format double */
  'amount.from'?: number;
  /** @format double */
  'amount.to'?: number;
  'amount.includeFrom'?: boolean;
  'amount.includeTo'?: boolean;
  memo?: string;
  transactionIds?: string[];
  voided?: boolean;
}

export interface GetCheckParams {
  checkId: string;
}

export interface DeleteCheckParams {
  checkId: string;
}

export interface VoidCheckParams {
  checkId: string;
}

export interface GetCompanyInvoicesParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format date */
  from?: string;
  /** @format date */
  to?: string;
}

export interface GetCompanyInvoiceParams {
  /** @format int64 */
  billId: string;
}

export interface PayCompanyInvoiceParams {
  /** @format int64 */
  billId: string;
}

export interface GetMagicDoorBillCreditsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format date */
  'creditDate.start'?: string;
  /** @format date */
  'creditDate.end'?: string;
  /** @format double */
  'amount.from'?: number;
  /** @format double */
  'amount.to'?: number;
  'amount.includeFrom'?: boolean;
  'amount.includeTo'?: boolean;
}

export interface GetMagicDoorBillCreditParams {
  /** @format int64 */
  magicDoorBillCreditId: string;
}

export interface GetCompanyPayoutsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format date-time */
  'transferDate.start'?: string;
  /** @format date-time */
  'transferDate.end'?: string;
  /** @format double */
  'amount.from'?: number;
  /** @format double */
  'amount.to'?: number;
  'amount.includeFrom'?: boolean;
  'amount.includeTo'?: boolean;
}

export interface DeleteCompanyPayoutParams {
  /** @format int64 */
  transferId: string;
}

export interface CreateLeaseChatParams {
  /** @format int64 */
  leaseId: string;
}

export interface CreateTenantChatParams {
  /** @format int64 */
  tenantId: string;
}

export interface CreateTenantChat2Params {
  /** @format int64 */
  ownerId: string;
}

export interface CreateVendorChatParams {
  /** @format int64 */
  vendorId: string;
}

export interface CreateRentalApplicationChatParams {
  /** @format int64 */
  rentalApplicationId: string;
}

export interface CreateMaintenanceRequestChatParams {
  /** @format int64 */
  maintenanceRequestId: string;
}

export interface CreateWorkOrderChatParams {
  /** @format int64 */
  workOrderId: string;
}

export interface CreateWorkOrderGroupChatParams {
  /** @format int64 */
  workOrderId: string;
}

export interface GetCustomFieldsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  entityType?: EntityType;
  public?: boolean;
  filterable?: boolean;
  listable?: boolean;
  active?: boolean;
  /**
   * @minLength 3
   * @maxLength 100
   */
  search?: string;
}

export interface UpdateCustomFieldParams {
  /** @format int64 */
  customFieldId: string;
}

export interface DeleteCustomFieldParams {
  /** @format int64 */
  customFieldId: string;
}

export interface GetEmailParams {
  /** @format int64 */
  emailId: string;
}

export interface GetEmailsParams {
  ownerIds?: string[];
  tenantIds?: string[];
  leaseIds?: string[];
  vendorIds?: string[];
  subjectLike?: string;
  bodyLike?: string;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
}

export interface GetOwnerEmailsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format int64 */
  ownerId: string;
}

export interface SendOwnerEmailParams {
  /** @format int64 */
  ownerId: string;
}

export interface GetLeaseEmailsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format int64 */
  leaseId: string;
}

export interface SendLeaseEmailParams {
  /** @format int64 */
  leaseId: string;
}

export interface GetTenantEmailsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format int64 */
  tenantId: string;
}

export interface SendTenantEmailParams {
  /** @format int64 */
  tenantId: string;
}

export interface GetTenantEmails2Params {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format int64 */
  vendorId: string;
}

export interface SendVendorEmailParams {
  /** @format int64 */
  vendorId: string;
}

export interface GetFeatureHighlightsParams {
  language?: string;
}

export interface GetEntityFilesParams {
  entityType: EntityType;
  /** @format int64 */
  entityId: string;
}

export interface AddFileAttachmentParams {
  entityType: EntityType;
  /** @format int64 */
  entityId: string;
}

export interface RequestUploadSessionParams {
  entityType: EntityType;
  /** @format int64 */
  entityId: string;
}

export interface CreateFileAttachmentFromTemplateParams {
  entityType: EntityType;
  /** @format int64 */
  entityId: string;
}

export interface UpdateEntityFileParams {
  /** @format int64 */
  fileAttachmentId: string;
  entityType: string;
  entityId: string;
}

export interface DeleteEntityFileParams {
  /** @format int64 */
  fileAttachmentId: string;
  entityType: string;
  entityId: string;
}

export interface SetFileShareTypesParams {
  /** @format int64 */
  fileAttachmentId: string;
  entityType: string;
  entityId: string;
}

export interface GetFileParams {
  /** @format int64 */
  fileId: string;
}

export interface GetFile2Params {
  /** @format int64 */
  fileId: string;
  fileName: string;
}

export interface GetThumbnailFileParams {
  /** @format int64 */
  fileId: string;
}

export interface GetThumbnailFile2Params {
  /** @format int64 */
  fileId: string;
  fileName: string;
}

export interface GetFileWithSignatureParams {
  /** @format int64 */
  fileId: string;
  signature: string;
}

export interface GetFileWithSignature2Params {
  /** @format int64 */
  fileId: string;
  signature: string;
  fileName: string;
}

export interface GetThumbnailFileWithSignatureParams {
  /** @format int64 */
  fileId: string;
  signature: string;
}

export interface GetThumbnailFileWithSignature2Params {
  /** @format int64 */
  fileId: string;
  signature: string;
  fileName: string;
}

export interface CreateFlyerParams {
  template: FlyerTemplate;
}

export interface AddPortfolioIconParams {
  portfolioId: string;
  icon: string;
}

export interface RemovePortfolioIconParams {
  portfolioId: string;
  icon: string;
}

export interface AddPropertyIconParams {
  propertyId: string;
  icon: string;
}

export interface RemovePropertyIconParams {
  propertyId: string;
  icon: string;
}

export interface AddUnitIconParams {
  unitId: string;
  icon: string;
}

export interface RemoveUnitIconParams {
  unitId: string;
  icon: string;
}

export interface AddLeaseIconParams {
  leaseId: string;
  icon: string;
}

export interface RemoveLeaseIconParams {
  leaseId: string;
  icon: string;
}

export interface AddTenantIconParams {
  tenantId: string;
  icon: string;
}

export interface RemoveTenantIconParams {
  tenantId: string;
  icon: string;
}

export interface AddVendorIconParams {
  vendorId: string;
  icon: string;
}

export interface RemoveVendorIconParams {
  vendorId: string;
  icon: string;
}

export interface GetLeaseDocumentParams {
  /** @format int64 */
  leaseDocumentId: string;
}

export interface UpdateLeaseDocumentParams {
  /** @format int64 */
  leaseDocumentId: string;
}

export interface DeleteLeaseDocumentParams {
  /** @format int64 */
  leaseDocumentId: string;
}

export interface GetLeaseDocumentsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  portfolioId?: string;
  propertyId?: string;
  unitId?: string;
  leaseId?: string;
  status?: LeaseDocumentStatus;
}

export interface RequestCreateUploadSessionParams {
  /** @format int64 */
  leaseId?: string;
}

export interface RequestReplaceUploadSessionParams {
  /** @format int64 */
  leaseDocumentId: string;
}

export interface ReplaceLeaseDocumentFileParams {
  /** @format int64 */
  leaseDocumentId: string;
}

export interface BeginSigningLeaseDocumentParams {
  /** @format int64 */
  leaseDocumentId: string;
}

export interface ResendLeaseDocumentNotificationParams {
  /** @format int64 */
  leaseDocumentId: string;
}

export interface RetractLeaseDocumentParams {
  /** @format int64 */
  leaseDocumentId: string;
}

export interface GetLeaseDocumentDataPathsParams {
  /** @format int64 */
  leaseDocumentId: string;
}

export interface GetLeasesPaginatedParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format date-time */
  'leaseStart.start'?: string;
  /** @format date-time */
  'leaseStart.end'?: string;
  /** @format date-time */
  'leaseEnd.start'?: string;
  /** @format date-time */
  'leaseEnd.end'?: string;
  monthToMonth?: boolean;
  eviction?: boolean;
  withBalance?: boolean;
  withPostedBalance?: boolean;
  tenantIds?: string[];
  propertyId?: string;
  portfolioId?: string;
  unitId?: string;
  portfolioIds?: string[];
  propertyIds?: string[];
  unitIds?: string[];
  ended?: boolean;
  draft?: boolean;
  /** @format double */
  'balance.from'?: number;
  /** @format double */
  'balance.to'?: number;
  'balance.includeFrom'?: boolean;
  'balance.includeTo'?: boolean;
  /** @format double */
  'postedBalance.from'?: number;
  /** @format double */
  'postedBalance.to'?: number;
  'postedBalance.includeFrom'?: boolean;
  'postedBalance.includeTo'?: boolean;
  search?: string;
}

export interface GetBatchLeasesParams {
  leaseIds?: string[];
}

export interface GetExpiringLeasesPaginatedParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  portfolioIds?: string[];
  propertyIds?: string[];
  unitIds?: string[];
}

export interface GetMoveOutsLeasesPaginatedParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  portfolioIds?: string[];
  propertyIds?: string[];
  unitIds?: string[];
  /** @format date-time */
  'moveOutDateRange.start'?: string;
  /** @format date-time */
  'moveOutDateRange.end'?: string;
}

export interface GetSuggestedLeaseEndDateParams {
  /** @format date */
  startDate: string;
}

export interface GetOverlappingLeasesParams {
  /** @format date-time */
  startTime: string;
  /** @format date-time */
  endTime?: string;
  unitId: string;
}

export interface GetLeaseParams {
  leaseId: string;
}

export interface UpdateLeaseParams {
  leaseId: string;
}

export interface DeleteLeaseParams {
  leaseId: string;
}

export interface UpdateLeaseEvictionStatusParams {
  leaseId: string;
}

export interface ActivateLeaseParams {
  leaseId: string;
}

export interface EndLeaseParams {
  leaseId: string;
}

export interface ReactivateLeaseParams {
  leaseId: string;
}

export interface NotifyBalanceDueParams {
  leaseId: string;
}

export interface GetProratedAmountParams {
  /** @format double */
  rentAmount: number;
  /** @format date */
  leaseStartDate: string;
  /** @format date */
  firstChargeDate?: string;
}

export interface GetNextChangeDateParams {
  /** @format date */
  leaseStartDate: string;
}

export interface GetTenantAutoPaysParams {
  leaseId: string;
}

export interface GetLeaseInvoicesByBillIdParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  billId: string;
}

export interface CreateLeaseInvoiceParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  billId: string;
}

export interface SendLeaseInvoiceParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  invoiceId: string;
}

export interface GetLeaseInvoiceFileByInvoiceIdParams {
  /** @format int64 */
  invoiceId: string;
  leaseId: string;
}

export interface GetCustomFieldValuesParams {
  /** @format int64 */
  leaseId: string;
}

export interface RequestCustomFieldUploadSessionParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface SetCustomFieldValueParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface RemoveCustomFieldValueParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface RequestLeaseFileUploadSessionParams {
  /** @format int64 */
  leaseId: string;
}

export interface AddFileAttachment2Params {
  /** @format int64 */
  leaseId: string;
}

export interface GetLeaseFilesParams {
  /** @format int64 */
  leaseId: string;
}

export interface UpdateLeaseFileParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  fileAttachmentId: string;
}

export interface DeleteLeaseFileParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  fileAttachmentId: string;
}

export interface GetLeaseChargeLedgerParams {
  /**
   * @format int32
   * @min 1
   * @max 300
   */
  limit?: number;
  /** @format date-time */
  asOf?: string;
  /** @format int64 */
  leaseId: string;
}

export interface GetLeaseChargeLedgerInvoiceParams {
  /** @format int64 */
  leaseId: string;
}

export interface ReleaseLeaseBalanceParams {
  /** @format int64 */
  leaseId: string;
}

export interface PostLeaseChargeParams {
  /** @format int64 */
  leaseId: string;
}

export interface AdjustLeaseChargeParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  chargeId: string;
}

export interface GetLeaseChargeParams {
  /** @format int64 */
  chargeId: string;
  leaseId: string;
}

export interface DeleteLeaseChargeParams {
  /** @format int64 */
  chargeId: string;
  leaseId: string;
}

export interface GetLeaseLateFeeParams {
  /** @format int64 */
  lateFeeId: string;
  leaseId: string;
}

export interface DeleteLeaseLateFeeParams {
  /** @format int64 */
  lateFeeId: string;
  leaseId: string;
}

export interface RequestLeaseChargeFileUploadSessionParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  chargeId: string;
}

export interface AddLeaseChargeFilesParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  chargeId: string;
}

export interface UpdateLeaseChargeFilesParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  chargeId: string;
}

export interface RemoveLeaseChargeFilesParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  chargeId: string;
}

export interface AddLeaseChargePaymentParams {
  /** @format int64 */
  leaseId: string;
}

export interface AdjustLeaseChargePaymentParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  paymentId: string;
}

export interface GetLeaseChargePaymentParams {
  /** @format int64 */
  paymentId: string;
  leaseId: string;
}

export interface DeleteLeaseChargePaymentParams {
  /** @format int64 */
  paymentId: string;
  leaseId: string;
}

export interface ReturnLeaseChargePaymentParams {
  /** @format int64 */
  paymentId: string;
  leaseId: string;
}

export interface PostLeaseChargeCreditParams {
  /** @format int64 */
  leaseId: string;
}

export interface AdjustLeaseChargeCreditParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  creditId: string;
}

export interface GetLeaseChargeCreditParams {
  /** @format int64 */
  creditId: string;
  leaseId: string;
}

export interface DeleteLeaseChargeCreditParams {
  /** @format int64 */
  creditId: string;
  leaseId: string;
}

export interface GetLeaseChargeTransferParams {
  /** @format int64 */
  transferId: string;
  leaseId: string;
}

export interface DeleteLeaseChargeTransferParams {
  /** @format int64 */
  transferId: string;
  leaseId: string;
}

export interface GetLeaseRecurringChargeParams {
  chartOfAccountIds?: string[];
  /** @default false */
  includeEnded?: boolean;
  /** @format int64 */
  leaseId: string;
}

export interface CreateLeaseRecurringChargeParams {
  /** @format int64 */
  leaseId: string;
}

export interface DeleteLeaseRecurringChargeParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  recurringChargeId: string;
}

export interface UpdateLeaseRecurringChargeParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  recurringChargeId: string;
}

export interface GetLeaseRecurringCreditsParams {
  /** @default false */
  includeEnded?: boolean;
  /** @format int64 */
  leaseId: string;
}

export interface CreateLeaseRecurringCreditParams {
  /** @format int64 */
  leaseId: string;
}

export interface UpdateLeaseRecurringCreditParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  recurringCreditId: string;
}

export interface DeleteLeaseRecurringCreditParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  recurringCreditId: string;
}

export interface GetRecurringLeasePaymentsParams {
  /** @default false */
  includeEnded?: boolean;
  /** @default false */
  includeInactive?: boolean;
  /** @format int64 */
  leaseId: string;
}

export interface CreateRecurringLeasePaymentParams {
  /** @format int64 */
  leaseId: string;
}

export interface UpdateRecurringLeasePaymentParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  recurringPaymentId: string;
}

export interface DeleteRecurringLeasePaymentParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  recurringPaymentId: string;
}

export interface GetLeaseDepositLedgerParams {
  /**
   * @format int32
   * @min 1
   * @max 300
   */
  limit?: number;
  /** @format date-time */
  asOf?: string;
  /** @format int64 */
  leaseId: string;
}

export interface ReleaseLeaseDepositParams {
  /** @format int64 */
  leaseId: string;
}

export interface AllocateLeaseDepositParams {
  /** @format int64 */
  leaseId: string;
}

export interface PostLeaseDepositParams {
  /** @format int64 */
  leaseId: string;
}

export interface AdjustLeaseDepositParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  depositId: string;
}

export interface GetLeaseDepositParams {
  /** @format int64 */
  depositId: string;
  leaseId: string;
}

export interface DeleteLeaseDepositParams {
  /** @format int64 */
  depositId: string;
  leaseId: string;
}

export interface RequestLeaseDepositFileUploadSessionParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  depositId: string;
}

export interface AddLeaseDepositFilesParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  depositId: string;
}

export interface UpdateLeaseDepositFilesParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  depositId: string;
}

export interface RemoveLeaseDepositFilesParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  depositId: string;
}

export interface AddLeaseDepositPaymentParams {
  /** @format int64 */
  leaseId: string;
}

export interface AdjustLeaseDepositPaymentParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  paymentId: string;
}

export interface GetLeaseDepositPaymentParams {
  /** @format int64 */
  paymentId: string;
  leaseId: string;
}

export interface DeleteLeaseDepositPaymentParams {
  /** @format int64 */
  paymentId: string;
  leaseId: string;
}

export interface GetLeaseDepositTransferParams {
  /** @format int64 */
  transferId: string;
  leaseId: string;
}

export interface DeleteLeaseDepositTransferParams {
  /** @format int64 */
  transferId: string;
  leaseId: string;
}

export interface GetMoveOutRequestsParams {
  /** @format int64 */
  leaseId: string;
}

export interface SetMoveOutDateParams {
  /** @format int64 */
  leaseId: string;
}

export interface AcceptMoveOutRequestParams {
  /** @format int64 */
  moveOutRequestId: string;
  leaseId: string;
}

export interface RejectMoveOutRequestParams {
  /** @format int64 */
  moveOutRequestId: string;
  leaseId: string;
}

export interface GetRenewalOffersParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  statuses?: LeaseRenewalStatus[];
}

export interface DeleteLeaseRenewalOfferParams {
  /** @format int64 */
  offerId: string;
}

export interface GetCalculatedLeaseRenewalOfferParams {
  /** @format int64 */
  leaseId: string;
}

export interface GetRenewalOffers2Params {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  statuses?: LeaseRenewalStatus[];
  /** @format int64 */
  leaseId: string;
}

export interface CreateLeaseRenewalOfferParams {
  /** @format int64 */
  leaseId: string;
}

export interface GetRenewalOffersSummariesParams {
  /** @format int64 */
  leaseId: string;
}

export interface SendSigningParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  offerId: string;
}

export interface ApplyOfferParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  offerId: string;
}

export interface CreateAndApplyLeaseRenewalOfferParams {
  /** @format int64 */
  leaseId: string;
}

export interface DeleteLeaseRenewalOffer2Params {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  offerId: string;
}

export interface DeleteLeaseRenewalOfferAutomaticSettingParams {
  /** @format int64 */
  id: string;
}

export interface GetLeasesSubsidiesParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @minItems 1 */
  unitIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  subsidizerIds?: string[];
  subsidyType?: SubsidyType;
  /** @default true */
  active?: boolean;
  /** @format int64 */
  leaseId: string;
}

export interface CreateLeaseSubsidyParams {
  /** @format int64 */
  leaseId: string;
}

export interface GetLeaseSubsidyParams {
  /** @format int64 */
  leaseSubsidyId: string;
  leaseId: string;
}

export interface UpdateLeaseSubsidyParams {
  /** @format int64 */
  leaseSubsidyId: string;
  leaseId: string;
}

export interface DeleteLeaseSubsidyParams {
  /** @format int64 */
  leaseSubsidyId: string;
  leaseId: string;
}

export interface DeactivateLeaseSubsidyParams {
  /** @format int64 */
  leaseSubsidyId: string;
  leaseId: string;
}

export interface ReactivateLeaseSubsidyParams {
  /** @format int64 */
  leaseSubsidyId: string;
  leaseId: string;
}

export interface MoveInTenantParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  tenantId: string;
}

export interface MoveOutTenantParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  tenantId: string;
}

export interface ReinstateTenantParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  tenantId: string;
}

export interface GetLeaseTemplateDataPathsParams {
  type?: LeaseTemplateType;
}

export interface GetLeaseTemplatesParams {
  leaseTemplateCategoryId?: string;
}

export interface GetLeaseTemplateParams {
  /** @format int64 */
  leaseTemplateId: string;
}

export interface UpdateLeaseTemplateParams {
  /** @format int64 */
  leaseTemplateId: string;
}

export interface DeleteLeaseTemplateParams {
  /** @format int64 */
  leaseTemplateId: string;
}

export interface RequestUploadSession2Params {
  /** @format int64 */
  leaseTemplateCategoryId?: string;
}

export interface UpdateLeaseTemplateCategoryParams {
  /** @format int64 */
  leaseTemplateCategoryId: string;
}

export interface DeleteLeaseTemplateCategoryParams {
  /** @format int64 */
  leaseTemplateCategoryId: string;
}

export interface GetLeaseTransactionReceiptParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  transactionId: string;
}

export interface SendLeaseTransactionReceiptParams {
  /** @format int64 */
  leaseId: string;
  /** @format int64 */
  transactionId: string;
}

export interface GetPaginatedManagementFeesParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  unitIds?: string[];
  /** @minItems 1 */
  leaseIds?: string[];
  /** @minItems 1 */
  companyChartOfAccountIds?: string[];
  /** @minItems 1 */
  propertyChartOfAccountIds?: string[];
  /** @format date-time */
  'chargeDate.start'?: string;
  /** @format date-time */
  'chargeDate.end'?: string;
  /** @format date-time */
  'periodStart.start'?: string;
  /** @format date-time */
  'periodStart.end'?: string;
  /** @format date-time */
  'periodEnd.start'?: string;
  /** @format date-time */
  'periodEnd.end'?: string;
  /** @format double */
  'totalAmount.from'?: number;
  /** @format double */
  'totalAmount.to'?: number;
  'totalAmount.includeFrom'?: boolean;
  'totalAmount.includeTo'?: boolean;
}

export interface GetManagementFeeParams {
  /** @format int64 */
  managementFeeId: string;
}

export interface DeleteManagementFeesParams {
  /** @format int64 */
  managementFeeId: string;
}

export interface GetManagementFeeCreditsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @minItems 1 */
  bankAccountIds?: string[];
  /** @minItems 1 */
  chartOfAccountIds?: string[];
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @format date */
  'creditDate.start'?: string;
  /** @format date */
  'creditDate.end'?: string;
  /** @format double */
  'amount.from'?: number;
  /** @format double */
  'amount.to'?: number;
  'amount.includeFrom'?: boolean;
  'amount.includeTo'?: boolean;
}

export interface GetManagementFeeCreditParams {
  /** @format int64 */
  managementFeeCreditId: string;
}

export interface PutManagementFeeCreditParams {
  /** @format int64 */
  managementFeeCreditId: string;
}

export interface DeleteManagementFeeCreditParams {
  /** @format int64 */
  managementFeeCreditId: string;
}

export interface GetMeetingSchedulesParams {
  source?: MeetingScheduleSource;
  status?: MeetingScheduleStatus;
  /** @format date-time */
  'startTime.start'?: string;
  /** @format date-time */
  'startTime.end'?: string;
  /** @format date-time */
  'endTime.start'?: string;
  /** @format date-time */
  'endTime.end'?: string;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
}

export interface UpdateMeetingScheduleParams {
  /** @format int64 */
  meetingScheduleId: string;
}

export interface DeleteMeetingScheduleParams {
  /** @format int64 */
  meetingScheduleId: string;
}

export interface GetEntityNotesParams {
  type?: NoteType;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  entityType: EntityType;
  /** @format int64 */
  entityId: string;
}

export interface CreateEntityNoteParams {
  entityType: EntityType;
  /** @format int64 */
  entityId: string;
}

export interface GetEntityNotes2Params {
  type?: NoteType;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  entityType: EntityType;
  /** @format int64 */
  entityId: string;
}

export interface CreateEntityNote2Params {
  entityType: EntityType;
  /** @format int64 */
  entityId: string;
}

export interface GetEntityNoteParams {
  /** @format int64 */
  noteId: string;
  entityType: string;
  entityId: string;
}

export interface UpdateEntityNoteParams {
  /** @format int64 */
  noteId: string;
  entityType: string;
  entityId: string;
}

export interface DeleteEntityNoteParams {
  /** @format int64 */
  noteId: string;
  entityType: string;
  entityId: string;
}

export interface GetEntityNote2Params {
  /** @format int64 */
  noteId: string;
  entityType: string;
  entityId: string;
}

export interface UpdateEntityNote2Params {
  /** @format int64 */
  noteId: string;
  entityType: string;
  entityId: string;
}

export interface DeleteEntityNote2Params {
  /** @format int64 */
  noteId: string;
  entityType: string;
  entityId: string;
}

export interface GetNotificationSchedulesParams {
  source?: NotificationSource;
  status?: NotificationStatus;
  /** @format date-time */
  'time.start'?: string;
  /** @format date-time */
  'time.end'?: string;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
}

export interface GetNotificationScheduleParams {
  /** @format int64 */
  notificationScheduleId: string;
}

export interface UpdateNotificationScheduleParams {
  /** @format int64 */
  notificationScheduleId: string;
}

export interface DeleteNotificationScheduleParams {
  /** @format int64 */
  notificationScheduleId: string;
}

export interface GetOwnerPaymentAccountsParams {
  ownerId: string;
}

export interface AddOwnerPaymentAccountParams {
  ownerId: string;
}

export interface DeleteOwnerPaymentAccountParams {
  ownerId: string;
  paymentAccountId: string;
}

export interface GetOwnersParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  active?: boolean;
  firstName?: string;
  lastName?: string;
  firstOrLastName?: string;
  phone?: string;
  email?: string;
  portalStatus?: PortalStatus;
  /** @format date-time */
  'created.start'?: string;
  /** @format date-time */
  'created.end'?: string;
  ownerIds?: string[];
  portfolioIds?: string[];
  propertyIds?: string[];
  search?: string;
}

export interface GetBatchOwnersParams {
  ownerIds?: string[];
}

export interface GetOwnerParams {
  ownerId: string;
}

export interface UpdateOwnerParams {
  ownerId: string;
}

export interface UpdateOwnerPasswordParams {
  /** @format int64 */
  ownerId: string;
}

export interface SendPortalInviteParams {
  /** @format int64 */
  ownerId: string;
}

export interface DeactivateOwnerParams {
  /** @format int64 */
  ownerId: string;
}

export interface ReactivateOwnerParams {
  /** @format int64 */
  ownerId: string;
}

export interface GetCustomFieldValues2Params {
  /** @format int64 */
  ownerId: string;
}

export interface RequestCustomFieldUploadSession2Params {
  /** @format int64 */
  ownerId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface SetCustomFieldValue2Params {
  /** @format int64 */
  ownerId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface RemoveCustomFieldValue2Params {
  /** @format int64 */
  ownerId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface UpdateTaxDocumentParams {
  ownerId: string;
  taxType: TaxType;
  /** @format int32 */
  calendarYear: number;
}

export interface BatchCreateTaxDocumentParams {
  taxType: TaxType;
  /** @format int32 */
  calendarYear: number;
}

export interface GetTaxDocumentsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format int32 */
  calendarYear?: number;
  taxType?: TaxType;
  ownerId: string;
}

export interface GetAllTaxDocumentsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format int32 */
  calendarYear?: number;
  taxType?: TaxType;
}

export interface GetTaxAmountParams {
  ownerId: string;
  /** @format int32 */
  calendarYear: number;
}

export interface GetTaxAmountsParams {
  ownerIds?: string[];
  /** @format int32 */
  calendarYear: number;
}

export interface GetOwnerTransfersParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format date-time */
  'transferDate.start'?: string;
  /** @format date-time */
  'transferDate.end'?: string;
  /** @format double */
  'amount.from'?: number;
  /** @format double */
  'amount.to'?: number;
  'amount.includeFrom'?: boolean;
  'amount.includeTo'?: boolean;
  /** @minItems 1 */
  ownerIds?: string[];
  /** @minItems 1 */
  sourcePortfolioIds?: string[];
  /** @minItems 1 */
  destinationPortfolioIds?: string[];
  /** @minItems 1 */
  sourcePropertyIds?: string[];
  /** @minItems 1 */
  destinationPropertyIds?: string[];
  /**
   * @minLength 1
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  reference?: string;
}

export interface GetOwnerTransferParams {
  /** @format int64 */
  ownerTransferId: string;
}

export interface UpdateOwnerTransferParams {
  /** @format int64 */
  ownerTransferId: string;
}

export interface DeleteOwnerTransferParams {
  /** @format int64 */
  ownerTransferId: string;
}

export interface RequestOwnerTransferFileUploadSessionParams {
  /** @format int64 */
  ownerTransferId: string;
}

export interface AddOwnerTransferFilesParams {
  /** @format int64 */
  ownerTransferId: string;
}

export interface UpdateOwnerTransferFilesParams {
  /** @format int64 */
  ownerTransferId: string;
}

export interface RemoveOwnerTransferFilesParams {
  /** @format int64 */
  ownerTransferId: string;
}

export interface GetOwnerContributionsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format date-time */
  'contributionDate.start'?: string;
  /** @format date-time */
  'contributionDate.end'?: string;
  /** @format double */
  'totalAmount.from'?: number;
  /** @format double */
  'totalAmount.to'?: number;
  'totalAmount.includeFrom'?: boolean;
  'totalAmount.includeTo'?: boolean;
  /** @minItems 1 */
  ownerIds?: string[];
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /**
   * @minLength 1
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  reference?: string;
}

export interface GetOwnerContributionParams {
  /** @format int64 */
  ownerContributionId: string;
}

export interface UpdateOwnerContributionParams {
  /** @format int64 */
  ownerContributionId: string;
}

export interface DeleteOwnerContributionParams {
  /** @format int64 */
  ownerContributionId: string;
}

export interface RequestOwnerContributionFileUploadSessionParams {
  /** @format int64 */
  ownerContributionId: string;
}

export interface AddOwnerContributionFilesParams {
  /** @format int64 */
  ownerContributionId: string;
}

export interface UpdateOwnerContributionFilesParams {
  /** @format int64 */
  ownerContributionId: string;
}

export interface RemoveOwnerContributionFilesParams {
  /** @format int64 */
  ownerContributionId: string;
}

export interface GetOwnerContributionRequestsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @minItems 1 */
  propertyIds?: string[];
  /** @format double */
  'amount.from'?: number;
  /** @format double */
  'amount.to'?: number;
  'amount.includeFrom'?: boolean;
  'amount.includeTo'?: boolean;
  /** @format date-time */
  'requestDate.start'?: string;
  /** @format date-time */
  'requestDate.end'?: string;
  /** @format date-time */
  'dueDate.start'?: string;
  /** @format date-time */
  'dueDate.end'?: string;
  statuses?: OwnerContributionRequestStatus[];
}

export interface CancelOwnerContributionRequestParams {
  /** @format int64 */
  ownerContributionRequestId: string;
}

export interface GetOwnerDistributionsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format date-time */
  'distributionDate.start'?: string;
  /** @format date-time */
  'distributionDate.end'?: string;
  /** @format double */
  'totalAmount.from'?: number;
  /** @format double */
  'totalAmount.to'?: number;
  'totalAmount.includeFrom'?: boolean;
  'totalAmount.includeTo'?: boolean;
  /** @minItems 1 */
  ownerIds?: string[];
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /**
   * @minLength 1
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  reference?: string;
}

export interface GetOwnerDistributionParams {
  /** @format int64 */
  ownerDistributionId: string;
}

export interface UpdateOwnerDistributionParams {
  /** @format int64 */
  ownerDistributionId: string;
}

export interface DeleteOwnerDistributionParams {
  /** @format int64 */
  ownerDistributionId: string;
}

export interface RequestOwnerDistributionFileUploadSessionParams {
  /** @format int64 */
  ownerDistributionId: string;
}

export interface AddOwnerDistributionFilesParams {
  /** @format int64 */
  ownerDistributionId: string;
}

export interface UpdateOwnerDistributionFilesParams {
  /** @format int64 */
  ownerDistributionId: string;
}

export interface RemoveOwnerDistributionFilesParams {
  /** @format int64 */
  ownerDistributionId: string;
}

export interface DeleteCompanyPaymentAccountParams {
  paymentAccountId: string;
}

export interface GetAvailablePhoneNumbersParams {
  /**
   * @minLength 1
   * @maxLength 7
   * @pattern ^\d{1,7}$
   */
  startsWith?: string;
}

export interface GetPolicyHandbooksParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  level?: string;
  levelId?: string;
  enabled?: boolean;
}

export interface GetPolicyHandbookParams {
  policyHandbookId: string;
}

export interface UpdatePolicyHandbookParams {
  policyHandbookId: string;
}

export interface DeletePolicyHandbookParams {
  policyHandbookId: string;
}

export interface ReindexPolicyHandbookParams {
  policyHandbookId: string;
}

export interface GetPortfoliosParams {
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name?: string;
  search?: string;
}

export interface GetBatchPortfoliosParams {
  portfolioIds?: string[];
}

export interface GetPortfolioParams {
  portfolioId: string;
}

export interface UpdatePortfolioParams {
  portfolioId: string;
}

export interface DeletePortfolioParams {
  portfolioId: string;
}

export interface GetPortfolioOverviewParams {
  /** @format int64 */
  portfolioId: string;
}

export interface DeactivateLeaseParams {
  /** @default false */
  forceDeactivateChildren?: boolean;
  portfolioId: string;
}

export interface GetCustomFieldValues3Params {
  /** @format int64 */
  portfolioId: string;
}

export interface RequestCustomFieldUploadSession3Params {
  /** @format int64 */
  portfolioId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface SetCustomFieldValue3Params {
  /** @format int64 */
  portfolioId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface RemoveCustomFieldValue3Params {
  /** @format int64 */
  portfolioId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface GetPropertiesParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name?: string;
  type?: PropertyType;
  portfolioId?: string;
  ownerId?: string;
  search?: string;
}

export interface GetBatchPropertiesParams {
  propertyIds?: string[];
}

export interface GetPropertyParams {
  /** @format int64 */
  propertyId: string;
}

export interface UpdatePropertyParams {
  /** @format int64 */
  propertyId: string;
}

export interface DeletePropertyParams {
  /** @format int64 */
  propertyId: string;
}

export interface GetPropertyOverviewParams {
  /** @format int64 */
  propertyId: string;
}

export interface GetPropertyBalanceParams {
  /** @format int64 */
  propertyId: string;
}

export interface MovePropertyParams {
  /** @format int64 */
  propertyId: string;
}

export interface DeactivateLease2Params {
  /** @default false */
  forceDeactivateChildren?: boolean;
  /** @format int64 */
  propertyId: string;
}

export interface UpdateMagicTagsParams {
  /** @format int64 */
  propertyId: string;
}

export interface GetCustomFieldValues4Params {
  /** @format int64 */
  propertyId: string;
}

export interface RequestCustomFieldUploadSession4Params {
  /** @format int64 */
  propertyId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface SetCustomFieldValue4Params {
  /** @format int64 */
  propertyId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface RemoveCustomFieldValue4Params {
  /** @format int64 */
  propertyId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface RequestPropertyImageUploadSessionParams {
  /** @format int64 */
  propertyId: string;
}

export interface UpdatePropertyImageParams {
  /** @format int64 */
  propertyId: string;
}

export interface GetPropertyDefaultImageParams {
  /** @format int64 */
  propertyId: string;
}

export interface GetPropertyDefaultThumbImageParams {
  /** @format int64 */
  propertyId: string;
}

export interface GetPropertyChargesParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  portfolioId?: string;
  /** @format int64 */
  propertyId: string;
  unitId?: string;
  leaseId?: string;
  chartOfAccountId?: string;
  /** @format date */
  'chargeDate.start'?: string;
  /** @format date */
  'chargeDate.end'?: string;
  /** @format double */
  'amount.from'?: number;
  /** @format double */
  'amount.to'?: number;
  'amount.includeFrom'?: boolean;
  'amount.includeTo'?: boolean;
}

export interface AddPropertyChargeParams {
  /** @format int64 */
  propertyId: string;
}

export interface GetPropertyCharges2Params {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  portfolioId?: string;
  /** @format int64 */
  propertyId: string;
  unitId?: string;
  leaseId?: string;
  chartOfAccountId?: string;
  /** @format date */
  'chargeDate.start'?: string;
  /** @format date */
  'chargeDate.end'?: string;
  /** @format double */
  'amount.from'?: number;
  /** @format double */
  'amount.to'?: number;
  'amount.includeFrom'?: boolean;
  'amount.includeTo'?: boolean;
}

export interface AddPropertyCharge2Params {
  /** @format int64 */
  propertyId: string;
}

export interface GetPropertyChargeParams {
  /** @format int64 */
  propertyChargeId: string;
  propertyId: string;
}

export interface AdjustPropertyChargeParams {
  /** @format int64 */
  propertyChargeId: string;
  propertyId: string;
}

export interface DeletePropertyChargeParams {
  /** @format int64 */
  propertyChargeId: string;
  propertyId: string;
}

export interface GetPropertyCharge2Params {
  /** @format int64 */
  propertyChargeId: string;
  propertyId: string;
}

export interface AdjustPropertyCharge2Params {
  /** @format int64 */
  propertyChargeId: string;
  propertyId: string;
}

export interface DeletePropertyCharge2Params {
  /** @format int64 */
  propertyChargeId: string;
  propertyId: string;
}

export interface AddOwnerPropertyParams {
  propertyId: string;
  ownerId: string;
}

export interface UpdateOwnerPropertyParams {
  propertyId: string;
  ownerId: string;
}

export interface RemoveOwnerPropertyParams {
  propertyId: string;
  ownerId: string;
}

export interface UpdatePropertyManager2Params {
  /** @format int64 */
  propertyManagerId: string;
}

export interface DeletePropertyManagerParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface GetPropertyManagerParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface UpdatePropertyManagerPassword2Params {
  /** @format int64 */
  propertyManagerId: string;
}

export interface UpdatePropertyManagerActiveParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface GetCustomFieldValues5Params {
  /** @format int64 */
  propertyManagerId: string;
}

export interface RequestCustomFieldUploadSession5Params {
  /** @format int64 */
  propertyManagerId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface SetCustomFieldValue5Params {
  /** @format int64 */
  propertyManagerId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface RemoveCustomFieldValue5Params {
  /** @format int64 */
  propertyManagerId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface GetNotificationSettingsParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface SetNotificationSettingParams {
  /** @format int64 */
  propertyManagerId: string;
  notificationType: string;
}

export interface GetPropertyManagerPermissionsParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface AddPropertyManagerPermissionParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface RemovePropertyManagerPermissionParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface GetPropertyManagerMenuAccessParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface UpdatePropertyManagerMenuAccessParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface GetPropertyManagerPropertyAccessParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface AddPropertyManagerPropertyAccessParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface RemovePropertyManagerPropertyAccessParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface RequestPropertyManagerImageUploadSessionParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface UploadPropertyManagerProfileImageParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface DeletePropertyManagerProfileImageParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface GetPropertyManagerProfileImageParams {
  /** @format int64 */
  propertyManagerId: string;
}

export interface GetClientVersionInfosParams {
  platform: Platform;
}

export interface GetClientVersionInfoParams {
  platform: Platform;
  version: string;
}

export interface LogoutNotificationDeviceParams {
  deviceToken: string;
}

export interface GetCashFlowReportParams {
  /** @format date */
  'dateRange.start'?: string;
  /** @format date */
  'dateRange.end'?: string;
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  ownerIds?: string[];
  groupBy?: CashFlowGroupBy;
  companyBills?: boolean;
  /** @default "cash" */
  accountingBasis?: AccountingBasis;
}

export interface GetGeneralLedgerReportParams {
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  ownerIds?: string[];
  /** @format date */
  'dateRange.start'?: string;
  /** @format date */
  'dateRange.end'?: string;
  includeChartOfAccountIds?: string[];
  companyBills?: boolean;
  /** @default true */
  includeSubsidies?: boolean;
}

export interface GetBalanceSheetReportParams {
  /** @format date */
  reportAsOff?: string;
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  ownerIds?: string[];
  companyBills?: boolean;
  /** @default "cash" */
  accountingBasis?: AccountingBasis;
}

export interface GetIncomeStatementReportParams {
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  ownerIds?: string[];
  /** @format date */
  'dateRange.start'?: string;
  /** @format date */
  'dateRange.end'?: string;
  companyBills?: boolean;
  /** @default true */
  includeSubsidies?: boolean;
  /** @default "cash" */
  accountingBasis?: AccountingBasis;
}

export interface GetOwnerStatementReportParams {
  /** @minItems 1 */
  propertyIds?: string[];
  /** @format date */
  'dateRange.start'?: string;
  /** @format date */
  'dateRange.end'?: string;
  /** @default true */
  includeAllUnpaidBills?: boolean;
  /** @default true */
  includeSubsidies?: boolean;
  /** @format int64 */
  ownerId: string;
}

export interface GetInventoryReportParams {
  showInactive?: boolean;
}

export interface GetPropertyDirectoryReportParams {
  active?: boolean;
}

export interface GetAccountsPayableReportParams {
  /** @format date */
  asOfDate?: string;
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  vendorIds?: string[];
  /** @default "total" */
  groupBy?: AccountsPayableGroupBy;
  companyBills?: boolean;
  boundariesDays?: number[];
  /** @default true */
  includeOverdue?: boolean;
}

export interface GetTenantDirectoryReportParams {
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  ownerIds?: string[];
  includeNoActiveLease?: boolean;
}

export interface GetRentRollReportParams {
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  ownerIds?: string[];
  includeEmptyUnits?: boolean;
  includeEmptyProperties?: boolean;
  includeDeactivatedUnits?: boolean;
}

export interface GetDelinquencyReportParams {
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  ownerIds?: string[];
  /** @format double */
  minimumDue?: number;
  includeEmptyProperties?: boolean;
  includeDeactivated?: boolean;
  status?: DelinquentLeaseStatus;
}

export interface GetPropertyReserveReportParams {
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  ownerIds?: string[];
}

export interface GetBankAccountActivityReportParams {
  /** @format date */
  'dateRange.start'?: string;
  /** @format date */
  'dateRange.end'?: string;
  /** @format int64 */
  bankAccountId: string;
}

export interface GetBankAccountActivityReport2Params {
  leaseId?: string;
}

export interface GetLeaseMagicTagsReportParams {
  propertyId?: string;
  portfolioId?: string;
  /** @format date-time */
  'leaseStart.start'?: string;
  /** @format date-time */
  'leaseStart.end'?: string;
  /** @format date-time */
  'leaseEnd.start'?: string;
  /** @format date-time */
  'leaseEnd.end'?: string;
  monthToMonth?: boolean;
  eviction?: boolean;
  ended?: boolean;
  draft?: boolean;
  tenantIds?: string[];
  leaseIds?: string[];
  portfolioIds?: string[];
  propertyIds?: string[];
  unitIds?: string[];
  /** @format double */
  'balance.from'?: number;
  /** @format double */
  'balance.to'?: number;
  'balance.includeFrom'?: boolean;
  'balance.includeTo'?: boolean;
  /** @format double */
  'postedBalance.from'?: number;
  /** @format double */
  'postedBalance.to'?: number;
  'postedBalance.includeFrom'?: boolean;
  'postedBalance.includeTo'?: boolean;
  search?: string;
  /** @format date-time */
  'moveOutDate.start'?: string;
  /** @format date-time */
  'moveOutDate.end'?: string;
  /** @format date-time */
  'created.start'?: string;
  /** @format date-time */
  'created.end'?: string;
  'magicTags.equalString'?: Record<string, string>;
  'magicTags.containsString'?: Record<string, string>;
  'magicTags.date'?: Record<string, DateOnlyRangeDto>;
  'magicTags.number'?: Record<string, IntRangeDto>;
  'magicTags.equalsBool'?: Record<string, boolean>;
  displayCustomFieldIds?: string[];
}

export interface GetPrepaidRentReportParams {
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  ownerIds?: string[];
  includeEndedLeases?: boolean;
}

export interface GetLateFeesReportParams {
  /** @format date */
  'dateRange.start'?: string;
  /** @format date */
  'dateRange.end'?: string;
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  ownerIds?: string[];
  includePaid?: boolean;
  includeManualCharges?: boolean;
}

export interface GetServiceBillsPaginatedParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  unitIds?: string[];
  /** @minItems 1 */
  leaseIds?: string[];
  /** @minItems 1 */
  companyChartOfAccountIds?: string[];
  /** @minItems 1 */
  propertyChartOfAccountIds?: string[];
  /** @format date-time */
  'chargeDate.start'?: string;
  /** @format date-time */
  'chargeDate.end'?: string;
  /** @format double */
  'totalAmount.from'?: number;
  /** @format double */
  'totalAmount.to'?: number;
  'totalAmount.includeFrom'?: boolean;
  'totalAmount.includeTo'?: boolean;
}

export interface GetServiceBillParams {
  /** @format int64 */
  serviceBillId: string;
}

export interface AdjustServiceBillParams {
  /** @format int64 */
  serviceBillId: string;
}

export interface DeleteServiceBillParams {
  /** @format int64 */
  serviceBillId: string;
}

export interface GetKeysParams {
  templateType?: LeaseTemplateType;
}

export interface GetSigningDocumentTemplatesParams {
  categoryId?: string;
}

export interface GetSigningDocumentTemplateParams {
  /** @format int64 */
  signingDocumentTemplateId: string;
}

export interface DeleteSigningDocumentTemplateParams {
  /** @format int64 */
  signingDocumentTemplateId: string;
}

export interface ReplaceSigningDocumentTemplateFileParams {
  /** @format int64 */
  signingDocumentTemplateId: string;
}

export interface GetSubsidizersParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  type?: SubsidizerType;
  /** @default true */
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  search?: string;
}

export interface GetBatchSubsidizersParams {
  subsidizerIds?: string[];
}

export interface GetSubsidizerParams {
  /** @format int64 */
  subsidizerId: string;
}

export interface UpdateSubsidizerParams {
  /** @format int64 */
  subsidizerId: string;
}

export interface DeleteSubsidizerParams {
  /** @format int64 */
  subsidizerId: string;
}

export interface DeactivateSubsidizerParams {
  /** @format int64 */
  subsidizerId: string;
}

export interface ReactivateSubsidizerParams {
  /** @format int64 */
  subsidizerId: string;
}

export interface GetTaxTypeParams {
  accountType: TaxDocumentAccountType;
}

export interface GetUserTaxDocumentYearsParams {
  accountType: TaxDocumentAccountType;
  accountId: string;
}

export interface GetTaxDocumentYearsParams {
  accountType: TaxDocumentAccountType;
}

export interface GetTenantPaymentAccountsParams {
  tenantId: string;
}

export interface AddTenantPaymentAccountParams {
  tenantId: string;
}

export interface DeleteTenantPaymentAccountParams {
  tenantId: string;
  paymentAccountId: string;
}

export interface GetTenantsPaginatedParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstOrLastName?: string;
  phone?: string;
  email?: string;
  portalStatus?: PortalStatus;
  active?: boolean;
  hasLease?: boolean;
  hasFullName?: boolean;
  search?: string;
}

export interface GetBatchTenantsParams {
  tenantIds?: string[];
}

export interface GetTenantParams {
  /** @format int64 */
  tenantId: string;
}

export interface UpdateTenantParams {
  /** @format int64 */
  tenantId: string;
}

export interface UpdateTenantPasswordParams {
  /** @format int64 */
  tenantId: string;
}

export interface DeactivateTenantParams {
  forceMoveOutFromLeases?: boolean;
  /** @format int64 */
  tenantId: string;
}

export interface ReactivateTenantParams {
  /** @format int64 */
  tenantId: string;
}

export interface GetTenantTransactionsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format int64 */
  tenantId: string;
}

export interface GetTenantAutoPaymentsParams {
  /** @format int64 */
  tenantId: string;
}

export interface SendPortalInvite2Params {
  /** @format int64 */
  tenantId: string;
}

export interface LeasesParams {
  /** @format int64 */
  tenantId: string;
}

export interface GetCustomFieldValues6Params {
  /** @format int64 */
  tenantId: string;
}

export interface RequestCustomFieldUploadSession6Params {
  /** @format int64 */
  tenantId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface SetCustomFieldValue6Params {
  /** @format int64 */
  tenantId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface RemoveCustomFieldValue6Params {
  /** @format int64 */
  tenantId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface GetUnitListingsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  portfolioId?: string;
  propertyId?: string;
  listed?: boolean;
  pinned?: boolean;
  /** @format date */
  availableFrom?: string;
  /** @format double */
  minRentalPrice?: number;
  /** @format double */
  maxRentalPrice?: number;
  /** @format double */
  minBeds?: number;
  /** @format double */
  minBaths?: number;
  propertyTypes?: PropertyType[];
  search?: string;
}

export interface GetUnitListingParams {
  /** @format int64 */
  unitId: string;
}

export interface UpdateUnitListingParams {
  /** @format int64 */
  unitId: string;
}

export interface GenerateAiUnitMasterListingParams {
  /** @format int64 */
  unitId: string;
}

export interface DeactivateUnitParams {
  /** @format int64 */
  unitId: string;
}

export interface GetUnitListingSyndicationStatusParams {
  /** @format int64 */
  unitId: string;
}

export interface ValidateUnitListingSyndicationParams {
  /** @format int64 */
  unitId: string;
}

export interface SendApplicationInviteParams {
  /** @format int64 */
  unitId: string;
}

export interface GetCustomFieldValues7Params {
  /** @format int64 */
  unitId: string;
}

export interface RequestCustomFieldUploadSession7Params {
  /** @format int64 */
  unitId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface SetCustomFieldValue7Params {
  /** @format int64 */
  unitId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface RemoveCustomFieldValue7Params {
  /** @format int64 */
  unitId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface RequestUnitListingImageUploadSessionParams {
  /** @format int64 */
  unitId: string;
}

export interface AddUnitListingImagesParams {
  /** @format int64 */
  unitId: string;
}

export interface UpdateUnitListingImagesParams {
  /** @format int64 */
  unitId: string;
}

export interface RemoveUnitListingImageParams {
  /** @format int64 */
  unitId: string;
  /** @format int64 */
  imageId: string;
}

export interface RequestUnitListingVideoUploadSessionParams {
  /** @format int64 */
  unitId: string;
}

export interface AddUnitListingVideosParams {
  /** @format int64 */
  unitId: string;
}

export interface UpdateUnitListingVideosParams {
  /** @format int64 */
  unitId: string;
}

export interface RemoveUnitListingVideoParams {
  /** @format int64 */
  unitId: string;
  /** @format int64 */
  imageId: string;
}

export interface GetUnitsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name?: string;
  propertyId?: string;
  portfolioId?: string;
  /** @minLength 1 */
  nameLike?: string;
  search?: string;
}

export interface GetBatchUnitsParams {
  unitIds?: string[];
}

export interface GetUnitParams {
  /** @format int64 */
  unitId: string;
}

export interface UpdateUnitParams {
  /** @format int64 */
  unitId: string;
}

export interface DeleteUnitParams {
  /** @format int64 */
  unitId: string;
}

export interface MoveUnitParams {
  /** @format int64 */
  unitId: string;
}

export interface DeactivateUnit2Params {
  forceEndLease?: boolean;
  /** @format int64 */
  unitId: string;
}

export interface GetUnitTransactionsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format int64 */
  unitId: string;
}

export interface UpdateMagicTags2Params {
  /** @format int64 */
  unitId: string;
}

export interface GetCustomFieldValues8Params {
  /** @format int64 */
  unitId: string;
}

export interface RequestCustomFieldUploadSession8Params {
  /** @format int64 */
  unitId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface SetCustomFieldValue8Params {
  /** @format int64 */
  unitId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface RemoveCustomFieldValue8Params {
  /** @format int64 */
  unitId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface RequestUnitImageUploadSessionParams {
  /** @format int64 */
  unitId: string;
}

export interface UpdateUnitImageParams {
  /** @format int64 */
  unitId: string;
}

export interface GetUnitDefaultImageParams {
  /** @format int64 */
  unitId: string;
}

export interface GetUnitDefaultThumbImageParams {
  /** @format int64 */
  unitId: string;
}

export interface GetVendorBillsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  companyBill?: boolean;
  /** @minItems 1 */
  vendorIds?: string[];
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  unitIds?: string[];
  /** @minItems 1 */
  leaseIds?: string[];
  /** @minItems 1 */
  statuses?: VendorBillStatus[];
  /** @minItems 1 */
  assignedToIds?: string[];
  /** @minItems 1 */
  assignedByIds?: string[];
  /** @format date-time */
  'assignedAt.start'?: string;
  /** @format date-time */
  'assignedAt.end'?: string;
  /** @format date-time */
  'dueDate.start'?: string;
  /** @format date-time */
  'dueDate.end'?: string;
  /** @format date-time */
  'billDate.start'?: string;
  /** @format date-time */
  'billDate.end'?: string;
  /** @format double */
  'totalAmount.from'?: number;
  /** @format double */
  'totalAmount.to'?: number;
  'totalAmount.includeFrom'?: boolean;
  'totalAmount.includeTo'?: boolean;
  /** @format double */
  'dueAmount.from'?: number;
  /** @format double */
  'dueAmount.to'?: number;
  'dueAmount.includeFrom'?: boolean;
  'dueAmount.includeTo'?: boolean;
}

export interface ParseVendorBillFromFileIdParams {
  language?: string;
  fileId: string;
}

export interface GetVendorBillParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface UpdateVendorBillParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface DeleteVendorBillParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface SetVendorBillSourceParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface DeleteVendorBillPaymentParams {
  /** @format int64 */
  vendorBillId: string;
  /** @format int64 */
  transactionId: string;
}

export interface RequestVendorBillFileUploadSessionParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface AddVendorBillFilesParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface UpdateVendorBillFilesParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface DeleteVendorBillFilesParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface GetVendorBillsToPayParams {
  billIds?: string[];
  propertyIds?: string[];
  vendorIds?: string[];
  /** @format date */
  'dueDate.start'?: string;
  /** @format date */
  'dueDate.end'?: string;
  companyBill?: boolean;
}

export interface GetVendorBillsToSettleParams {
  billIds?: string[];
  propertyIds?: string[];
  vendorIds?: string[];
  /** @format date */
  'dueDate.start'?: string;
  /** @format date */
  'dueDate.end'?: string;
  companyBill?: boolean;
}

export interface GetCustomFieldValues9Params {
  /** @format int64 */
  vendorId: string;
}

export interface RequestCustomFieldUploadSession9Params {
  /** @format int64 */
  vendorId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface SetCustomFieldValue9Params {
  /** @format int64 */
  vendorId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface RemoveCustomFieldValue9Params {
  /** @format int64 */
  vendorId: string;
  /** @format int64 */
  customFieldId: string;
}

export interface GetVendorPaymentAccountsParams {
  vendorId: string;
}

export interface AddVendorPaymentAccountParams {
  vendorId: string;
}

export interface DeleteVendorPaymentAccountParams {
  vendorId: string;
  paymentAccountId: string;
}

export interface GetRecurringVendorBillsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  propertyIds?: string[];
  unitIds?: string[];
  leaseIds?: string[];
  vendorIds?: string[];
  chargeFrequencies?: ChargeFrequency[];
  companyCharge?: boolean;
  /** @format date-time */
  'nextChargeDate.start'?: string;
  /** @format date-time */
  'nextChargeDate.end'?: string;
  /** @format date */
  endsAfter?: string;
}

export interface UpdateRecurringVendorBillParams {
  /** @format int64 */
  recurringVendorBillId: string;
}

export interface DeleteRecurringVendorBillParams {
  /** @format int64 */
  recurringVendorBillId: string;
}

export interface UpdateTaxDocument2Params {
  vendorId: string;
  taxType: TaxType;
  /** @format int32 */
  calendarYear: number;
}

export interface BatchCreateTaxDocument2Params {
  taxType: TaxType;
  /** @format int32 */
  calendarYear: number;
}

export interface GetTaxDocuments2Params {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format int32 */
  calendarYear?: number;
  taxType?: TaxType;
  vendorId: string;
}

export interface GetAllTaxDocuments2Params {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format int32 */
  calendarYear?: number;
  taxType?: TaxType;
}

export interface GetTaxAmount2Params {
  vendorId: string;
  /** @format int32 */
  calendarYear: number;
}

export interface GetTaxAmounts2Params {
  vendorIds?: string[];
  /** @format int32 */
  calendarYear: number;
}
